/*
 * AUTO-GENERATED by scripts/generate-chapter.ts.
 * Source: LearningHub / beginner-level4
 * Do not edit by hand — regenerate from extracted JSON + translations.
 */
import type { Chapter, Level } from "../types";

export const CHAPTER_ID = "beginner-level4";

export const CHAPTER: Chapter = {
    id: "beginner-level4",
    title: { zh: "王者", en: "King" },
    description: {
        zh: "高阶战术与全局策略进阶",
        en: "Advanced tactics and whole-board strategy",
    },
};

const bl4Opening1Levels: Level[] = [
    {
        id: "beginner-level4-bl4-opening-1-1",
        chapterId: "beginner-level4",
        order: 1,
        title: { zh: "布局 · 1/9", en: "Opening · 1/9" },
        instruction: { zh: "角部占据后，你可以在边上下棋。选择有足够空间建立根据地的边。选择空间最大的边。最好在两个都被对手占据的角之间的边上落子。在这样的边上落子，可以分割对手的棋子。在第三线上落子进行分割。如果你在边上下一颗棋子，对手可能会攻击这颗棋子。你将从一边受到攻击。在这种情况下，你会想在另一边建立根据地来防守。为了确保这一点，确保你的第一颗棋子可以向两边延伸。当对手从一边攻击你时，你可以向另一边延伸。黑先。选择A、B或C中最佳的分割着法。", en: "After the corners are occupied, you can play at the sides. Play at a side that has sufficient space to make a base. Choose the side with the most space. Play preferably at a side between two corners that are both occupied by your opponent. By playing at such a side, you can divide your opponent´s stones. Divide by playing on the third line. If you play a stone at a side, your opponent might attack this stone. You will be attacked from one of both sides. In that case, you would like to defend by making a base at the other side. To ensure this, make certain you can extend you first stone to both sides. When your opponent attacks you from one side, you can extend to the other side. Black to play. Choose the best move to divide, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "codqoqqp" },
            marks: { A: "hq", B: "jq", C: "lq" },
            correct: ["jqhqmq"],
            wrong: ["hqjq", "lqjq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-1-2",
        chapterId: "beginner-level4",
        order: 2,
        title: { zh: "布局 · 2/9", en: "Opening · 2/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的分割着法。", en: "Black to play. Choose the best move to divide, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "dppqqo" },
            marks: { A: "gq", B: "jq", C: "mq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-1-3",
        chapterId: "beginner-level4",
        order: 3,
        title: { zh: "布局 · 3/9", en: "Opening · 3/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的分割着法。", en: "Black to play. Choose the best move to divide, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "ppnqdqcn" },
            marks: { A: "hq", B: "iq", C: "jq" },
            correct: ["iq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-1-4",
        chapterId: "beginner-level4",
        order: 4,
        title: { zh: "布局 · 4/9", en: "Opening · 4/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的分割着法。", en: "Black to play. Choose the best move to divide, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "qpopdodq" },
            marks: { A: "jp", B: "jq", C: "lq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-1-5",
        chapterId: "beginner-level4",
        order: 5,
        title: { zh: "布局 · 5/9", en: "Opening · 5/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的分割着法。", en: "Black to play. Choose the best move to divide, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "codqpqqo" },
            marks: { A: "iq", B: "jq", C: "kq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-1-6",
        chapterId: "beginner-level4",
        order: 6,
        title: { zh: "布局 · 6/9", en: "Opening · 6/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的分割着法。", en: "Black to play. Choose the best move to divide, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "cpeqppoqqn" },
            marks: { A: "hq", B: "jq", C: "lq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-1-7",
        chapterId: "beginner-level4",
        order: 7,
        title: { zh: "布局 · 7/9", en: "Opening · 7/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的分割着法。", en: "Black to play. Choose the best move to divide, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "ppcpep" },
            marks: { A: "jp", B: "kp", C: "jq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-1-8",
        chapterId: "beginner-level4",
        order: 8,
        title: { zh: "布局 · 8/9", en: "Opening · 8/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的分割着法。", en: "Black to play. Choose the best move to divide, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocndmcj", white: "pqqofqdpcpdnen" },
            marks: { A: "jq", B: "kq", C: "lq" },
            correct: ["kq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-1-9",
        chapterId: "beginner-level4",
        order: 9,
        title: { zh: "布局 · 9/9", en: "Opening · 9/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的分割着法。", en: "Black to play. Choose the best move to divide, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocndmcl", white: "cpdpfpdnenppqn" },
            marks: { A: "kp", B: "kq", C: "lq" },
            correct: ["kq"],
        },
    },
];

const bl4Opening2Levels: Level[] = [
    {
        id: "beginner-level4-bl4-opening-2-1",
        chapterId: "beginner-level4",
        order: 10,
        title: { zh: "布局 · 1/9", en: "Opening · 1/9" },
        instruction: { zh: "对于分割棋子，你可以选择攻击它。从对手最容易延伸的一边攻击。如果你在分割棋子的一边第三线上有一颗棋子，另一边第四线上有一颗棋子，就从第四线的棋子攻击。这保护了开放的一边。如果你在一边有一个强大的棋块，例如因为你在那边下了一个角部包围，而另一个角较弱，就从弱角那边下。这使你的弱棋块变强。黑先。选择A或B中最佳的攻击方向。", en: "In response to a dividing stone you can decide to attack it. Attack at the side where your opponent can extend the easiest. If you have a stone on the third line at one side of the dividing stone and a stone on the fourth line on the other side, attack from the stone on the fourth line. This defends the open side. If you have a strong group at one side, e.g. because you played a corner enclosure there, and is the other corner weaker, then play from the weak corner. This makes your weak group stronger. Black to play. Choose the best side to attack, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpoqqp", white: "jq" },
            marks: { A: "hq", B: "lq" },
            correct: ["hq"],
            wrong: ["lq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-2-2",
        chapterId: "beginner-level4",
        order: 11,
        title: { zh: "布局 · 2/9", en: "Opening · 2/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的攻击着法。", en: "Black to play. Choose the best move to attack, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qpoqepcp", white: "jq" },
            marks: { A: "gq", B: "hq", C: "lq" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-2-3",
        chapterId: "beginner-level4",
        order: 12,
        title: { zh: "布局 · 3/9", en: "Opening · 3/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的攻击着法。", en: "Black to play. Choose the best move to attack, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqcopqqo", white: "jq" },
            marks: { A: "hp", B: "gq", C: "hq" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-2-4",
        chapterId: "beginner-level4",
        order: 13,
        title: { zh: "布局 · 4/9", en: "Opening · 4/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的攻击着法。", en: "Black to play. Choose the best move to attack, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ppepcp", white: "jq" },
            marks: { A: "fq", B: "gq", C: "hq" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-2-5",
        chapterId: "beginner-level4",
        order: 14,
        title: { zh: "布局 · 5/9", en: "Opening · 5/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的攻击着法。", en: "Black to play. Choose the best move to attack, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qpoqdqco", white: "iq" },
            marks: { A: "kp", B: "kq", C: "lq" },
            correct: ["kq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-2-6",
        chapterId: "beginner-level4",
        order: 15,
        title: { zh: "布局 · 6/9", en: "Opening · 6/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的攻击着法。", en: "Black to play. Choose the best move to attack, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pqqodpfpco", white: "kq" },
            marks: { A: "ip", B: "iq", C: "mq" },
            correct: ["iq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-2-7",
        chapterId: "beginner-level4",
        order: 16,
        title: { zh: "布局 · 7/9", en: "Opening · 7/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的攻击着法。", en: "Black to play. Choose the best move to attack, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpfpqpoq", white: "jq" },
            marks: { A: "kp", B: "lq", C: "mq" },
            correct: ["lq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-2-8",
        chapterId: "beginner-level4",
        order: 17,
        title: { zh: "布局 · 8/9", en: "Opening · 8/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的攻击着法。", en: "Black to play. Choose the best move to attack, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ppdqco", white: "jq" },
            marks: { A: "fq", B: "gq", C: "hq" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-2-9",
        chapterId: "beginner-level4",
        order: 18,
        title: { zh: "布局 · 9/9", en: "Opening · 9/9" },
        instruction: { zh: "黑先。选择A、B或C中最佳的攻击着法。", en: "Black to play. Choose the best move to attack, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpeqqpoq", white: "jqcndkqnqk" },
            marks: { A: "jo", B: "lq", C: "mq" },
            correct: ["lq"],
        },
    },
];

const bl4Opening3Levels: Level[] = [
    {
        id: "beginner-level4-bl4-opening-3-1",
        chapterId: "beginner-level4",
        order: 19,
        title: { zh: "布局 · 1/10", en: "Opening · 1/10" },
        instruction: { zh: "通常你通过两点延伸建立根据地来扩展你的分割棋子。有时你可以延伸你的棋子并同时攻击一个角。那么，三点延伸可能更有效，就像这个例子所示。黑先。选择白棋2之后，延伸并攻击角部的最佳着法。", en: "Normally you extend your dividing stone by making a base with a 2-points extension. Sometimes you can extend your stone and at the same time attack a corner. Then, a 3-points extension might be more effective, like in this example. Black to play. Choose the best move to extend and attack the corner after White's 2." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jq", white: "dplqpp" },
            marks: { 1: "jq", 2: "lq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-3-2",
        chapterId: "beginner-level4",
        order: 20,
        title: { zh: "布局 · 2/10", en: "Opening · 2/10" },
        instruction: { zh: "如果没有足够的空间进行两点跳，就下一点跳，如这个例子所示。黑先。选择白棋2之后延伸的最佳着法。", en: "If there is not enough space for a 2-points jump, play a 1-point jump, as in this example. Black to play. Choose the best move to extend after White's 2." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "kq", white: "dpfqoqqpiq" },
            marks: { 1: "kq", 2: "iq" },
            correct: ["mq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-3-3",
        chapterId: "beginner-level4",
        order: 21,
        title: { zh: "布局 · 3/10", en: "Opening · 3/10" },
        instruction: { zh: "黑先。选择A、B或C中最佳的延伸着法。", en: "Black to play. Choose the best move to extend, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jq", white: "codqpqqohq" },
            marks: { A: "lq", B: "mq", C: "nq" },
            correct: ["mq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-3-4",
        chapterId: "beginner-level4",
        order: 22,
        title: { zh: "布局 · 4/10", en: "Opening · 4/10" },
        instruction: { zh: "黑先。选择A、B或C中最佳的延伸着法。", en: "Black to play. Choose the best move to extend, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jq", white: "dqcopplq" },
            marks: { A: "fq", B: "gq", C: "hq" },
            correct: ["gq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-3-5",
        chapterId: "beginner-level4",
        order: 23,
        title: { zh: "布局 · 5/10", en: "Opening · 5/10" },
        instruction: { zh: "黑先。选择A、B或C中最佳的延伸着法。", en: "Black to play. Choose the best move to extend, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jq", white: "dqcopphq" },
            marks: { A: "lq", B: "mq", C: "nq" },
            correct: ["nq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-3-6",
        chapterId: "beginner-level4",
        order: 24,
        title: { zh: "布局 · 6/10", en: "Opening · 6/10" },
        instruction: { zh: "黑先。选择A、B或C中最佳的延伸着法。", en: "Black to play. Choose the best move to extend, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jq", white: "cpeppqqohq" },
            marks: { A: "lq", B: "mq", C: "nq" },
            correct: ["mq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-3-7",
        chapterId: "beginner-level4",
        order: 25,
        title: { zh: "布局 · 7/10", en: "Opening · 7/10" },
        instruction: { zh: "黑先。选择A、B或C中最佳的延伸着法。", en: "Black to play. Choose the best move to extend, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jq", white: "cpeqhqppnp" },
            marks: { A: "lp", B: "lq", C: "mq" },
            correct: ["lq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-3-8",
        chapterId: "beginner-level4",
        order: 26,
        title: { zh: "布局 · 8/10", en: "Opening · 8/10" },
        instruction: { zh: "黑先。选择A、B或C中最佳的延伸着法。", en: "Black to play. Choose the best move to extend, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qnqkcndkjq", white: "cpeqoqqplq" },
            marks: { A: "jo", B: "gq", C: "hq" },
            correct: ["gq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-3-9",
        chapterId: "beginner-level4",
        order: 27,
        title: { zh: "布局 · 9/10", en: "Opening · 9/10" },
        instruction: { zh: "黑先。选择A、B或C中最佳的延伸着法。", en: "Black to play. Choose the best move to extend, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eqdpdnkq", white: "pqqoiqfqfp" },
            marks: { A: "ko", B: "mq", C: "nq" },
            correct: ["nq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-3-10",
        chapterId: "beginner-level4",
        order: 28,
        title: { zh: "布局 · 10/10", en: "Opening · 10/10" },
        instruction: { zh: "黑先。选择A、B或C中最佳的延伸着法。", en: "Black to play. Choose the best move to extend, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jq", white: "dpqpoplq" },
            marks: { A: "fq", B: "gq", C: "hq" },
            correct: ["fq"],
        },
    },
];

const bl4Opening4Levels: Level[] = [
    {
        id: "beginner-level4-bl4-opening-4-1",
        chapterId: "beginner-level4",
        order: 29,
        title: { zh: "布局 · 1/8", en: "Opening · 1/8" },
        instruction: { zh: "白先。选择A、B或C中最佳的防守着法。", en: "White to play. Choose the best defense, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "pppqqmcqdpdn", white: "nqkqdrfq" },
            marks: { A: "hp", B: "hq", C: "iq" },
            correct: ["hp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-4-2",
        chapterId: "beginner-level4",
        order: 30,
        title: { zh: "布局 · 2/8", en: "Opening · 2/8" },
        instruction: { zh: "白先。选择A、B或C中最佳的防守着法。", en: "White to play. Choose the best defense, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "qlolnqjpfpepfq", white: "ppqneqdqcpcncj" },
            marks: { A: "no", B: "qq", C: "pr" },
            correct: ["pr"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-4-3",
        chapterId: "beginner-level4",
        order: 31,
        title: { zh: "布局 · 3/8", en: "Opening · 3/8" },
        instruction: { zh: "白先。选择A、B或C中最佳的防守着法。", en: "White to play. Choose the best defense, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "oqqpeqcpcl", white: "mqkp" },
            marks: { A: "hp", B: "hq", C: "iq" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-4-4",
        chapterId: "beginner-level4",
        order: 32,
        title: { zh: "布局 · 4/8", en: "Opening · 4/8" },
        instruction: { zh: "白先。选择A、B或C中最佳的防守着法。", en: "White to play. Choose the best defense, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "qoppnq", white: "kqepcp" },
            marks: { A: "hp", B: "gq", C: "hq" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-4-5",
        chapterId: "beginner-level4",
        order: 33,
        title: { zh: "布局 · 5/8", en: "Opening · 5/8" },
        instruction: { zh: "白先。选择A、B或C中最佳的防守着法。", en: "White to play. Choose the best defense, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "jqmqcl", white: "dqcohqppqm" },
            marks: { A: "oq", B: "pq", C: "qq" },
            correct: ["oq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-4-6",
        chapterId: "beginner-level4",
        order: 34,
        title: { zh: "布局 · 6/8", en: "Opening · 6/8" },
        instruction: { zh: "白先。选择A、B或C中最佳的防守着法。", en: "White to play. Choose the best defense, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfqppqqpncl", white: "hqprnqno" },
            marks: { A: "kp", B: "lp", C: "kq" },
            correct: ["kp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-4-7",
        chapterId: "beginner-level4",
        order: 35,
        title: { zh: "布局 · 7/8", en: "Opening · 7/8" },
        instruction: { zh: "白先。选择A、B或C中最佳的防守着法。", en: "White to play. Choose the best defense, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "qoppnqkq", white: "epcp" },
            marks: { A: "hp", B: "gq", C: "hq" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-4-8",
        chapterId: "beginner-level4",
        order: 36,
        title: { zh: "布局 · 8/8", en: "Opening · 8/8" },
        instruction: { zh: "白先。选择A、B或C中最佳的防守着法。", en: "White to play. Choose the best defense, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "jqgqdrqk", white: "pqqolqdpcm" },
            marks: { A: "cp", B: "cq", C: "cr" },
            correct: ["cq"],
        },
    },
];

const bl4Opening5Levels: Level[] = [
    {
        id: "beginner-level4-bl4-opening-5-1",
        chapterId: "beginner-level4",
        order: 37,
        title: { zh: "布局 · 1/18", en: "Opening · 1/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "nq", white: "dpqppq" },
            marks: { A: "cn", B: "fq", C: "kq" },
            correct: ["kq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-2",
        chapterId: "beginner-level4",
        order: 38,
        title: { zh: "布局 · 2/18", en: "Opening · 2/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "iqqoqnpmqlnl", white: "npppqponpndqcocl" },
            marks: { A: "fq", B: "gq", C: "lq" },
            correct: ["lq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-3",
        chapterId: "beginner-level4",
        order: 39,
        title: { zh: "布局 · 3/18", en: "Opening · 3/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ppqngq", white: "lqeqcp" },
            marks: { A: "jq", B: "nq", C: "oq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-4",
        chapterId: "beginner-level4",
        order: 40,
        title: { zh: "布局 · 4/18", en: "Opening · 4/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fq", white: "cpdqhqpqqo" },
            marks: { A: "fo", B: "jq", C: "lq" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-5",
        chapterId: "beginner-level4",
        order: 41,
        title: { zh: "布局 · 5/18", en: "Opening · 5/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "opnpnqcpcocm", white: "oqpqqpqoeqdodn" },
            marks: { A: "om", B: "iq", C: "jq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-6",
        chapterId: "beginner-level4",
        order: 42,
        title: { zh: "布局 · 6/18", en: "Opening · 6/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "pqpo" },
            marks: { A: "hq", B: "jq", C: "lq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-7",
        chapterId: "beginner-level4",
        order: 43,
        title: { zh: "布局 · 7/18", en: "Opening · 7/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "nqfq", white: "dpdnpppn" },
            marks: { A: "ip", B: "jp", C: "kp" },
            correct: ["jp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-8",
        chapterId: "beginner-level4",
        order: 44,
        title: { zh: "布局 · 8/18", en: "Opening · 8/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqco", white: "pp" },
            marks: { A: "gq", B: "hq", C: "jq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-9",
        chapterId: "beginner-level4",
        order: 45,
        title: { zh: "布局 · 9/18", en: "Opening · 9/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "oqop", white: "pqqpqnlpdqdo" },
            marks: { A: "on", B: "hq", C: "mq" },
            correct: ["on"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-10",
        chapterId: "beginner-level4",
        order: 46,
        title: { zh: "布局 · 10/18", en: "Opening · 10/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ppqmhqdp", white: "jqmq" },
            marks: { A: "ho", B: "fp", C: "oq" },
            correct: ["oq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-11",
        chapterId: "beginner-level4",
        order: 47,
        title: { zh: "布局 · 11/18", en: "Opening · 11/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "oqlqdpeqdn", white: "qpqmfqfp" },
            marks: { A: "fn", B: "ip", C: "fr" },
            correct: ["ip"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-12",
        chapterId: "beginner-level4",
        order: 48,
        title: { zh: "布局 · 12/18", en: "Opening · 12/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dppnqppqoq", white: "nqnpop" },
            marks: { A: "nn", B: "kp", C: "nr" },
            correct: ["kp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-13",
        chapterId: "beginner-level4",
        order: 49,
        title: { zh: "布局 · 13/18", en: "Opening · 13/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ppeqdqcpcn", white: "epfqgp" },
            marks: { A: "jp", B: "lq", C: "nq" },
            correct: ["jp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-14",
        chapterId: "beginner-level4",
        order: 50,
        title: { zh: "布局 · 14/18", en: "Opening · 14/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fqpqpppopnpmnmnp", white: "dpcnqqqpqoqnqmpkoo" },
            marks: { A: "hp", B: "ip", C: "iq" },
            correct: ["ip"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-15",
        chapterId: "beginner-level4",
        order: 51,
        title: { zh: "布局 · 15/18", en: "Opening · 15/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qnqk", white: "cndpeqoqqp" },
            marks: { A: "iq", B: "jq", C: "kq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-16",
        chapterId: "beginner-level4",
        order: 52,
        title: { zh: "布局 · 16/18", en: "Opening · 16/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qpdpfpcpdnen", white: "oqcocndmcl" },
            marks: { A: "iq", B: "jq", C: "kq" },
            correct: ["kq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-17",
        chapterId: "beginner-level4",
        order: 53,
        title: { zh: "布局 · 17/18", en: "Opening · 17/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqcqcpcnpqqo", white: "dpeqfpjq" },
            marks: { A: "lp", B: "lq", C: "mq" },
            correct: ["lq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-5-18",
        chapterId: "beginner-level4",
        order: 54,
        title: { zh: "布局 · 18/18", en: "Opening · 18/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "iq", white: "ppnpdqco" },
            marks: { A: "fq", B: "lq", C: "mq" },
            correct: ["lq"],
        },
    },
];

const bl4Opening6Levels: Level[] = [
    {
        id: "beginner-level4-bl4-opening-6-1",
        chapterId: "beginner-level4",
        order: 55,
        title: { zh: "布局 · 1/18", en: "Opening · 1/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqepdp", white: "dqcqopqp" },
            marks: { A: "bo", B: "jq", C: "kq" },
            correct: ["bo"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-2",
        chapterId: "beginner-level4",
        order: 56,
        title: { zh: "布局 · 2/18", en: "Opening · 2/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "lqdqdo", white: "qqqofqgp" },
            marks: { A: "iq", B: "jq", C: "nq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-3",
        chapterId: "beginner-level4",
        order: 57,
        title: { zh: "布局 · 3/18", en: "Opening · 3/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpeppqqngq", white: "iqlq" },
            marks: { A: "io", B: "lo", C: "nq" },
            correct: ["nq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-4",
        chapterId: "beginner-level4",
        order: 58,
        title: { zh: "布局 · 4/18", en: "Opening · 4/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "pqpo", white: "dqco" },
            marks: { A: "hq", B: "jq", C: "lq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-5",
        chapterId: "beginner-level4",
        order: 59,
        title: { zh: "布局 · 5/18", en: "Opening · 5/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "pplqdqdo", white: "nq" },
            marks: { A: "no", B: "hq", C: "jq" },
            correct: ["no"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-6",
        chapterId: "beginner-level4",
        order: 60,
        title: { zh: "布局 · 6/18", en: "Opening · 6/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epfqgp", white: "ppeqdqcpcn" },
            marks: { A: "jp", B: "mq", C: "nq" },
            correct: ["jp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-7",
        chapterId: "beginner-level4",
        order: 61,
        title: { zh: "布局 · 7/18", en: "Opening · 7/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqcojq", white: "pqpo" },
            marks: { A: "gq", B: "hq", C: "lq" },
            correct: ["lq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-8",
        chapterId: "beginner-level4",
        order: 62,
        title: { zh: "布局 · 8/18", en: "Opening · 8/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqiq", white: "dqcpcmpqqo" },
            marks: { A: "fo", B: "kq", C: "mq" },
            correct: ["kq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-9",
        chapterId: "beginner-level4",
        order: 63,
        title: { zh: "布局 · 9/18", en: "Opening · 9/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqco", white: "pqqn" },
            marks: { A: "hq", B: "jq", C: "lq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-10",
        chapterId: "beginner-level4",
        order: 64,
        title: { zh: "布局 · 10/18", en: "Opening · 10/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "oqcpdqeq", white: "qpepfqgp" },
            marks: { A: "qm", B: "jq", C: "kq" },
            correct: ["kq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-11",
        chapterId: "beginner-level4",
        order: 65,
        title: { zh: "布局 · 11/18", en: "Opening · 11/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "rqqopmiq", white: "pqnpdqco" },
            marks: { A: "gq", B: "kq", C: "lq" },
            correct: ["kq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-12",
        chapterId: "beginner-level4",
        order: 66,
        title: { zh: "布局 · 12/18", en: "Opening · 12/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "qnrpqkdqdocl", white: "ppqqnp" },
            marks: { A: "hq", B: "jq", C: "lq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-13",
        chapterId: "beginner-level4",
        order: 67,
        title: { zh: "布局 · 13/18", en: "Opening · 13/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdpdniplpqppnqj", white: "drfqfonpoqqr" },
            marks: { A: "hq", B: "cr", C: "ir" },
            correct: ["ir"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-14",
        chapterId: "beginner-level4",
        order: 68,
        title: { zh: "布局 · 14/18", en: "Opening · 14/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "pqpo", white: "dp" },
            marks: { A: "hq", B: "jq", C: "lq" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-15",
        chapterId: "beginner-level4",
        order: 69,
        title: { zh: "布局 · 15/18", en: "Opening · 15/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "pqoqqpqndq", white: "opnqmpiqco" },
            marks: { A: "cl", B: "fq", C: "gq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-16",
        chapterId: "beginner-level4",
        order: 70,
        title: { zh: "布局 · 16/18", en: "Opening · 16/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "qqqpqnrndp", white: "pqpppoomql" },
            marks: { A: "jp", B: "kp", C: "kq" },
            correct: ["jp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-17",
        chapterId: "beginner-level4",
        order: 71,
        title: { zh: "布局 · 17/18", en: "Opening · 17/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "nqdp", white: "pqppqn" },
            marks: { A: "no", B: "lq", C: "or" },
            correct: ["lq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-6-18",
        chapterId: "beginner-level4",
        order: 72,
        title: { zh: "布局 · 18/18", en: "Opening · 18/18" },
        instruction: { zh: "白先。选择A、B或C中最佳的着法。", en: "White to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "nqnpopjp", white: "qnpqoqqpdqco" },
            marks: { A: "fq", B: "gq", C: "hq" },
            correct: ["hq"],
        },
    },
];

const bl4Opening7Levels: Level[] = [
    {
        id: "beginner-level4-bl4-opening-7-1",
        chapterId: "beginner-level4",
        order: 73,
        title: { zh: "布局 · 1/18", en: "Opening · 1/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pppd", white: "cpdd" },
            marks: { A: "jp", B: "ep", C: "jd" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-2",
        chapterId: "beginner-level4",
        order: 74,
        title: { zh: "布局 · 2/18", en: "Opening · 2/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdjdpqqk", white: "jqdpddqf" },
            marks: { A: "qh", B: "qe", C: "nd" },
            correct: ["qe"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-3",
        chapterId: "beginner-level4",
        order: 75,
        title: { zh: "布局 · 3/18", en: "Opening · 3/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdjdpjppfqhq", white: "dpfohojpdddj" },
            marks: { A: "dr", B: "cr", C: "dq" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-4",
        chapterId: "beginner-level4",
        order: 76,
        title: { zh: "布局 · 4/18", en: "Opening · 4/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dppqqpqopnonpd", white: "poqnqmqjjcdccf" },
            marks: { A: "qf", B: "cn", C: "jp" },
            correct: ["jp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-5",
        chapterId: "beginner-level4",
        order: 77,
        title: { zh: "布局 · 5/18", en: "Opening · 5/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jppppnpjpdmd", white: "dddfcjdphpjd" },
            marks: { A: "mp", B: "mo", C: "jn" },
            correct: ["jn"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-6",
        chapterId: "beginner-level4",
        order: 78,
        title: { zh: "布局 · 6/18", en: "Opening · 6/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqopqfq", white: "dpcnddjd" },
            marks: { A: "jp", B: "pj", C: "qf" },
            correct: ["jp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-7",
        chapterId: "beginner-level4",
        order: 79,
        title: { zh: "布局 · 7/18", en: "Opening · 7/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdpnqppqoqeqdodn", white: "opnpnqcpcocmdcjd" },
            marks: { A: "jq", B: "nc", C: "lc" },
            correct: ["jq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-8",
        chapterId: "beginner-level4",
        order: 80,
        title: { zh: "布局 · 8/18", en: "Opening · 8/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdpfqkpq", white: "ncjddddp" },
            marks: { A: "jp", B: "po", C: "cj" },
            correct: ["jp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-9",
        chapterId: "beginner-level4",
        order: 81,
        title: { zh: "布局 · 9/18", en: "Opening · 9/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqlqpoq", white: "qjjqdpdd" },
            marks: { A: "lq", B: "ol", C: "qh" },
            correct: ["qh"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-10",
        chapterId: "beginner-level4",
        order: 82,
        title: { zh: "布局 · 10/18", en: "Opening · 10/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdjdpplolqcqcpcnbn", white: "jpjnddgddqdpdoemcl" },
            marks: { A: "jr", B: "ir", C: "jq" },
            correct: ["jr"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-11",
        chapterId: "beginner-level4",
        order: 83,
        title: { zh: "布局 · 11/18", en: "Opening · 11/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdppcgcj", white: "dpddgccm" },
            marks: { A: "eg", B: "bd", C: "jd" },
            correct: ["bd"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-12",
        chapterId: "beginner-level4",
        order: 84,
        title: { zh: "布局 · 12/18", en: "Opening · 12/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdpjpplq", white: "nqqqdpdd" },
            marks: { A: "pq", B: "qp", C: "np" },
            correct: ["qp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-13",
        chapterId: "beginner-level4",
        order: 85,
        title: { zh: "布局 · 13/18", en: "Opening · 13/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdicfcdbppnq", white: "ccddcfdpgqqj" },
            marks: { A: "cl", B: "ck", C: "cj" },
            correct: ["ck"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-14",
        chapterId: "beginner-level4",
        order: 86,
        title: { zh: "布局 · 14/18", en: "Opening · 14/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqcooqpopnpmpd", white: "kqqpqoqnqlfccd" },
            marks: { A: "di", B: "gq", C: "iq" },
            correct: ["iq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-15",
        chapterId: "beginner-level4",
        order: 87,
        title: { zh: "布局 · 15/18", en: "Opening · 15/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qdocqjidcndndofp", white: "qlqpoqddcfdqcpco" },
            marks: { A: "oj", B: "ph", C: "pg" },
            correct: ["oj"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-16",
        chapterId: "beginner-level4",
        order: 88,
        title: { zh: "布局 · 16/18", en: "Opening · 16/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdppepfqgp", white: "eqdqcpcndd" },
            marks: { A: "kq", B: "pn", C: "qn" },
            correct: ["kq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-17",
        chapterId: "beginner-level4",
        order: 89,
        title: { zh: "布局 · 17/18", en: "Opening · 17/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "jdndpdqepjpnpp", white: "qfpfqinqjpdpdd" },
            marks: { A: "qj", B: "pi", C: "fc" },
            correct: ["qj"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-7-18",
        chapterId: "beginner-level4",
        order: 90,
        title: { zh: "布局 · 18/18", en: "Opening · 18/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqgqpoqckdbfcic", white: "qjqmdpgqcicfddcc" },
            marks: { A: "cn", B: "cm", C: "ek" },
            correct: ["cn"],
        },
    },
];

const bl4Opening8Levels: Level[] = [
    {
        id: "beginner-level4-bl4-opening-8-1",
        chapterId: "beginner-level4",
        order: 91,
        title: { zh: "布局 · 1/18", en: "Opening · 1/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ocqdqgqoqppqnq", white: "qioipoqnpmdpdc" },
            marks: { A: "fq", B: "og", C: "de" },
            correct: ["de"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-2",
        chapterId: "beginner-level4",
        order: 92,
        title: { zh: "布局 · 2/18", en: "Opening · 2/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqpoq", white: "qjdddp" },
            marks: { A: "ql", B: "oj", C: "jd" },
            correct: ["ql"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-3",
        chapterId: "beginner-level4",
        order: 93,
        title: { zh: "布局 · 3/18", en: "Opening · 3/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qcpdqfcocqhqppnq", white: "pbnckcddeqeohojp" },
            marks: { A: "jr", B: "kq", C: "jq" },
            correct: ["jr"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-4",
        chapterId: "beginner-level4",
        order: 94,
        title: { zh: "布局 · 4/18", en: "Opening · 4/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qdocqjppjpcccdde", white: "cpeqcibbcbdcfdjc" },
            marks: { A: "ck", B: "oj", C: "cg" },
            correct: ["cg"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-5",
        chapterId: "beginner-level4",
        order: 95,
        title: { zh: "布局 · 5/18", en: "Opening · 5/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdpjppfcfd", white: "idddeccfdp" },
            marks: { A: "ff", B: "hc", C: "eb" },
            correct: ["ff"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-6",
        chapterId: "beginner-level4",
        order: 96,
        title: { zh: "布局 · 6/18", en: "Opening · 6/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqcocfpcpdqepfpkqn", white: "ddfdkcocodoeppnqiq" },
            marks: { A: "di", B: "eo", C: "gq" },
            correct: ["di"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-7",
        chapterId: "beginner-level4",
        order: 97,
        title: { zh: "布局 · 7/18", en: "Opening · 7/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqppqqn", white: "oqopdpddjc" },
            marks: { A: "lp", B: "on", C: "pj" },
            correct: ["lp"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-8",
        chapterId: "beginner-level4",
        order: 98,
        title: { zh: "布局 · 8/18", en: "Opening · 8/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqpoq", white: "qfdpdd" },
            marks: { A: "qh", B: "qe", C: "jd" },
            correct: ["qh"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-9",
        chapterId: "beginner-level4",
        order: 99,
        title: { zh: "布局 · 9/18", en: "Opening · 9/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdncrdppiqfqdr", white: "qfdpcqcndiddfc" },
            marks: { A: "qh", B: "of", C: "jc" },
            correct: ["qh"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-10",
        chapterId: "beginner-level4",
        order: 100,
        title: { zh: "布局 · 10/18", en: "Opening · 10/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qpqopqnqqdocbdcfci", white: "poqnpmqijcddccfddp" },
            marks: { A: "fq", B: "jp", C: "qg" },
            correct: ["qg"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-11",
        chapterId: "beginner-level4",
        order: 101,
        title: { zh: "布局 · 11/18", en: "Opening · 11/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qdocplpqnpjq", white: "pnqorqdqcodc" },
            marks: { A: "gq", B: "pi", C: "ce" },
            correct: ["ce"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-12",
        chapterId: "beginner-level4",
        order: 102,
        title: { zh: "布局 · 12/18", en: "Opening · 12/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpepjpqipepc", white: "lppqqojcdcde" },
            marks: { A: "je", B: "cj", C: "ql" },
            correct: ["cj"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-13",
        chapterId: "beginner-level4",
        order: 103,
        title: { zh: "布局 · 13/18", en: "Opening · 13/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qcpdqfcjhqgqeqdqpo", white: "pbnckcddclcoepfpgp" },
            marks: { A: "ch", B: "cf", C: "fc" },
            correct: ["cf"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-14",
        chapterId: "beginner-level4",
        order: 104,
        title: { zh: "布局 · 14/18", en: "Opening · 14/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqhqlqpoq", white: "qfofqjdpdd" },
            marks: { A: "pi", B: "oh", C: "nd" },
            correct: ["nd"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-15",
        chapterId: "beginner-level4",
        order: 105,
        title: { zh: "布局 · 15/18", en: "Opening · 15/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qdocqjlqhpcpcmid", white: "pgqmppoqepenccfc" },
            marks: { A: "oj", B: "qh", C: "oe" },
            correct: ["oj"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-16",
        chapterId: "beginner-level4",
        order: 106,
        title: { zh: "布局 · 16/18", en: "Opening · 16/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdpfqkpqkp", white: "iqdpkdncdd" },
            marks: { A: "io", B: "cn", C: "dn" },
            correct: ["io"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-17",
        chapterId: "beginner-level4",
        order: 107,
        title: { zh: "布局 · 17/18", en: "Opening · 17/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ppqqpndpgqpd", white: "prnqjqjdddcf" },
            marks: { A: "lq", B: "dj", C: "fc" },
            correct: ["lq"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-8-18",
        chapterId: "beginner-level4",
        order: 108,
        title: { zh: "布局 · 18/18", en: "Opening · 18/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqpoq", white: "dddpql" },
            marks: { A: "qn", B: "qj", C: "qf" },
            correct: ["qj"],
        },
    },
];

const bl4Opening9Levels: Level[] = [
    {
        id: "beginner-level4-bl4-opening-9-1",
        chapterId: "beginner-level4",
        order: 109,
        title: { zh: "布局 · 1/18", en: "Opening · 1/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqpoqip", white: "dpdkddjd" },
            marks: { A: "pj", B: "qf", C: "nc" },
            correct: ["pj"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-2",
        chapterId: "beginner-level4",
        order: 110,
        title: { zh: "布局 · 2/18", en: "Opening · 2/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdpqqofc", white: "jqdpddhc" },
            marks: { A: "lq", B: "fe", C: "cc" },
            correct: ["cc"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-3",
        chapterId: "beginner-level4",
        order: 111,
        title: { zh: "布局 · 3/18", en: "Opening · 3/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pcdpqejc", white: "qpdcceoq" },
            marks: { A: "gc", B: "qk", C: "jq" },
            correct: ["qk"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-4",
        chapterId: "beginner-level4",
        order: 112,
        title: { zh: "布局 · 4/18", en: "Opening · 4/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dddfdkopocofoh", white: "dpcnfcldqdpiqg" },
            marks: { A: "id", B: "ip", C: "fq" },
            correct: ["id"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-5",
        chapterId: "beginner-level4",
        order: 113,
        title: { zh: "布局 · 5/18", en: "Opening · 5/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdppfq", white: "dpipdd" },
            marks: { A: "fp", B: "fo", C: "fn" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-6",
        chapterId: "beginner-level4",
        order: 114,
        title: { zh: "布局 · 6/18", en: "Opening · 6/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bdcddcedocpcqdqfpqqo", white: "decegcjdodndncjqdpci" },
            marks: { A: "gq", B: "fp", C: "cn" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-7",
        chapterId: "beginner-level4",
        order: 115,
        title: { zh: "布局 · 7/18", en: "Opening · 7/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdjdfcpqqo", white: "dddfdpjqqi" },
            marks: { A: "lq", B: "qk", C: "qg" },
            correct: ["qg"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-8",
        chapterId: "beginner-level4",
        order: 116,
        title: { zh: "布局 · 8/18", en: "Opening · 8/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqfpjqpoqfqicfcdbfe", white: "dpeqfphqnckcccdddffg" },
            marks: { A: "ck", B: "cj", C: "ci" },
            correct: ["ck"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-9",
        chapterId: "beginner-level4",
        order: 117,
        title: { zh: "布局 · 9/18", en: "Opening · 9/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdppqonpeq", white: "qnpnlqcpdd" },
            marks: { A: "nr", B: "pk", C: "jd" },
            correct: ["pk"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-10",
        chapterId: "beginner-level4",
        order: 118,
        title: { zh: "布局 · 10/18", en: "Opening · 10/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pcmcphqndpfqci", white: "qeneppnpjqcdec" },
            marks: { A: "pk", B: "dl", C: "cl" },
            correct: ["pk"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-11",
        chapterId: "beginner-level4",
        order: 119,
        title: { zh: "布局 · 11/18", en: "Opening · 11/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqpoqjpfq", white: "qjdpdndjdd" },
            marks: { A: "ql", B: "qf", C: "jc" },
            correct: ["ql"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-12",
        chapterId: "beginner-level4",
        order: 120,
        title: { zh: "布局 · 12/18", en: "Opening · 12/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qdocpq", white: "podpdd" },
            marks: { A: "np", B: "qo", C: "ql" },
            correct: ["qo"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-13",
        chapterId: "beginner-level4",
        order: 121,
        title: { zh: "布局 · 13/18", en: "Opening · 13/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qcndqnpnpoop", white: "ddeqqpqopqqg" },
            marks: { A: "qj", B: "qi", C: "qe" },
            correct: ["qi"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-14",
        chapterId: "beginner-level4",
        order: 122,
        title: { zh: "布局 · 14/18", en: "Opening · 14/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qdocqoqppqnq", white: "qnpopmqidpdd" },
            marks: { A: "fq", B: "qg", C: "lc" },
            correct: ["qg"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-15",
        chapterId: "beginner-level4",
        order: 123,
        title: { zh: "布局 · 15/18", en: "Opening · 15/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qdocldiccjcmjqppnpqq", white: "ecddcfcpeqhqrpqnqkqh" },
            marks: { A: "jo", B: "io", C: "ho" },
            correct: ["jo"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-16",
        chapterId: "beginner-level4",
        order: 124,
        title: { zh: "布局 · 16/18", en: "Opening · 16/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdqopqcqcpcnbn", white: "jpdqdpdoemcldd" },
            marks: { A: "cg", B: "cf", C: "fc" },
            correct: ["fc"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-17",
        chapterId: "beginner-level4",
        order: 125,
        title: { zh: "布局 · 17/18", en: "Opening · 17/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ocqdqgqoqppqnq", white: "qioipoqnpmdpdd" },
            marks: { A: "fq", B: "dj", C: "fc" },
            correct: ["fc"],
        },
    },
    {
        id: "beginner-level4-bl4-opening-9-18",
        chapterId: "beginner-level4",
        order: 126,
        title: { zh: "布局 · 18/18", en: "Opening · 18/18" },
        instruction: { zh: "黑先。选择A、B或C中最佳的着法。", en: "Black to play. Choose the best move, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpdogpkpopqopjpdnedc", white: "ccdbecdencldbncpcqer" },
            marks: { A: "lf", B: "dj", C: "dl" },
            correct: ["lf"],
        },
    },
];

const bl4Joseki1Levels: Level[] = [
    {
        id: "beginner-level4-bl4-joseki-1-1",
        chapterId: "beginner-level4",
        order: 127,
        title: { zh: "定式 · 1/16", en: "Joseki · 1/16" },
        instruction: { zh: "白棋在1下挂，黑棋在2下夹。白棋可以跳向中腹或在3跳入角部。在这个定式中，黑棋将白棋的1和3分断。用白棋下这个定式，从3开始。", en: "White plays a kakari at 1 and Black plays a pincer at 2. White can jump to the center or jump into the corner at 3. In this joseki Black separates White's 1 and 3. Play this joseki with White, starting at 3." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dphq", white: "fq" },
            marks: { 1: "fq", 2: "hq", 3: "cq", 4: "dq", 5: "cp", 6: "do", 7: "dr", 8: "er", 9: "cr", 10: "eq", 11: "cn" },
            correct: ["cqdqcpdodrercreqcn"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-2",
        chapterId: "beginner-level4",
        order: 128,
        title: { zh: "定式 · 2/16", en: "Joseki · 2/16" },
        instruction: { zh: "用黑棋下这个定式，从4开始。", en: "Play this joseki with Black, starting at 4." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dphq", white: "fqcq" },
            marks: { 1: "fq", 2: "hq", 3: "cq", 4: "dq", 5: "cp", 6: "do", 7: "dr", 8: "er", 9: "cr", 10: "eq", 11: "cn" },
            correct: ["dqcpdodrercreqcn"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-3",
        chapterId: "beginner-level4",
        order: 129,
        title: { zh: "定式 · 3/16", en: "Joseki · 3/16" },
        instruction: { zh: "在两颗白棋的头上下1，在这种情况下并不好。白棋可以用2威胁从下方连接，如果黑棋用3阻止，白棋可以用4切断三颗黑棋。用白棋下这个变化。", en: "Playing 1 at the head of the two white stones is in this case not good. White can threaten with 2 to connect underneath and if Black prevents this with 3, White can cut the three black stones with 4. Play this deviation with White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codpdqhq", white: "cpcqfq" },
            marks: { 1: "co", 2: "cr", 3: "dr", 4: "do", 5: "cn", 6: "ep", 7: "fr", 8: "er" },
            correct: ["crdrdocnepfrer"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-4",
        chapterId: "beginner-level4",
        order: 130,
        title: { zh: "定式 · 4/16", en: "Joseki · 4/16" },
        instruction: { zh: "在这个定式中，白棋用3跳入角部，黑棋用4挡。这个定式将角部在黑白之间分割。用白棋下这个定式。", en: "In this joseki, White jumps into the corner with 3 and Black blocks with 4. This joseki divides the corner between Black and White. Play this joseki with White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdn", white: "ep" },
            marks: { 1: "ep", 2: "dn", 3: "cq", 4: "bq", 5: "dq", 6: "bo", 7: "iq" },
            correct: ["cqbqdqboiq"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-5",
        chapterId: "beginner-level4",
        order: 131,
        title: { zh: "定式 · 5/16", en: "Joseki · 5/16" },
        instruction: { zh: "用黑棋下这个定式，从4开始。", en: "Play this joseki with Black, starting at 4." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdn", white: "epcq" },
            marks: { 1: "ep", 2: "dn", 3: "cq", 4: "bq", 5: "dq", 6: "bo", 7: "iq" },
            correct: ["bqdqboiq"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-6",
        chapterId: "beginner-level4",
        order: 132,
        title: { zh: "定式 · 6/16", en: "Joseki · 6/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldocpcqbr", white: "fpdqcrer" },
            marks: { 1: "br", A: "bq", B: "bs", C: "cs" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-7",
        chapterId: "beginner-level4",
        order: 133,
        title: { zh: "定式 · 7/16", en: "Joseki · 7/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqfqdr", white: "dpdqhq" },
            marks: { 1: "dr", A: "cp", B: "fp", C: "er" },
            correct: ["er"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-8",
        chapterId: "beginner-level4",
        order: 134,
        title: { zh: "定式 · 8/16", en: "Joseki · 8/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqdr", white: "dphq" },
            marks: { 1: "dr", A: "fp", B: "cq", C: "er" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-9",
        chapterId: "beginner-level4",
        order: 135,
        title: { zh: "定式 · 9/16", en: "Joseki · 9/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpcqeqfqdr", white: "dodpdqhqer" },
            marks: { 1: "eq", A: "co", B: "fo", C: "cr" },
            correct: ["cr"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-10",
        chapterId: "beginner-level4",
        order: 136,
        title: { zh: "定式 · 10/16", en: "Joseki · 10/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "focqfq", white: "dpdqhq" },
            marks: { 1: "fo", A: "dn", B: "cp", C: "fp" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-11",
        chapterId: "beginner-level4",
        order: 137,
        title: { zh: "定式 · 11/16", en: "Joseki · 11/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmfpdqcrer", white: "cldocpcq" },
            marks: { 1: "dm", A: "dl", B: "cm", C: "cn" },
            correct: ["cm"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-12",
        chapterId: "beginner-level4",
        order: 138,
        title: { zh: "定式 · 12/16", en: "Joseki · 12/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cocpcqfq", white: "dodpdqhq" },
            marks: { 1: "co", A: "cn", B: "fp", C: "cr" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-13",
        chapterId: "beginner-level4",
        order: 139,
        title: { zh: "定式 · 13/16", en: "Joseki · 13/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cncpcqfq", white: "dodpdqhq" },
            marks: { 1: "cn", A: "dn", B: "co", C: "cr" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-14",
        chapterId: "beginner-level4",
        order: 140,
        title: { zh: "定式 · 14/16", en: "Joseki · 14/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cododpdqhqer", white: "cpcqfqcrdr" },
            marks: { 1: "co", A: "bo", B: "eq", C: "fr" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-15",
        chapterId: "beginner-level4",
        order: 141,
        title: { zh: "定式 · 15/16", en: "Joseki · 15/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpdqbrcr", white: "docpcq" },
            marks: { 1: "br", A: "cl", B: "bq", C: "hq" },
            correct: ["cl"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-1-16",
        chapterId: "beginner-level4",
        order: 142,
        title: { zh: "定式 · 16/16", en: "Joseki · 16/16" },
        instruction: { zh: "白先。选择黑棋1之后A、B或C中最佳的应答。", en: "White to play. Choose the best answer after Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codpepdqhqdr", white: "docpcqfqcr" },
            marks: { 1: "ep", A: "cn", B: "bo", C: "fp" },
            correct: ["cn"],
        },
    },
];

const bl4Joseki2Levels: Level[] = [
    {
        id: "beginner-level4-bl4-joseki-2-1",
        chapterId: "beginner-level4",
        order: 143,
        title: { zh: "定式 · 1/18", en: "Joseki · 1/18" },
        instruction: { zh: "如果黑棋在A有一颗棋子，黑棋应该在那一边筑墙。用白棋下这个定式，从3开始。", en: "If Black has a stone at A, Black should build a wall on that side. Play this joseki with White, starting at 3." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldpjp", white: "cn" },
            marks: { 1: "cn", 2: "cl", 3: "cq", 4: "dq", 5: "cp", 6: "do", 7: "bn", 8: "em", A: "jp" },
            correct: ["cqdqcpdobnem"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-2",
        chapterId: "beginner-level4",
        order: 144,
        title: { zh: "定式 · 2/18", en: "Joseki · 2/18" },
        instruction: { zh: "用黑棋下这个定式，从4开始。", en: "Play this joseki with Black, starting at 4." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldpjp", white: "cncq" },
            marks: { 1: "cn", 2: "cl", 3: "cq", 4: "dq", 5: "cp", 6: "do", 7: "bn", 8: "em" },
            correct: ["dqcpdobnem"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-3",
        chapterId: "beginner-level4",
        order: 145,
        title: { zh: "定式 · 3/18", en: "Joseki · 3/18" },
        instruction: { zh: "如果黑棋2攻击白棋的挂，白棋在3曲。在这个版本中，白棋和黑棋都在7和8下了大伸展。用白棋下这个定式，从3开始。", en: "If Black 2 attacks the white kakari, White bends at 3. In this version both White and Black play large extensions at 7 and 8. Play this joseki with White, starting at 3." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfp", white: "fq" },
            marks: { 1: "fq", 2: "fp", 3: "gp", 4: "fo", 5: "eq", 6: "dq", 7: "jq", 8: "cj" },
            correct: ["gpfoeqdqjqcj"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-4",
        chapterId: "beginner-level4",
        order: 146,
        title: { zh: "定式 · 4/18", en: "Joseki · 4/18" },
        instruction: { zh: "用黑棋下这个定式，从2开始。", en: "Play this joseki with Black, starting at 2." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "fq" },
            marks: { 1: "fq", 2: "fp", 3: "gp", 4: "fo", 5: "eq", 6: "dq", 7: "jq", 8: "cj" },
            correct: ["fpgpfoeqdqjqcj"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-5",
        chapterId: "beginner-level4",
        order: 147,
        title: { zh: "定式 · 5/18", en: "Joseki · 5/18" },
        instruction: { zh: "这是前一个定式的不同版本，其中白棋和黑棋用7和8覆盖切断点。用白棋下这个定式，从3开始。", en: "This is a different version of the previous joseki, where White and Black cover the cuts with 7 and 8. Play this joseki with White, starting at 3." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfp", white: "fq" },
            marks: { 1: "fq", 2: "fp", 3: "gp", 4: "fo", 5: "eq", 6: "dq", 7: "hq", 8: "dn" },
            correct: ["gpfoeqdqhqdn"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-6",
        chapterId: "beginner-level4",
        order: 148,
        title: { zh: "定式 · 6/18", en: "Joseki · 6/18" },
        instruction: { zh: "用黑棋下同一个定式，从2开始。", en: "Play the same joseki with Black, starting at 2." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "fq" },
            marks: { 1: "fq", 2: "fp", 3: "gp", 4: "fo", 5: "eq", 6: "dq", 7: "hq", 8: "dn" },
            correct: ["fpgpfoeqdqhqdn"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-7",
        chapterId: "beginner-level4",
        order: 149,
        title: { zh: "定式 · 7/18", en: "Joseki · 7/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eocpepcq", white: "dpfpdqeq" },
            marks: { 1: "dp", A: "co", B: "do", C: "dr" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-8",
        chapterId: "beginner-level4",
        order: 150,
        title: { zh: "定式 · 8/18", en: "Joseki · 8/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fq", white: "dpeq" },
            marks: { 1: "eq", A: "fp", B: "er", C: "fr" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-9",
        chapterId: "beginner-level4",
        order: 151,
        title: { zh: "定式 · 9/18", en: "Joseki · 9/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpfp", white: "dqfq" },
            marks: { 1: "dq", A: "ep", B: "cq", C: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-10",
        chapterId: "beginner-level4",
        order: 152,
        title: { zh: "定式 · 10/18", en: "Joseki · 10/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fodpfp", white: "gpcqfq" },
            marks: { 1: "cq", A: "cp", B: "dq", C: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-11",
        chapterId: "beginner-level4",
        order: 153,
        title: { zh: "定式 · 11/18", en: "Joseki · 11/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpfp", white: "fqgq" },
            marks: { 1: "gq", A: "gp", B: "hp", C: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-12",
        chapterId: "beginner-level4",
        order: 154,
        title: { zh: "定式 · 12/18", en: "Joseki · 12/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpfp", white: "eqfq" },
            marks: { 1: "eq", A: "ep", B: "dq", C: "gq" },
            correct: ["dq", "ep"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-13",
        chapterId: "beginner-level4",
        order: 155,
        title: { zh: "定式 · 13/18", en: "Joseki · 13/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gpeqfq", white: "fogodpfp" },
            marks: { 1: "go", A: "ho", B: "hp", C: "hq" },
            correct: ["hp"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-14",
        chapterId: "beginner-level4",
        order: 156,
        title: { zh: "定式 · 14/18", en: "Joseki · 14/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmcnco", white: "dnendodp" },
            marks: { 1: "do", A: "cl", B: "cp", C: "cq" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-15",
        chapterId: "beginner-level4",
        order: 157,
        title: { zh: "定式 · 15/18", en: "Joseki · 15/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fodpfpdq", white: "gpeqfqdr" },
            marks: { 1: "dr", A: "ep", B: "gq", C: "cr" },
            correct: ["cr"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-16",
        chapterId: "beginner-level4",
        order: 158,
        title: { zh: "定式 · 16/18", en: "Joseki · 16/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fodpfp", white: "gpfqgq" },
            marks: { 1: "gq", A: "go", B: "dq", C: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-17",
        chapterId: "beginner-level4",
        order: 159,
        title: { zh: "定式 · 17/18", en: "Joseki · 17/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gpeqfq", white: "fodpfpgq" },
            marks: { 1: "gq", A: "dq", B: "hq", C: "gr" },
            correct: ["hq"],
        },
    },
    {
        id: "beginner-level4-bl4-joseki-2-18",
        chapterId: "beginner-level4",
        order: 160,
        title: { zh: "定式 · 18/18", en: "Joseki · 18/18" },
        instruction: { zh: "黑先。选择白棋1之后A、B或C中最佳的应答。", en: "Black to play. Choose the best answer after White's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnencpdp", white: "dmcncofq" },
            marks: { 1: "fq", A: "cm", B: "ep", C: "fp" },
            correct: ["fp"],
        },
    },
];

const bl4Skills1Levels: Level[] = [
    {
        id: "beginner-level4-bl4-skills-1-1",
        chapterId: "beginner-level4",
        order: 161,
        title: { zh: "技巧 · 1/13", en: "Skills · 1/13" },
        instruction: { zh: "为了保持对手的棋块虚弱，好战术是包围或切断这个棋块。包围通常是通过阻挡对手棋子的前进方向来实现的。在这个例子中，黑棋可以朝不同方向前进。在方向A，黑棋可以向中腹发展。在方向B，黑棋跑向边缘。那是死路。在方向C，黑棋可以沿着边缘发展，但那一边已经有一颗白棋。如果白棋想阻止黑棋的发展，最好的方法是下A，从而阻挡向中腹的前进。白先。选择A、B或C中最佳的阻挡方式？", en: "To keep an opponent's group weak, good tactics is to surround or cut this group. Surrounding is often done by blocking the advance of the opponent's stones. In this example, the black stones can advance in different directions. In direction A, Black can develop towards the center. In direction B, Black runs toward the edge. That's a dead end. In direction C, Black can develop along the edge, but there is already a white stone on that side. If White wants to stop Black's development, the best way is to play A, thus blocking the advance to the center. White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdq", white: "cpcqfp" },
            marks: { A: "do", B: "dr", C: "fr" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-2",
        chapterId: "beginner-level4",
        order: 162,
        title: { zh: "技巧 · 2/13", en: "Skills · 2/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepeq", white: "dohocpcqdqhq" },
            marks: { A: "eo", B: "fp", C: "er" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-3",
        chapterId: "beginner-level4",
        order: 163,
        title: { zh: "技巧 · 3/13", en: "Skills · 3/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eocpdpcq", white: "doepfpdqdr" },
            marks: { A: "en", B: "co", C: "cr" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-4",
        chapterId: "beginner-level4",
        order: 164,
        title: { zh: "技巧 · 4/13", en: "Skills · 4/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdq", white: "coep" },
            marks: { A: "do", B: "cp", C: "eq" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-5",
        chapterId: "beginner-level4",
        order: 165,
        title: { zh: "技巧 · 5/13", en: "Skills · 5/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcocpcqfqgqiqir", white: "dndodpfpgphpipjqjr" },
            marks: { A: "dm", B: "cn", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-6",
        chapterId: "beginner-level4",
        order: 166,
        title: { zh: "技巧 · 6/13", en: "Skills · 6/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmdmfmepcqdqfqfr", white: "cncpfpgpbqgqiqbr" },
            marks: { A: "eo", B: "dp", C: "gr" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-7",
        chapterId: "beginner-level4",
        order: 167,
        title: { zh: "技巧 · 7/13", en: "Skills · 7/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epdqeq", white: "dodpcqcr" },
            marks: { A: "eo", B: "fp", C: "dr" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-8",
        chapterId: "beginner-level4",
        order: 168,
        title: { zh: "技巧 · 8/13", en: "Skills · 8/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cncpdpcq", white: "dmeoepdqiqcrer" },
            marks: { A: "cm", B: "dn", C: "bq" },
            correct: ["cm"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-9",
        chapterId: "beginner-level4",
        order: 169,
        title: { zh: "技巧 · 9/13", en: "Skills · 9/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hndodphpdq", white: "emcncocqeqcrdrfr" },
            marks: { A: "dn", B: "cp", C: "ep" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-10",
        chapterId: "beginner-level4",
        order: 170,
        title: { zh: "技巧 · 10/13", en: "Skills · 10/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "goeqfq", white: "dniodpepdqiq" },
            marks: { A: "fp", B: "gq", C: "er" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-11",
        chapterId: "beginner-level4",
        order: 171,
        title: { zh: "技巧 · 11/13", en: "Skills · 11/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dncpdpcq", white: "enepdqeqbrcr" },
            marks: { A: "dm", B: "eo", C: "bq" },
            correct: ["dm"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-12",
        chapterId: "beginner-level4",
        order: 172,
        title: { zh: "技巧 · 12/13", en: "Skills · 12/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpephpdqeqfrgr", white: "cnenbqcqfqdrer" },
            marks: { A: "eo", B: "bp", C: "fp" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-1-13",
        chapterId: "beginner-level4",
        order: 173,
        title: { zh: "技巧 · 13/13", en: "Skills · 13/13" },
        instruction: { zh: "白先。选择A、B或C中最佳的阻挡方式？", en: "White to play. Choose the best way to block, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodpepfp", white: "codqeqfq" },
            marks: { A: "dn", B: "cp", C: "gp" },
            correct: ["cp"],
        },
    },
];

const bl4Skills2Levels: Level[] = [
    {
        id: "beginner-level4-bl4-skills-2-1",
        chapterId: "beginner-level4",
        order: 174,
        title: { zh: "技巧 · 1/16", en: "Skills · 1/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqapbpcpcqepeoerdrescn", white: "arbrcrbsbqdqeqfrfpgqho" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-2",
        chapterId: "beginner-level4",
        order: 175,
        title: { zh: "技巧 · 2/16", en: "Skills · 2/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqcqcpcobobncndrds", white: "aoanbmcmdmdndodpdqeresfqaraq" },
            correct: ["ap"],
            wrong: ["asap", "csap"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-3",
        chapterId: "beginner-level4",
        order: 176,
        title: { zh: "技巧 · 3/16", en: "Skills · 3/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arapbpcpcqdodrercm", white: "frfqeqdqcrbrbqaqhp" },
            correct: ["bs"],
            wrong: ["csas"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-4",
        chapterId: "beginner-level4",
        order: 177,
        title: { zh: "技巧 · 4/16", en: "Skills · 4/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrcqcpbpao", white: "anbnbocododpcrdrdq" },
            correct: ["aq"],
            wrong: ["apaq", "araq"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-5",
        chapterId: "beginner-level4",
        order: 178,
        title: { zh: "技巧 · 5/16", en: "Skills · 5/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bscrbqbpcododpeqfqfo", white: "arbrbobncmcpcqdqdrem" },
            correct: ["ds"],
            wrong: ["ercs", "ascs", "aqap", "csds"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-6",
        chapterId: "beginner-level4",
        order: 179,
        title: { zh: "技巧 · 6/16", en: "Skills · 6/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fsfrerendncrcqcpcogqgpfpephriqfm", white: "dqdreqfqgrbscsbocncmdodldpbp" },
            correct: ["ds"],
            wrong: ["gsds"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-7",
        chapterId: "beginner-level4",
        order: 180,
        title: { zh: "技巧 · 7/16", en: "Skills · 7/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbrcrcqcpcoapbnbmbkckcl", white: "blcmcndodpdqdrenaobobpcsbs" },
            correct: ["bq"],
            wrong: ["anam", "aqds", "alaq", "asds"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-8",
        chapterId: "beginner-level4",
        order: 181,
        title: { zh: "技巧 · 8/16", en: "Skills · 8/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "araqbpcpcqfrgqfpepdocngp", white: "bqbrcrdsereqdqdpfq" },
            correct: ["gs"],
            wrong: ["bsgr", "esfs"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-9",
        chapterId: "beginner-level4",
        order: 182,
        title: { zh: "技巧 · 9/16", en: "Skills · 9/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnengnbscrcqcpbobncn", white: "gqhpfpbrbqbpaoanbmcmdmdkcododpeq" },
            correct: ["apaqar"],
            wrong: ["arap"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-10",
        chapterId: "beginner-level4",
        order: 183,
        title: { zh: "技巧 · 10/16", en: "Skills · 10/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eofpgpfrcscrcqcpdpepeq", white: "hncmgrhrfqhpgofoendocobpbqbrgq" },
            correct: ["drfses"],
            wrong: ["esdr", "fsdr"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-11",
        chapterId: "beginner-level4",
        order: 184,
        title: { zh: "技巧 · 11/16", en: "Skills · 11/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbqcqcrcsbobncmamcl", white: "dmcncocpbpaodqdreogpfrbs" },
            correct: ["ap"],
            wrong: ["anap", "aqap"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-12",
        chapterId: "beginner-level4",
        order: 185,
        title: { zh: "技巧 · 12/16", en: "Skills · 12/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "boaobncmbmdndodpdqdrdsdl", white: "brcscrcqcpbpcocn" },
            correct: ["aqaparasbs"],
            wrong: ["aqapasar", "apaq", "araq"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-13",
        chapterId: "beginner-level4",
        order: 186,
        title: { zh: "技巧 · 13/16", en: "Skills · 13/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drdsaqbpaocododpfn", white: "arbqcrdqerfqfphp" },
            correct: ["cq"],
            wrong: ["eqep", "brcq"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-14",
        chapterId: "beginner-level4",
        order: 187,
        title: { zh: "技巧 · 14/16", en: "Skills · 14/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrgrisiriqhpgpfoeqepdpcpcq", white: "cscrdqdrerfqfpgqhrgs" },
            correct: ["hsfrhq", "hqfrhs"],
            wrong: ["fsfrhses", "fsfrhqes", "fsfresds", "frfs"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-15",
        chapterId: "beginner-level4",
        order: 188,
        title: { zh: "技巧 · 15/16", en: "Skills · 15/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbqcqdqdrer", white: "braqapbpcpdpeqfrfpgr" },
            correct: ["bs"],
            wrong: ["cras"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-2-16",
        chapterId: "beginner-level4",
        order: 189,
        title: { zh: "技巧 · 16/16", en: "Skills · 16/16" },
        instruction: { zh: "黑先。下劫争以获利。", en: "Black to play. Play ko to profit." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbocpdqeresepbnco", white: "brbqbpcqdrdscs" },
            correct: ["bs"],
            wrong: ["aqap", "asap", "apaq"],
        },
    },
];

const bl4Skills3Levels: Level[] = [
    {
        id: "beginner-level4-bl4-skills-3-1",
        chapterId: "beginner-level4",
        order: 190,
        title: { zh: "技巧 · 1/13", en: "Skills · 1/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqapbpcpdodndmdqck", white: "arbrbqcqdpeoenfqgo" },
            marks: { A: "ep", B: "dr" },
            correct: ["dr"],
            wrong: ["epdr"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-2",
        chapterId: "beginner-level4",
        order: 191,
        title: { zh: "技巧 · 2/13", en: "Skills · 2/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gpfpdocqdqeqcpbncmbohpfrgr", white: "dldpepfofmcofqgqhqiqekcndm" },
            marks: { A: "dn", B: "eo" },
            correct: ["eodnio"],
            wrong: ["dneo"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-3",
        chapterId: "beginner-level4",
        order: 192,
        title: { zh: "技巧 · 3/13", en: "Skills · 3/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbpcphqgpepdqdrerfrgrjq", white: "crcqeqfqgqdpcobofoenclbr" },
            marks: { A: "do", B: "fp" },
            correct: ["do"],
            wrong: ["fpdo"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-4",
        chapterId: "beginner-level4",
        order: 193,
        title: { zh: "技巧 · 4/13", en: "Skills · 4/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbrcrdrerfrgrgqfphpiqjqjr", white: "cqdqeqfqgphqhriripjp" },
            marks: { A: "eo", B: "ho" },
            correct: ["ho"],
            wrong: ["eogo"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-5",
        chapterId: "beginner-level4",
        order: 194,
        title: { zh: "技巧 · 5/13", en: "Skills · 5/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnfqflendrdqdpepfpgpcocn", white: "brcrcqcpbpbododmclfrgqhqipeq" },
            marks: { A: "dn", B: "er" },
            correct: ["dn"],
            wrong: ["erdn"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-6",
        chapterId: "beginner-level4",
        order: 195,
        title: { zh: "技巧 · 6/13", en: "Skills · 6/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqbocpdpepeqclfpfr", white: "bscrdserdqcqbpcofqiq" },
            marks: { A: "bn", B: "gq" },
            correct: ["gq"],
            wrong: ["bnap"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-7",
        chapterId: "beginner-level4",
        order: 196,
        title: { zh: "技巧 · 7/13", en: "Skills · 7/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqgqhqepdoapbpfoiphojpcqdqeq", white: "brbqaobocpdpeofpgphpenfndlgn" },
            marks: { A: "co", B: "go" },
            correct: ["co"],
            wrong: ["goco"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-8",
        chapterId: "beginner-level4",
        order: 197,
        title: { zh: "技巧 · 8/13", en: "Skills · 8/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqerdrfpgqgr", white: "crdqdpepfrfq" },
            marks: { A: "fo", B: "gp" },
            correct: ["fo"],
            wrong: ["gpfo"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-9",
        chapterId: "beginner-level4",
        order: 198,
        title: { zh: "技巧 · 9/13", en: "Skills · 9/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmdndobrbqcqcpeofpgphqiqgrjpapblcl", white: "crdrdqbpbococnbmhogofoenemdmglfqjnhp" },
            marks: { A: "dp", B: "ep" },
            correct: ["dp"],
            wrong: ["epdp"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-10",
        chapterId: "beginner-level4",
        order: 199,
        title: { zh: "技巧 · 10/13", en: "Skills · 10/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fmfnhncrdrcqcphqhpdoeofpgqhk", white: "eqgpgofoendncncocldkdq" },
            marks: { A: "dp", B: "ep" },
            correct: ["dp"],
            wrong: ["epdp"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-11",
        chapterId: "beginner-level4",
        order: 200,
        title: { zh: "技巧 · 11/13", en: "Skills · 11/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drcqcpbpdpcmfqdl", white: "bscrbqaqdqhq" },
            marks: { A: "eq", B: "ar" },
            correct: ["ar"],
            wrong: ["eqer"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-12",
        chapterId: "beginner-level4",
        order: 201,
        title: { zh: "技巧 · 12/13", en: "Skills · 12/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpcmbmdodnfpepfnck", white: "cncodmdpdqeqfqgpip" },
            marks: { A: "en", B: "fo" },
            correct: ["en"],
            wrong: ["foen"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-3-13",
        chapterId: "beginner-level4",
        order: 202,
        title: { zh: "技巧 · 13/13", en: "Skills · 13/13" },
        instruction: { zh: "白先。哪些棋子重要？你应该在哪里下棋？选择A或B。", en: "White to play. Which stones are important? Where should you play? Choose A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqdrepfpfqdodnemgogngmhriqipin", white: "crcqcpdpeqeofogphqbn" },
            marks: { B: "fr", A: "er" },
            correct: ["fr"],
            wrong: ["erfr"],
        },
    },
];

const bl4Skills4Levels: Level[] = [
    {
        id: "beginner-level4-bl4-skills-4-1",
        chapterId: "beginner-level4",
        order: 203,
        title: { zh: "技巧 · 1/7", en: "Skills · 1/7" },
        instruction: { zh: "当对手对你进行打吃时，你常常被迫回应。这给了对手一个好机会来加强他们的阵地或使你的棋形变坏。在这个例子中，白棋可以通过在A下棋来打吃一颗棋子。如果你随后保护那颗棋子，你将留下坏形，白棋将占据角部。你自己在A下棋来防止打吃更好。下B太远了。白棋仍然可以打吃然后吃掉你在B的棋子。黑先。防止打吃。选择A或B中最佳的着法。", en: "When your opponent puts you in atari, you're often forced to respond. This presents your opponent with a good opportunity to strengthen their position or give your pieces a bad shape. In this example, White can put a stone in atari by playing at A. If you then protect that stone, you'll be left with bad shape, and White will take the corner. You're better off playing at A yourself to prevent the atari. Playing at B is a step too far. White can still play atari and then capture your stone at B. Black to play. Prevent atari. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdoep", white: "bpclcnco" },
            marks: { A: "cq", B: "bq" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-4-2",
        chapterId: "beginner-level4",
        order: 204,
        title: { zh: "技巧 · 2/7", en: "Skills · 2/7" },
        instruction: { zh: "黑先。防止打吃。选择A或B中最佳的着法。", en: "Black to play. Prevent atari. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdpco", white: "crdqeqgq" },
            marks: { A: "bp", B: "bq" },
            correct: ["bq"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-4-3",
        chapterId: "beginner-level4",
        order: 205,
        title: { zh: "技巧 · 3/7", en: "Skills · 3/7" },
        instruction: { zh: "黑先。防止打吃。选择A或B中最佳的着法。", en: "Black to play. Prevent atari. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqcpdo", white: "eodpdqdrfphp" },
            marks: { A: "cn", B: "dn" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-4-4",
        chapterId: "beginner-level4",
        order: 206,
        title: { zh: "技巧 · 4/7", en: "Skills · 4/7" },
        instruction: { zh: "黑先。防止打吃。选择A或B中最佳的着法。", en: "Black to play. Prevent atari. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqepdofqgq", white: "fpfoeodnemdk" },
            marks: { A: "cn", B: "co" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-4-5",
        chapterId: "beginner-level4",
        order: 207,
        title: { zh: "技巧 · 5/7", en: "Skills · 5/7" },
        instruction: { zh: "黑先。防止打吃。选择A或B中最佳的着法。", en: "Black to play. Prevent atari. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqbpcocl", white: "crdqeqhq" },
            marks: { A: "bq", B: "br" },
            correct: ["br"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-4-6",
        chapterId: "beginner-level4",
        order: 208,
        title: { zh: "技巧 · 6/7", en: "Skills · 6/7" },
        instruction: { zh: "黑先。防止打吃。选择A或B中最佳的着法。", en: "Black to play. Prevent atari. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqdpcofphq", white: "cndndodk" },
            marks: { A: "bn", B: "bo" },
            correct: ["bo"],
        },
    },
    {
        id: "beginner-level4-bl4-skills-4-7",
        chapterId: "beginner-level4",
        order: 209,
        title: { zh: "技巧 · 7/7", en: "Skills · 7/7" },
        instruction: { zh: "黑先。防止打吃。选择A或B中最佳的着法。", en: "Black to play. Prevent atari. Choose the best move, A or B." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dneneodpdqer", white: "crdrcqcpcodocm" },
            marks: { A: "fp", B: "fq" },
            correct: ["fq"],
        },
    },
];

const bl4Capture1Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capture-1-1",
        chapterId: "beginner-level4",
        order: 210,
        title: { zh: "手筋 · 1/22", en: "Tesuji · 1/22" },
        instruction: { zh: "手筋是一个术语，用于表示局部战斗中战术性的巧妙着法。一个例子是征子：你像征子一样包围对手的棋子。一路上，你牺牲一颗或多颗棋子，但你继续打吃。最后，你吃掉整个棋块。白先。尽可能多地吃掉黑棋。", en: "Tesuji is a term used to indicate a tactical, clever move in a local position. An example is surrounding: you surround your opponent's stones, like with a ladder. Along the way, you sacrifice one or more stones, but you continue to atari. Finally, you capture the entire group. White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cncocpdodqfnhohq", white: "bnbobpbqcmcrdkdndpdr" },
            correct: ["eoepcqdpfp"],
            wrong: ["epeo"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-2",
        chapterId: "beginner-level4",
        order: 211,
        title: { zh: "手筋 · 2/22", en: "Tesuji · 2/22" },
        instruction: { zh: "这个形状叫做鹤的巢穴。你可以通过下鹤的巢穴手筋来吃掉三颗黑棋，从A开始并利用气的短缺。白先。吃掉三颗黑棋。", en: "This shape is called a crane's nest. You can capture the three black stones by playing the crane's nest tesuji, starting at A and using shortage of liberties. White to play. Capture the three black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpenepfp", white: "cocpdqeqfqgogp" },
            marks: { A: "eo" },
            correct: ["eododnfofn"],
            wrong: ["eodofodn"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-3",
        chapterId: "beginner-level4",
        order: 212,
        title: { zh: "手筋 · 3/22", en: "Tesuji · 3/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqdpdoeq", white: "dqdrcpepeoen" },
            correct: ["codndm"],
            wrong: ["dnco", "cnco", "fqer", "bper"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-4",
        chapterId: "beginner-level4",
        order: 213,
        title: { zh: "手筋 · 4/22", en: "Tesuji · 4/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "grfqerepdphp", white: "cqcpcndqeqfrdl" },
            correct: ["fpfseo", "fpfsfo"],
            wrong: ["drfs", "gqfp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-5",
        chapterId: "beginner-level4",
        order: 214,
        title: { zh: "手筋 · 5/22", en: "Tesuji · 5/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdreqfqfrgrhqhpho", white: "gqgpfpepdpdqcpbpdler" },
            correct: ["cresbr"],
            wrong: ["aqbr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-6",
        chapterId: "beginner-level4",
        order: 215,
        title: { zh: "手筋 · 6/22", en: "Tesuji · 6/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmesdscscrcqcpepeqerdodnemcl", white: "eobsbrbqbpcobnfsfrfqfpfoendq" },
            correct: ["dpdrdp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-7",
        chapterId: "beginner-level4",
        order: 216,
        title: { zh: "手筋 · 7/22", en: "Tesuji · 7/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbpcqdqeqerfpdmemgmhnhq", white: "fqfrepdpcpcobodncmclhp" },
            correct: ["gofofn"],
            wrong: ["gpfo", "fogpgqgo", "fogpgogq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-8",
        chapterId: "beginner-level4",
        order: 217,
        title: { zh: "手筋 · 8/22", en: "Tesuji · 8/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdodpepfpgqgrhpiqclel", white: "dqeqfqgpgocpcohm" },
            correct: ["dneneofofn"],
            wrong: ["dneneofognem", "dneneofoemgn", "dnenfoeoemfngnfm", "dnenfoeoemfnfmgn", "fodn", "endn", "fncn", "cndndmcm"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-9",
        chapterId: "beginner-level4",
        order: 218,
        title: { zh: "手筋 · 9/22", en: "Tesuji · 9/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdrdqcpbpepfqgrgpeohr", white: "frereqcqbrdpdocobodm" },
            correct: ["csbqdscqaq", "csbqdscqap", "dsbqcscqaq", "dsbqcscqap"],
            wrong: ["bqes", "apes", "escsbsbq", "escsgsbqbsar", "fsbq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-10",
        chapterId: "beginner-level4",
        order: 219,
        title: { zh: "手筋 · 10/22", en: "Tesuji · 10/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpcpbocncmcleqfqfpdk", white: "bpbqcqerfrgqgpgoendngliqep" },
            correct: ["dqeofoepco", "dqeocodofo"],
            wrong: ["dqeofoepdoco", "fodq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-11",
        chapterId: "beginner-level4",
        order: 220,
        title: { zh: "手筋 · 11/22", en: "Tesuji · 11/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dsdrcpbpepeoenfpfqfrdl", white: "bqcrerfsgrgqgpfofnfmhn" },
            correct: ["dqeqcs"],
            wrong: ["dqeqesgs", "dqeqcqes", "eqdq", "cqdq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-12",
        chapterId: "beginner-level4",
        order: 221,
        title: { zh: "手筋 · 12/22", en: "Tesuji · 12/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epeqdqcpdmfnhn", white: "cqbpbodrerfqgpbnfrdpip" },
            correct: ["eodofpdpdn"],
            wrong: ["eododnfo", "fpeo", "coeo", "doeo"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-13",
        chapterId: "beginner-level4",
        order: 222,
        title: { zh: "手筋 · 13/22", en: "Tesuji · 13/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqapbobncmdqcpcqcrerfqgqgrhp", white: "bsbrbqbpcododpepfpeqfremgm" },
            correct: ["drdscs"],
            wrong: ["csdr", "esfs"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-14",
        chapterId: "beginner-level4",
        order: 223,
        title: { zh: "手筋 · 14/22", en: "Tesuji · 14/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqbpbocncmdoeofognhnfqfrckcshq", white: "crcqcpcodnenfngohoerfsgrhr" },
            correct: ["fpepeqgpdpfphp"],
            wrong: ["epfpgqdpeqdr", "epfpgqdpdqeqdrds", "epfpeqgq", "epfpdpgq", "epfpgpgq", "dpeqfpepgqgphpdr", "dpeqfpepgqgpdrio", "dpeqepfp", "gqfm", "eqfm"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-15",
        chapterId: "beginner-level4",
        order: 224,
        title: { zh: "手筋 · 15/22", en: "Tesuji · 15/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epdpdqfqfresgshrhqioimhp", white: "bqcpdoeofpgpgqgreqcmfnbo" },
            correct: ["drercqeqds"],
            wrong: ["cqdr", "erdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-16",
        chapterId: "beginner-level4",
        order: 225,
        title: { zh: "手筋 · 16/22", en: "Tesuji · 16/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqbrdreqhq", white: "crdqdpcpbpdnfn" },
            correct: ["ercsfq"],
            wrong: ["ercsfrfq", "aqfq", "epfq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-17",
        chapterId: "beginner-level4",
        order: 226,
        title: { zh: "手筋 · 17/22", en: "Tesuji · 17/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepcqcrfqgqhqhpir", white: "dqeqfpeodmgphoio" },
            correct: ["cpdocodnen"],
            wrong: ["cpdocodncnen", "docp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-18",
        chapterId: "beginner-level4",
        order: 227,
        title: { zh: "手筋 · 18/22", en: "Tesuji · 18/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdrerfrgshrhqhogp", white: "grgqfqeqdqcqbrbsclcoes" },
            correct: ["fsdsfsescs"],
            wrong: ["csfs", "dsfs"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-19",
        chapterId: "beginner-level4",
        order: 228,
        title: { zh: "手筋 · 19/22", en: "Tesuji · 19/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqcrbscpcobmdlfl", white: "bpbocqdqdpfpiqdr" },
            correct: ["cndoen"],
            wrong: ["cndodneofnbn", "cndodneoenfo", "cndodneofoen", "cndoeodn", "dncn", "docn"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-20",
        chapterId: "beginner-level4",
        order: 229,
        title: { zh: "手筋 · 20/22", en: "Tesuji · 20/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqbpbocndmdlbmdpdqdrfpfoeoenfr", white: "cscrcqcpcododnemfmfngohnfqgqgr" },
            correct: ["epeqgpepds"],
            wrong: ["epeqgpeperes", "epeqgpepfsbs", "gpep", "ereseqds", "eresepeq", "dses", "fsds"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-21",
        chapterId: "beginner-level4",
        order: 230,
        title: { zh: "手筋 · 21/22", en: "Tesuji · 21/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "docobobpfoepdqdrdl", white: "bqcqcrcpdpeoar" },
            correct: ["eqener"],
            wrong: ["fpeqfqen", "enfq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-1-22",
        chapterId: "beginner-level4",
        order: 231,
        title: { zh: "手筋 · 22/22", en: "Tesuji · 22/22" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crbqcpdpeqfqgrhqirioaq", white: "hrgqgpfpepdocobpbnen" },
            correct: ["frhsdq", "dqcqfr"],
            wrong: ["frhserdqdrcqcsbs", "dqcqerfr", "dqcqdrer"],
        },
    },
];

const bl4Capture2Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capture-2-1",
        chapterId: "beginner-level4",
        order: 232,
        title: { zh: "手筋 · 1/20", en: "Tesuji · 1/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cscrcqbqcpcocncmaohqho", white: "brasaraqbpbobnbmcldlfl" },
            correct: ["apanapaobsapbl", "blbkapanapaobs"],
            wrong: ["bsap"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-2",
        chapterId: "beginner-level4",
        order: 233,
        title: { zh: "手筋 · 2/20", en: "Tesuji · 2/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobncmcpdpepfphoio", white: "bpbqcqdqeqgqhqdococnemgmdlbk" },
            correct: ["en"],
            wrong: ["eodn", "dneoenfogofn", "dneoenfofngogpgn", "dneoenfofngogngp", "dneofoen", "dmen", "fnen"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-3",
        chapterId: "beginner-level4",
        order: 234,
        title: { zh: "手筋 · 3/20", en: "Tesuji · 3/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdrerfqfpbpbohqbq", white: "eqdqcpdodmckfn" },
            correct: ["dpepeodpdn"],
            wrong: ["epdp", "codp", "eodpdncnencocmbm", "eodpdncnencobnbm", "eodpdncncoen"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-4",
        chapterId: "beginner-level4",
        order: 235,
        title: { zh: "手筋 · 4/20", en: "Tesuji · 4/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "araqbrcqdqdpdodncngp", white: "bqbpcpcobncmdmenfmbkck" },
            correct: ["boaoapbobm"],
            wrong: ["apbo", "bmbo"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-5",
        chapterId: "beginner-level4",
        order: 236,
        title: { zh: "手筋 · 5/20", en: "Tesuji · 5/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsaqbqcqdqdrdm", white: "crbrardserfrgqgo" },
            correct: ["csascs"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-6",
        chapterId: "beginner-level4",
        order: 237,
        title: { zh: "手筋 · 6/20", en: "Tesuji · 6/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcncobobpdpep", white: "bqcqcpdodncmblamergq" },
            correct: ["dmbnen"],
            wrong: ["cldm", "bndl"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-7",
        chapterId: "beginner-level4",
        order: 238,
        title: { zh: "手筋 · 7/20", en: "Tesuji · 7/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpbobncqdrcmcleock", white: "crdqercncocpdmendlgmgq" },
            correct: ["dpdsdn"],
            wrong: ["dpdsdodn", "dpdseqdn", "eqdp", "dndo", "dodn"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-8",
        chapterId: "beginner-level4",
        order: 239,
        title: { zh: "手筋 · 8/20", en: "Tesuji · 8/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqbpbocodndmdpepfpdlfk", white: "dqcpcqcrfqgqdoeofncnbnclhmckip" },
            correct: ["eqerdrdscsdrfr"],
            wrong: ["eqercsdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-9",
        chapterId: "beginner-level4",
        order: 240,
        title: { zh: "手筋 · 9/20", en: "Tesuji · 9/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqcpbobnbmerfrgrhqcldogpiq", white: "cocncmdpepeqfqgqeohpgohmipflek" },
            correct: ["dmdnendofo"],
            wrong: ["dndmenfn", "endmfodn", "fofn"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-10",
        chapterId: "beginner-level4",
        order: 241,
        title: { zh: "手筋 · 10/20", en: "Tesuji · 10/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcrdrdqdpcoeoenfpiq", white: "brbscqcpbpdodnck" },
            correct: ["boaqdmcnbncmcl", "dmcnboaqbncmcl"],
            wrong: ["cndm", "cmdm"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-11",
        chapterId: "beginner-level4",
        order: 242,
        title: { zh: "手筋 · 11/20", en: "Tesuji · 11/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpbobncpdqeqfpgpfqiphm", white: "cqcrbqdrerfrgqhqepdpcodmfmck" },
            correct: ["eododn"],
            wrong: ["doeo", "cndndoeo", "dneoenfofngohpgngmcnemcm", "endn"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-12",
        chapterId: "beginner-level4",
        order: 243,
        title: { zh: "手筋 · 12/20", en: "Tesuji · 12/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqdpepfpgphqhpbpirdm", white: "dqeqfqgqcrhriqjrjp" },
            correct: ["grisfr"],
            wrong: ["grisdrfr", "dris"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-13",
        chapterId: "beginner-level4",
        order: 244,
        title: { zh: "手筋 · 13/20", en: "Tesuji · 13/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqeqcpbofres", white: "cmbncodpepfqgrhq" },
            correct: ["fpgqdo", "docnfp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-14",
        chapterId: "beginner-level4",
        order: 245,
        title: { zh: "手筋 · 14/20", en: "Tesuji · 14/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqcpdqercodoeoem", white: "cqcrdrbpbocncmeqckgq" },
            correct: ["dsdpcsdqfq", "csdpdsdqfq"],
            wrong: ["fqfrepes", "fqfresdp", "frfq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-15",
        chapterId: "beginner-level4",
        order: 246,
        title: { zh: "手筋 · 15/20", en: "Tesuji · 15/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcrdrbobncmdmemfofpdogm", white: "cocndndpdqerfqgqiq" },
            correct: ["cpeoendoeq", "eqepcpeoen"],
            wrong: ["encp", "eocp", "epeqcpeo", "epeqeocp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-16",
        chapterId: "beginner-level4",
        order: 247,
        title: { zh: "手筋 · 16/20", en: "Tesuji · 16/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpdqeqfqfngogpgm", white: "dpcocqbqcmfpfogqgrdl" },
            correct: ["doeodncpep"],
            wrong: ["eoepcpdo", "eoepdocp", "epeo", "cpdoaqbo", "cpdobobn", "endo", "aqcp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-17",
        chapterId: "beginner-level4",
        order: 248,
        title: { zh: "手筋 · 17/20", en: "Tesuji · 17/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdqeqcocnbnbmbpaodmgq", white: "dndodpcmclblcqbqarcrbsaqdkgl" },
            correct: ["emfoeoenfnepfp"],
            wrong: ["enem", "epem"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-18",
        chapterId: "beginner-level4",
        order: 249,
        title: { zh: "手筋 · 18/20", en: "Tesuji · 18/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcndndodpdqcrerelhp", white: "brcqcpcobncmblcldk" },
            correct: ["boambq"],
            wrong: ["bqbp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-19",
        chapterId: "beginner-level4",
        order: 250,
        title: { zh: "手筋 · 19/20", en: "Tesuji · 19/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqcodreqepeodmcmfrfm", white: "brcrdqdpcpbocn" },
            correct: ["bpdodncobn", "bpdodncoao"],
            wrong: ["dobp", "bndo", "dnbp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-2-20",
        chapterId: "beginner-level4",
        order: 251,
        title: { zh: "手筋 · 20/20", en: "Tesuji · 20/20" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbrcrdrdscqdpdodncnckekgl", white: "bsbqcpcobncmesereqdqepenemhp" },
            correct: ["bobpapaoaqbobm", "bobpaqaoapbobm"],
            wrong: ["bpbo", "aqdm"],
        },
    },
];

const bl4Capture3Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capture-3-1",
        chapterId: "beginner-level4",
        order: 252,
        title: { zh: "手筋 · 1/20", en: "Tesuji · 1/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "erdqcpbqaqbpcn", white: "arbrcrdrcq" },
            correct: ["eqdpfr"],
            wrong: ["dpeq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-2",
        chapterId: "beginner-level4",
        order: 253,
        title: { zh: "手筋 · 2/20", en: "Tesuji · 2/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqfqfpeoelfmhl", white: "dqdrerepcpcmclgpgqgr" },
            correct: ["fodpfrepen"],
            wrong: ["fodpfrepdoen", "fodpdoen", "fodpengo", "frfo", "dpfo"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-3",
        chapterId: "beginner-level4",
        order: 254,
        title: { zh: "手筋 · 3/20", en: "Tesuji · 3/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqcpdqepdofofnemgpgqgrglir", white: "brbqbpcocndmelcldreqfqfpgohnhpiq" },
            correct: ["csdpeoendneofm"],
            wrong: ["csdpeoendneognfm", "csdpeoendneogmer", "csdpeoenfmer", "csdpdneo", "fmer", "ener"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-4",
        chapterId: "beginner-level4",
        order: 255,
        title: { zh: "手筋 · 4/20", en: "Tesuji · 4/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdqepfqfrgshrhqcocncmdlckelfofniofl", white: "bqcpeqfpgpgqgreododndmgohnbobn" },
            correct: ["drercqeqes"],
            wrong: ["erfs", "cqdr", "fmem", "gnem"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-5",
        chapterId: "beginner-level4",
        order: 256,
        title: { zh: "手筋 · 5/20", en: "Tesuji · 5/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqdofqdmdlenfngmhpdkbmip", white: "epdncnemfmgnhnfkin" },
            correct: ["foeodpcobocpcq"],
            wrong: ["foeodpcobocpbpcq", "foeodpcocpbo", "foeocodp", "eofo", "glco", "hmco"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-6",
        chapterId: "beginner-level4",
        order: 257,
        title: { zh: "手筋 · 6/20", en: "Tesuji · 6/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqereqdqcpcodnhqhohm", white: "cqcrdrbpbocnbndmemfqfpcl" },
            correct: ["dpdoeoependpfr", "dpdoeoependpesfrgr"],
            wrong: ["dpdoeneo", "dodp", "ends", "aqcs", "bsds", "epdp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-7",
        chapterId: "beginner-level4",
        order: 258,
        title: { zh: "手筋 · 7/20", en: "Tesuji · 7/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqeqfqcpcododmfngo", white: "cqbqbpbodrerfrgqdpbnhqio" },
            correct: ["fpepeodpdn"],
            wrong: ["epfp", "eofp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-8",
        chapterId: "beginner-level4",
        order: 259,
        title: { zh: "手筋 · 8/20", en: "Tesuji · 8/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcrdsesdpdofphqirhp", white: "csbsbrbqbpdrcocndlfnhn" },
            correct: ["erfsgr"],
            wrong: ["erfsfrgs", "frer", "fser", "dqcp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-9",
        chapterId: "beginner-level4",
        order: 260,
        title: { zh: "手筋 · 9/20", en: "Tesuji · 9/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdpdodnbmckdkeqerfphpbk", white: "crdrdqcpcodleneoepgn" },
            correct: ["cm"],
            wrong: ["cndmemcm", "cndmcmem", "dmcn", "brbp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-10",
        chapterId: "beginner-level4",
        order: 261,
        title: { zh: "手筋 · 10/20", en: "Tesuji · 10/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpeqfr", white: "bqcqdqer" },
            correct: ["fqepgr"],
            wrong: ["epfq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-11",
        chapterId: "beginner-level4",
        order: 262,
        title: { zh: "手筋 · 11/20", en: "Tesuji · 11/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqapaobobncndncpcqdreqfrdl", white: "arbrbqbpcodoeodqfqfpgrhqfm" },
            correct: ["crdpepdqds"],
            wrong: ["dpcr", "epcr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-12",
        chapterId: "beginner-level4",
        order: 263,
        title: { zh: "手筋 · 12/20", en: "Tesuji · 12/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrdrdqcpcoesfsfrfqgphqhoirhmfn", white: "cqbqcndpepfpeqergqgrdmdk" },
            correct: ["dscsgsdsar"],
            wrong: ["gsds", "bpbo", "dobp", "bobp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-13",
        chapterId: "beginner-level4",
        order: 264,
        title: { zh: "手筋 · 13/20", en: "Tesuji · 13/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqdqbqbsarbpaperfqfpgq", white: "bocpdpdreqepcnfoeohoiqir" },
            correct: ["frdsgr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-14",
        chapterId: "beginner-level4",
        order: 265,
        title: { zh: "手筋 · 14/20", en: "Tesuji · 14/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqbpcododpdqepgqfrer", white: "crcqcpbocnbmdneofogphqhogreqenap" },
            correct: ["drfqfpeqes", "drfqfpeqfs"],
            wrong: ["fpdr", "fqdr", "aqdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-15",
        chapterId: "beginner-level4",
        order: 266,
        title: { zh: "手筋 · 15/20", en: "Tesuji · 15/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeocpbpdqfngoergqhnhq", white: "bocodnenfoeqfqcqbqcnel" },
            correct: ["dpepfpdpdr"],
            wrong: ["dpepfpdpapdr", "epfp", "fpdp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-16",
        chapterId: "beginner-level4",
        order: 267,
        title: { zh: "手筋 · 16/20", en: "Tesuji · 16/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "erfrhqdqdpcpbocnaniodlbl", white: "apbpbqbrardrcqcseqepeoaogn" },
            correct: ["cododncocmbnbm"],
            wrong: ["doco", "dncocmbm", "gqgr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-17",
        chapterId: "beginner-level4",
        order: 268,
        title: { zh: "手筋 · 17/20", en: "Tesuji · 17/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqdqdpdoenfngohoerfqgqiq", white: "drcsbrbqcpcodnemfmcmbpgnfpgmdsbs" },
            correct: ["foeoeq"],
            wrong: ["eofo", "eqfo", "epeq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-18",
        chapterId: "beginner-level4",
        order: 269,
        title: { zh: "手筋 · 18/20", en: "Tesuji · 18/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpbpdoeocmbmfpgpgqfrhremgm", white: "cqdpepeqfqercocn" },
            correct: ["bobqbrcraqdqapcqcs", "bobqbrcraqdqapcqdr", "bobqbrcrapdqaqcqcs", "bobqbrcrapdqaqcqdr"],
            wrong: ["bobqapbr", "bobqcrao", "bqbo"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-19",
        chapterId: "beginner-level4",
        order: 270,
        title: { zh: "手筋 · 19/20", en: "Tesuji · 19/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqdqeqepgqaqapaobocodoblcndmbm", white: "csbrarbqbpcpdperdrhqeofnfldn" },
            correct: ["fqfpgpfrfofqgr", "fqfpgpfrfofqfs"],
            wrong: ["fqfpgpfrgrbs", "fqfpfogp", "fpfq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-3-20",
        chapterId: "beginner-level4",
        order: 271,
        title: { zh: "手筋 · 20/20", en: "Tesuji · 20/20" },
        instruction: { zh: "白先。尽可能多地吃掉黑棋。", en: "White to play. Capture as many black stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdrdqepfpgqgrcogn", white: "dpdocnbocqeqerfrdn" },
            correct: ["brbqcscpdscqaq", "brbqcscpdscqbp", "brbqdscpcscqbp", "brbqdscpcscqaq"],
            wrong: ["dsbr", "csbr", "bqes"],
        },
    },
];

const bl4Capture4Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capture-4-1",
        chapterId: "beginner-level4",
        order: 272,
        title: { zh: "手筋 · 1/16", en: "Tesuji · 1/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqcodoepeqer", white: "crbqcpdpeoenfpfqfrgn" },
            correct: ["bpdqdrcqaq", "bpdqdrcqcs"],
            wrong: ["drbo", "dqbp", "bodr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-2",
        chapterId: "beginner-level4",
        order: 273,
        title: { zh: "手筋 · 2/16", en: "Tesuji · 2/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cscrerdqbqbpcncodnengn", white: "brardrcqcpdpdobobncmfpclhp" },
            correct: ["epeqeodqfq"],
            wrong: ["dsfo", "eoep"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-3",
        chapterId: "beginner-level4",
        order: 274,
        title: { zh: "手筋 · 3/16", en: "Tesuji · 3/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "grgqipiognfpdpepdqcpbpdmim", white: "bqcqdreqfqfrgphpiqjqjp" },
            correct: ["gserhq"],
            wrong: ["fser", "eres", "hqgs", "crbr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-4",
        chapterId: "beginner-level4",
        order: 275,
        title: { zh: "手筋 · 4/16", en: "Tesuji · 4/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fsgsgrgqgpfoeodocpdqhn", white: "bqbpbocqdresfrfqfpepcm" },
            correct: ["ereqdpercr"],
            wrong: ["eqer", "dper"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-5",
        chapterId: "beginner-level4",
        order: 276,
        title: { zh: "手筋 · 5/16", en: "Tesuji · 5/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "csdresfsfrfqepfododndl", white: "bscrereqdqdpcocncmck" },
            correct: ["cqdscpdrbr"],
            wrong: ["cpcq", "dsbq", "brds"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-6",
        chapterId: "beginner-level4",
        order: 277,
        title: { zh: "手筋 · 6/16", en: "Tesuji · 6/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fqfpepcsbsbrbqbpcpfrfsgognhp", white: "dpcqcrcoboeofodsereqclem" },
            correct: ["dqdres"],
            wrong: ["esdq", "drdq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-7",
        chapterId: "beginner-level4",
        order: 278,
        title: { zh: "手筋 · 7/16", en: "Tesuji · 7/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcpdoeodqbpcnfpdl", white: "cqcrfogphofneqepdpiqfl" },
            correct: ["erdrfq"],
            wrong: ["drer", "fqer", "brdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-8",
        chapterId: "beginner-level4",
        order: 279,
        title: { zh: "手筋 · 8/16", en: "Tesuji · 8/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcsdrdqcqepfpgqen", white: "bpcpdpgphqhrhsgoipcmdleqer" },
            correct: ["frfsesdsfq"],
            wrong: ["frfsfqes", "esfr", "fqfr", "grgs"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-9",
        chapterId: "beginner-level4",
        order: 280,
        title: { zh: "手筋 · 9/16", en: "Tesuji · 9/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdreqbpbobncmdmgqbr", white: "dqcpcocneogofm" },
            correct: ["dodpepdnen"],
            wrong: ["dodpdnep", "dpdo", "dndp"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-10",
        chapterId: "beginner-level4",
        order: 281,
        title: { zh: "手筋 · 10/16", en: "Tesuji · 10/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crdrbqapaobodpdncn", white: "bpcpcododqbnbmcmdkhq" },
            correct: ["eoepcqdpfp"],
            wrong: ["eoepcqdpeqfp", "eoepfpen", "epen", "cqeo", "eneo", "eqen"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-11",
        chapterId: "beginner-level4",
        order: 282,
        title: { zh: "手筋 · 11/16", en: "Tesuji · 11/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqbpcododp", white: "bocnbmcpcqdqcrgqhpdlao" },
            correct: ["eqerdrdscsdrfr"],
            wrong: ["eqercsdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-12",
        chapterId: "beginner-level4",
        order: 283,
        title: { zh: "手筋 · 12/16", en: "Tesuji · 12/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbsdpbqcrdrerfqfpfofnen", white: "frgrhqeqdqcqcpdmbnemfmgmhoineodn" },
            correct: ["codoep", "cobobp", "cobpboepdo", "cobpbodoep"],
            wrong: ["bpco", "doco", "boco", "epco"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-13",
        chapterId: "beginner-level4",
        order: 284,
        title: { zh: "手筋 · 13/16", en: "Tesuji · 13/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "enfrfqbsbrbqbpdoeoepco", white: "bocndndpcpcqcrerfsgrgqgpdlelhnbmgs" },
            correct: ["drdscsdqeq"],
            wrong: ["drdsdqeq", "drdseqcs", "dqeq", "eqcs", "cseq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-14",
        chapterId: "beginner-level4",
        order: 285,
        title: { zh: "手筋 · 14/16", en: "Tesuji · 14/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbqbpcpdoeocnfpdl", white: "brcrcqdpepfogogqfmhq" },
            correct: ["dqeqerdrfq"],
            wrong: ["eqdq", "fqer", "erdq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-15",
        chapterId: "beginner-level4",
        order: 286,
        title: { zh: "手筋 · 15/16", en: "Tesuji · 15/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drcrcqcpcodnenepfnfl", white: "bpbocndodpdqeqgognbmhqbqhl" },
            correct: ["fqerfreofofpes"],
            wrong: ["eofq", "erfq", "fpfq", "frfq"],
        },
    },
    {
        id: "beginner-level4-bl4-capture-4-16",
        chapterId: "beginner-level4",
        order: 287,
        title: { zh: "手筋 · 16/16", en: "Tesuji · 16/16" },
        instruction: { zh: "黑先。尽可能多地提掉白棋棋子。", en: "Black to play. Capture as many white stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqbpdocoeqenfnfl", white: "bocnbncpcqcrerdmgpgqgrhndl" },
            correct: ["drdqdpdscs", "drdqcsdsdp"],
            wrong: ["csdr", "dqdr", "dpdr"],
        },
    },
];

const bl4Connect1Levels: Level[] = [
    {
        id: "beginner-level4-bl4-connect-1-1",
        chapterId: "beginner-level4",
        order: 288,
        title: { zh: "手筋 · 1/14", en: "Tesuji · 1/14" },
        instruction: { zh: "有几种手筋可以下方连接（日语称为'渡'）。这是一种利用小飞的连接手筋。黑棋在A点落子，可以连接自己的棋子。黑先。连接黑棋棋子。", en: "There are several tesuji's to connect underneath ('watari' in Japanese). This is a connect tesuji using a knight's move. By playing at A, Black can connect their stones. Black to play. Connect the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpgqhq", white: "cnenepfpgnipiq" },
            marks: { A: "er" },
            correct: ["ereqdrdqcq"],
            wrong: ["eqfqfrer", "ereqdqfr"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-2",
        chapterId: "beginner-level4",
        order: 289,
        title: { zh: "手筋 · 2/14", en: "Tesuji · 2/14" },
        instruction: { zh: "另一种连接手筋是斜飞（日语称为'小尖'）。黑棋在A点落子，可以连接自己的棋子。黑先。连接黑棋棋子。", en: "Another connect tesuji is the diagonal ('kosumi' in Japanese). By playing at A, Black can connect their stones. Black to play. Connect the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqdrhrioiq", white: "bpcpdpeoeqfqgq" },
            marks: { A: "es" },
            correct: ["esgrgs"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-3",
        chapterId: "beginner-level4",
        order: 290,
        title: { zh: "手筋 · 3/14", en: "Tesuji · 3/14" },
        instruction: { zh: "第三种连接手筋是夹（日语称为'ハサミ付き'）。黑棋在A点落子，可以连接自己的棋子。黑先。连接黑棋棋子。", en: "A third connect tesuji is the clamp ('hasami tsuke' in Japanese). By playing at A, Black can connect their stones. Black to play. Connect the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codqdrhqhr", white: "eperfpgphpiqir" },
            marks: { A: "fr" },
            correct: ["freqes"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-4",
        chapterId: "beginner-level4",
        order: 291,
        title: { zh: "手筋 · 4/14", en: "Tesuji · 4/14" },
        instruction: { zh: "有时可以利用气紧来下方连接。如果黑棋在A点落子，白棋由于气紧而无法在B点应答。黑先。连接黑棋棋子。", en: "You can sometimes use shortage of liberties to connect underneath. If Black plays at A, White can not respond at B, due to a shortage of liberties. Black to play. Connect the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bscpcqcrdmdndpfrgrhq", white: "csdqdreneperfqhmhohpirjpjq" },
            marks: { A: "es", B: "ds" },
            correct: ["es"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-5",
        chapterId: "beginner-level4",
        order: 292,
        title: { zh: "手筋 · 5/14", en: "Tesuji · 5/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drcrcqdncndlem", white: "ereqdqcpdoenfnhq" },
            correct: ["bpbocodpbq", "bpbocodpaq", "bpbocodpbr", "bpbocodpar"],
            wrong: ["bpbocodpbnbqaobr", "bobp", "apbo", "bnbp", "bqbp"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-6",
        chapterId: "beginner-level4",
        order: 293,
        title: { zh: "手筋 · 6/14", en: "Tesuji · 6/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeoengoeqdqinfl", white: "crcqdpepcodndmckgqiq" },
            correct: ["fpcpfq"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-7",
        chapterId: "beginner-level4",
        order: 294,
        title: { zh: "手筋 · 7/14", en: "Tesuji · 7/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqcperfrfqfpfoiq", white: "bpbocncqcrdrdpepeqendl" },
            correct: ["ds"],
            wrong: ["csds", "escs"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-8",
        chapterId: "beginner-level4",
        order: 295,
        title: { zh: "手筋 · 8/14", en: "Tesuji · 8/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqeqfqhpcpbpbmcmdmdnfl", white: "bqcqdrerdpdocnbneneognim" },
            correct: ["aoanco"],
            wrong: ["anao", "apcoanaoboaq", "boan", "coap"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-9",
        chapterId: "beginner-level4",
        order: 296,
        title: { zh: "手筋 · 9/14", en: "Tesuji · 9/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fpepdpbrbscsaobocodrer", white: "cpdocnbnancrcqdsesfsfrgqgpdnhofn" },
            correct: ["aq"],
            wrong: ["bqbp", "bpbq"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-10",
        chapterId: "beginner-level4",
        order: 297,
        title: { zh: "手筋 · 10/14", en: "Tesuji · 10/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crbrbqbpbobncmclfq", white: "cqcpcodndldkdrhqhohmfn" },
            correct: ["erdsdq"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-11",
        chapterId: "beginner-level4",
        order: 298,
        title: { zh: "手筋 · 11/14", en: "Tesuji · 11/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqcqcmcldk", white: "dpepeqfrhqdnfn" },
            correct: ["bo"],
            wrong: ["bpbo", "bnbo", "cncp", "cpcn", "cocpbpbobnbq"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-12",
        chapterId: "beginner-level4",
        order: 299,
        title: { zh: "手筋 · 12/14", en: "Tesuji · 12/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcpcoepdrcm", white: "crdqdperfohpgqfm" },
            correct: ["doeqeo"],
            wrong: ["eqdo"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-13",
        chapterId: "beginner-level4",
        order: 300,
        title: { zh: "手筋 · 13/14", en: "Tesuji · 13/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gngqgrbqbpcrdrgseripbocmjqjrhp", white: "cqdqcoemfpeqeohqfrhrhsgp" },
            correct: ["es"],
            wrong: ["fsesfqfr", "fsesdsfqesbr", "fqfs"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-1-14",
        chapterId: "beginner-level4",
        order: 301,
        title: { zh: "手筋 · 14/14", en: "Tesuji · 14/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpcqdqgqip", white: "dpdocoeqfpcl" },
            correct: ["erfrfq"],
            wrong: ["frer", "drer", "eserfrdr", "eserdrfs", "fseresdr", "grer", "dseresfr"],
        },
    },
];

const bl4Connect2Levels: Level[] = [
    {
        id: "beginner-level4-bl4-connect-2-1",
        chapterId: "beginner-level4",
        order: 302,
        title: { zh: "手筋 · 1/14", en: "Tesuji · 1/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcsfrfqfpapbpcodobnfn", white: "bsbrarbqcqcpdpeq" },
            correct: ["es"],
            wrong: ["erdr", "dses", "drer"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-2",
        chapterId: "beginner-level4",
        order: 303,
        title: { zh: "手筋 · 2/14", en: "Tesuji · 2/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqcqereqgrgqip", white: "crdrdqepfpcpbpcmgn" },
            correct: ["ds"],
            wrong: ["csds", "esds"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-3",
        chapterId: "beginner-level4",
        order: 304,
        title: { zh: "手筋 · 3/14", en: "Tesuji · 3/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqcrckcmemfk", white: "drdqcpdoeogpiq" },
            correct: ["bobpap"],
            wrong: ["anapbpboaobn", "anapbpbobnao", "bpbo", "bnbp"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-4",
        chapterId: "beginner-level4",
        order: 305,
        title: { zh: "手筋 · 4/14", en: "Tesuji · 4/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcpeqepeocl", white: "crdqdpdnergqhqen" },
            correct: ["dodrcn"],
            wrong: ["dodrcocn"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-5",
        chapterId: "beginner-level4",
        order: 306,
        title: { zh: "手筋 · 5/14", en: "Tesuji · 5/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqbpgqgrgscncl", white: "cqdqeqfqgphpiqireofm" },
            correct: ["esdsdrercs"],
            wrong: ["esdsdrerfscr", "esdscsdr", "cses", "dscscres", "crdr", "erdr", "drfrfsesercr"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-6",
        chapterId: "beginner-level4",
        order: 307,
        title: { zh: "手筋 · 6/14", en: "Tesuji · 6/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdqcnanbmblclek", white: "bpcpdpeqdrgpeodndmcmbngm" },
            correct: ["ap"],
            wrong: ["boap"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-7",
        chapterId: "beginner-level4",
        order: 308,
        title: { zh: "手筋 · 7/14", en: "Tesuji · 7/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpcpdmdlfk", white: "dodnfnfofqdr" },
            correct: ["bnbococnbm", "bnbobpcnbm"],
            wrong: ["bnbococncmbm", "bnbocnco", "bnbobpcncmbm", "bnbobpcncobm", "bnbobpcnaobm", "cocn", "cncobobn", "bobncncocmbp"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-8",
        chapterId: "beginner-level4",
        order: 309,
        title: { zh: "手筋 · 8/14", en: "Tesuji · 8/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dsdrdqcpcobqhshrhqcmcl", white: "frgqeqepdphpgpgndndmiqirio" },
            correct: ["fs"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-9",
        chapterId: "beginner-level4",
        order: 310,
        title: { zh: "手筋 · 9/14", en: "Tesuji · 9/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdreqepgqclcmip", white: "dpcpeodndlckekglgo" },
            correct: ["bobpap"],
            wrong: ["anbobpao", "anboaobmbncnblap", "anboaobmbncnbpbl", "anbobnao", "bpbo", "bnbp", "aobpapbncnbo"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-10",
        chapterId: "beginner-level4",
        order: 311,
        title: { zh: "手筋 · 10/14", en: "Tesuji · 10/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "erfqepdpcpbpdm", white: "bqcqdqdreqfriqio" },
            correct: ["gresgp"],
            wrong: ["gpgr", "fpgr", "fogr"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-11",
        chapterId: "beginner-level4",
        order: 312,
        title: { zh: "手筋 · 11/14", en: "Tesuji · 11/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcrcsfrgqfpeodocnbnhoiqhq", white: "bsbrbqbpcpdpeqfq" },
            correct: ["eserds"],
            wrong: ["erdrdsesdqdr", "erdrdsesfsdqesgr", "dreresgrfsgs"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-12",
        chapterId: "beginner-level4",
        order: 313,
        title: { zh: "手筋 · 12/14", en: "Tesuji · 12/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqbqdncmbmemgndk", white: "cpcocndqdrdpgphq" },
            correct: ["anaobo", "anapbp", "apanbn"],
            wrong: ["aoapbpan", "bpbo", "bnbo", "bobpapbnanao"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-13",
        chapterId: "beginner-level4",
        order: 314,
        title: { zh: "手筋 · 13/14", en: "Tesuji · 13/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drdqcqdpcmcl", white: "cpdoeoepdkdldmfrck" },
            correct: ["bobncncobp"],
            wrong: ["bpcnbnbmblboamao", "cocn", "bnbo"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-2-14",
        chapterId: "beginner-level4",
        order: 315,
        title: { zh: "手筋 · 14/14", en: "Tesuji · 14/14" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqcpdpeperfqhpgqfn", white: "crdrdqbqbpbocncl" },
            correct: ["bsards"],
            wrong: ["dsbs", "csds"],
        },
    },
];

const bl4Connect3Levels: Level[] = [
    {
        id: "beginner-level4-bl4-connect-3-1",
        chapterId: "beginner-level4",
        order: 316,
        title: { zh: "手筋 · 1/24", en: "Tesuji · 1/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpbpbqdneneodqeqergriqhoco", white: "brarcrdrcqdpdocnbnfldmcmck" },
            correct: ["ap"],
            wrong: ["aqap"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-2",
        chapterId: "beginner-level4",
        order: 317,
        title: { zh: "手筋 · 2/24", en: "Tesuji · 2/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpepfpgqhqcmdmemfmhlfkfrbp", white: "cocnengngogpipimhm" },
            correct: ["eo"],
            wrong: ["dnfnfoeo", "fndndoeo", "dofnfoeo", "fodndoeo"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-3",
        chapterId: "beginner-level4",
        order: 318,
        title: { zh: "手筋 · 3/24", en: "Tesuji · 3/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodpdqenemeleriqiohm", white: "drcrcqcpcndmdlgq" },
            correct: ["freseq"],
            wrong: ["esfr", "fses", "dses", "gres"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-4",
        chapterId: "beginner-level4",
        order: 319,
        title: { zh: "手筋 · 4/24", en: "Tesuji · 4/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqcpbpdpbneqerfoem", white: "aqbqbrcsdrdqfrgqhqho" },
            correct: ["esdsdr"],
            wrong: ["dses", "fsds"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-5",
        chapterId: "beginner-level4",
        order: 320,
        title: { zh: "手筋 · 5/24", en: "Tesuji · 5/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocpdpdoeoendlblflgn", white: "cqbqbpdqepdncnfphp" },
            correct: ["bnaoco"],
            wrong: ["cobn", "aobn"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-6",
        chapterId: "beginner-level4",
        order: 321,
        title: { zh: "手筋 · 6/24", en: "Tesuji · 6/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eogpdmbmfmaqbpcqcrbsarhpgnip", white: "cpbodqdrfqgqhqir" },
            correct: ["do"],
            wrong: ["frdp", "dpco", "epco", "eqdp", "codp", "fpdp", "cndp"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-7",
        chapterId: "beginner-level4",
        order: 322,
        title: { zh: "手筋 · 7/24", en: "Tesuji · 7/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdqdrdncl", white: "bsbrbqfqfrfsfoiq" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-8",
        chapterId: "beginner-level4",
        order: 323,
        title: { zh: "手筋 · 8/24", en: "Tesuji · 8/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqeqfqeofofmgnipiqirhn", white: "crcqcpgpgqgrdndmdk" },
            correct: ["fsdrds", "dsfrfs"],
            wrong: ["esdsdrfs"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-9",
        chapterId: "beginner-level4",
        order: 324,
        title: { zh: "手筋 · 9/24", en: "Tesuji · 9/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpbobncldlfleneqfqgqeobl", white: "bqcqdqerfranbmcmcnhr" },
            correct: ["bpaocoamap"],
            wrong: ["aoapbpamcoan", "apao"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-10",
        chapterId: "beginner-level4",
        order: 325,
        title: { zh: "手筋 · 10/24", en: "Tesuji · 10/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpbpbqdocncmdlfpgpioim", white: "crcqdpdneneqfqhrgmgk" },
            correct: ["eocoep"],
            wrong: ["epeo"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-11",
        chapterId: "beginner-level4",
        order: 326,
        title: { zh: "手筋 · 11/24", en: "Tesuji · 11/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrbqbpcpdpeqfq", white: "cqcrcsgqfrfpeodocnbngpiq" },
            correct: ["esdser"],
            wrong: ["esdsdrergrdq", "esdsdrergsdq", "esdsdrerfsdqdsgr", "esdsdrerhrdq", "esdsdrerdsdqfsgr", "erdrdsdqesgr", "fsdrdseserdqesgr"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-12",
        chapterId: "beginner-level4",
        order: 327,
        title: { zh: "手筋 · 12/24", en: "Tesuji · 12/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqcqdqdpfpfqercmaq", white: "bsbrcrdrdsfrhqhphn" },
            correct: ["fsgrgq"],
            wrong: ["esgrfsgq", "esgreqgq", "gres", "gses"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-13",
        chapterId: "beginner-level4",
        order: 328,
        title: { zh: "手筋 · 13/24", en: "Tesuji · 13/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpbpdoeodqeqerhqgo", white: "drcrcqdpcobocndncl" },
            correct: ["apepbq"],
            wrong: ["bqap", "aqap"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-14",
        chapterId: "beginner-level4",
        order: 329,
        title: { zh: "手筋 · 14/24", en: "Tesuji · 14/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqcpcocneqeofqgrgphpiqirisio", white: "bqcqdrerfrbpbohqhrhs" },
            correct: ["fs"],
            wrong: ["gsfsgqgr", "gsfsesgqfscr", "gqgs"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-15",
        chapterId: "beginner-level4",
        order: 330,
        title: { zh: "手筋 · 15/24", en: "Tesuji · 15/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcodpdnepfpeqdrcl", white: "cscrcqcpfqgqgpgoiqgm" },
            correct: ["erdqdsfres"],
            wrong: ["dses", "frds", "esds", "dqfr"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-16",
        chapterId: "beginner-level4",
        order: 331,
        title: { zh: "手筋 · 16/24", en: "Tesuji · 16/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrdqdperdnenfngqhqfmfl", white: "eqcqcpepeodmemgpgognck" },
            correct: ["dodrcn"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-17",
        chapterId: "beginner-level4",
        order: 332,
        title: { zh: "手筋 · 17/24", en: "Tesuji · 17/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqercpbpboeqeohp", white: "bqcqcrdrapcoclckfl" },
            correct: ["bndpao"],
            wrong: ["aobn", "anbnbmaodpcn", "anbnaoam"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-18",
        chapterId: "beginner-level4",
        order: 333,
        title: { zh: "手筋 · 18/24", en: "Tesuji · 18/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpcrdqepeocm", white: "bsbrbqeqfpfqgnhq" },
            correct: ["drcscq"],
            wrong: ["csds", "ercs", "dscs", "cqer"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-19",
        chapterId: "beginner-level4",
        order: 334,
        title: { zh: "手筋 · 19/24", en: "Tesuji · 19/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcldlelfmfneogoereqdpgrco", white: "drcrcqcpdoenemdmcmes" },
            correct: ["bodncn"],
            wrong: ["cnbo", "bnbo"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-20",
        chapterId: "beginner-level4",
        order: 335,
        title: { zh: "手筋 · 20/24", en: "Tesuji · 20/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqepfohqhpho", white: "brbqcpfqgqcm" },
            correct: ["drereqcrdp", "drereqcrcq"],
            wrong: ["drercreq", "drercqeq", "drerfreqescrdscsfscq", "erdr", "esdrdserfrcs", "esdrdserfsfrgrcs", "esdrdsercsfr", "esdrdsercrfs", "csdr", "dser", "eqdrdpgs"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-21",
        chapterId: "beginner-level4",
        order: 336,
        title: { zh: "手筋 · 21/24", en: "Tesuji · 21/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqeqerdpcogp", white: "arbrcrdrdodncnbnfn" },
            correct: ["aqbpapaobo"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-22",
        chapterId: "beginner-level4",
        order: 337,
        title: { zh: "手筋 · 22/24", en: "Tesuji · 22/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpbpeqfpgrgqhqgodmgmepbn", white: "bqcqfqfrgshririqipin" },
            correct: ["dreresfsfr"],
            wrong: ["erdrdqes", "dsdrcres", "dsdrescr", "dsdrercrdqfsescs", "dsdrcses", "cses", "esdr"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-23",
        chapterId: "beginner-level4",
        order: 338,
        title: { zh: "手筋 · 23/24", en: "Tesuji · 23/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcodoenckdlekfkgn", white: "aqbqcqeqcncmclgp" },
            correct: ["boapcp", "bobnaoanap"],
            wrong: ["apao", "aoap", "cpbn"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-3-24",
        chapterId: "beginner-level4",
        order: 339,
        title: { zh: "手筋 · 24/24", en: "Tesuji · 24/24" },
        instruction: { zh: "白先。走出最佳连接。", en: "White to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcocndpepfpfneqdrdl", white: "cscrcqcpgpgqfqiqhn" },
            correct: ["erdsdq", "erfres"],
            wrong: ["erdsesdq", "esds", "dses"],
        },
    },
];

const bl4Connect4Levels: Level[] = [
    {
        id: "beginner-level4-bl4-connect-4-1",
        chapterId: "beginner-level4",
        order: 340,
        title: { zh: "手筋 · 1/16", en: "Tesuji · 1/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdqcrepdodncmcl", white: "dpcpcoeoeqfqerdrhpfn" },
            correct: ["bo"],
            wrong: ["aoboanbnambmblap", "aobobnap", "aoboapbn", "bnbo", "bpbo", "apbn", "anbn"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-2",
        chapterId: "beginner-level4",
        order: 341,
        title: { zh: "手筋 · 2/16", en: "Tesuji · 2/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcpdpepfqerdm", white: "arbrcqdqdrfrgrgqgpgn" },
            correct: ["dsfpeq"],
            wrong: ["eseq", "eqes", "fpeq"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-3",
        chapterId: "beginner-level4",
        order: 342,
        title: { zh: "手筋 · 3/16", en: "Tesuji · 3/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpcngqhqiqjqcl", white: "fqgphpipkqkpjnfn" },
            correct: ["eqfpfr"],
            wrong: ["freq", "erfr"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-4",
        chapterId: "beginner-level4",
        order: 343,
        title: { zh: "手筋 · 4/16", en: "Tesuji · 4/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqeqerfrcn", white: "dpepfqgqclelfpgriq" },
            correct: ["bpbococpbq"],
            wrong: ["bpbococpcqbq", "bpbocpcodobn", "cpcobocqdocr", "cpcobocqbpcr", "cpcodobobpbn", "bobpcpcqbqcr", "bobpcpcqcocr", "cqcp", "bqbpcpcocqbn"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-5",
        chapterId: "beginner-level4",
        order: 344,
        title: { zh: "手筋 · 5/16", en: "Tesuji · 5/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcqdqerfrgrcmcl", white: "eqfqhqdpcpbockbkdkemfkeogn" },
            correct: ["bnaoco"],
            wrong: ["aobn", "anao"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-6",
        chapterId: "beginner-level4",
        order: 345,
        title: { zh: "手筋 · 6/16", en: "Tesuji · 6/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcpcobobnfq", white: "cqdpdobmcndmbkfo" },
            correct: ["drcrdq"],
            wrong: ["crdrdqeq", "dqeqdrer", "erdrcreq"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-7",
        chapterId: "beginner-level4",
        order: 346,
        title: { zh: "手筋 · 7/16", en: "Tesuji · 7/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "apaobocodoeofpfqgrhqgndlaqcqcrcs", white: "arbrbsbqbpcpdpepeqfr" },
            correct: ["fseresdsdr"],
            wrong: ["erdr", "esdrdsfs"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-8",
        chapterId: "beginner-level4",
        order: 347,
        title: { zh: "手筋 · 8/16", en: "Tesuji · 8/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcqdrgqipiq", white: "cpbocodpbmgoeren" },
            correct: ["freqes"],
            wrong: ["eqdqfrcresbr", "eqdqcrfqfrepesgr", "fqeq"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-9",
        chapterId: "beginner-level4",
        order: 348,
        title: { zh: "手筋 · 9/16", en: "Tesuji · 9/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eofofqhpbmcmcldlerdqcqaqapbpekfkdsdp", white: "arbrbqcrdrcpcocnglendmdofm" },
            correct: ["an"],
            wrong: ["bobn", "aoan", "bnbo"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-10",
        chapterId: "beginner-level4",
        order: 349,
        title: { zh: "手筋 · 10/16", en: "Tesuji · 10/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpdqephq", white: "eqfpfoeocnbnho" },
            correct: ["frerfq"],
            wrong: ["erfr", "grfr"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-11",
        chapterId: "beginner-level4",
        order: 350,
        title: { zh: "手筋 · 11/16", en: "Tesuji · 11/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eqdqcqbqbmcnenemcmdk", white: "frfqfpfodpcobpbobngm" },
            correct: ["doeodnepcp"],
            wrong: ["epeo", "eoep", "cpdo"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-12",
        chapterId: "beginner-level4",
        order: 351,
        title: { zh: "手筋 · 12/16", en: "Tesuji · 12/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "asarbrbocodpeofpfqfrfsbm", white: "bscscrdqeqerescp" },
            correct: ["ap"],
            wrong: ["bpbq", "bqbpapcq", "aqap"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-13",
        chapterId: "beginner-level4",
        order: 352,
        title: { zh: "手筋 · 13/16", en: "Tesuji · 13/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "csbsbrbqbpcpdpgpgqgrhn", white: "araqapaobocodoepeqdqcqcrfodl" },
            correct: ["dseser"],
            wrong: ["esdsdras", "fsds", "erds"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-14",
        chapterId: "beginner-level4",
        order: 353,
        title: { zh: "手筋 · 14/16", en: "Tesuji · 14/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqfqfrgshririqip", white: "bpcpeqepfphqgqgrgpgnbn" },
            correct: ["dreresfsfr"],
            wrong: ["erdrdqes", "dsdrercsdqes", "dsdrercsesfs", "dsdrercscres", "dsdrdqes", "dsdrescr", "dsdrcres", "csdrdses"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-15",
        chapterId: "beginner-level4",
        order: 354,
        title: { zh: "手筋 · 15/16", en: "Tesuji · 15/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fmcndnaqbqcqdqerfrgrhqemhl", white: "drcreqfqdpdofoanhoinbmckarbr" },
            correct: ["bobpao"],
            wrong: ["bobpcpcoapbn", "bobpcocp", "cocpbpbo", "cocpbobp", "cocpapao", "cpcobobpapao", "bpbococp", "aocp", "apbo"],
        },
    },
    {
        id: "beginner-level4-bl4-connect-4-16",
        chapterId: "beginner-level4",
        order: 355,
        title: { zh: "手筋 · 16/16", en: "Tesuji · 16/16" },
        instruction: { zh: "黑先。走出最佳连接。", en: "Black to play. Play the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gmfmembqfoepbpcpdpim", white: "dqeqbrfpeogogpdmcmeldkbmbofrarcqfl" },
            correct: ["dnfnendoco"],
            wrong: ["dnfndoen", "fndo", "doen", "endo"],
        },
    },
];

const bl4Cut1Levels: Level[] = [
    {
        id: "beginner-level4-bl4-cut-1-1",
        chapterId: "beginner-level4",
        order: 356,
        title: { zh: "手筋 · 1/22", en: "Tesuji · 1/22" },
        instruction: { zh: "小飞（keima）是好形，但可能被切断。黑先。在A点落子是切断白棋小飞的最佳方式。如果黑棋在B点落子，白棋最终会形成好形。切断白棋棋子。", en: "The knight's move (keima) is good shape, but can be cut. Black to play. Playing at A is the best way to cut the white keima. If Black plays at B, White ends with good shape. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "dnfo" },
            marks: { A: "en", B: "eo" },
            correct: ["eneodocnem"],
            wrong: ["eoenfnfp"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-2",
        chapterId: "beginner-level4",
        order: 357,
        title: { zh: "手筋 · 2/22", en: "Tesuji · 2/22" },
        instruction: { zh: "在此局面下，在B点切断白棋的小飞更好。黑先。切断白棋棋子。", en: "In this position, it is better to cut the white keima at B. Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ep", white: "dnfo" },
            marks: { A: "en", B: "eo" },
            correct: ["eoenfn"],
            wrong: ["eneodo"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-3",
        chapterId: "beginner-level4",
        order: 358,
        title: { zh: "手筋 · 3/22", en: "Tesuji · 3/22" },
        instruction: { zh: "黑棋可以在A点落子，切断被标记的小飞形状。白棋无法下方连接。黑先。切断白棋棋子。", en: "Black can cut the marked knight's move shape by playing at A. White can not connect underneath. Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncocpcqdmdneneogm", white: "bmckcmcndodpeqgphqip" },
            marks: { A: "fq", triangle: "eqgp" },
            correct: ["fqfrerdrdqesep"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-4",
        chapterId: "beginner-level4",
        order: 359,
        title: { zh: "手筋 · 4/22", en: "Tesuji · 4/22" },
        instruction: { zh: "切断小飞并不总是成功。这里，白棋可以抵御黑棋的1。白先。抵御黑棋的切断。", en: "Cutting the knight's move does not always succeed. Here, White can defend against Black 1. White to play. Defend against the black cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbrcncpcqdoeoepfpfripiqjnkq", white: "bscrdpdqergqhmhohp" },
            marks: { 1: "fr" },
            correct: ["grfsfqeqdr"],
            wrong: ["fqeqdrgr"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-5",
        chapterId: "beginner-level4",
        order: 360,
        title: { zh: "手筋 · 5/22", en: "Tesuji · 5/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpep", white: "cqdqfq" },
            correct: ["eqerfrgrdrfscr", "eqerdrcrfr"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-6",
        chapterId: "beginner-level4",
        order: 361,
        title: { zh: "手筋 · 6/22", en: "Tesuji · 6/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqbpcocndngrfqhphnirclgq", white: "crdrerfrdpdoenfoemgl" },
            correct: ["epeodq"],
            wrong: ["dqeqepfp", "eqdq"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-7",
        chapterId: "beginner-level4",
        order: 362,
        title: { zh: "手筋 · 7/22", en: "Tesuji · 7/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbrcrdrcqanbncndnenfofpgn", white: "bqapcpcoboeodqeqergqhpip" },
            correct: ["dp"],
            wrong: ["fqfr", "epdp", "dodp"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-8",
        chapterId: "beginner-level4",
        order: 363,
        title: { zh: "手筋 · 8/22", en: "Tesuji · 8/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drdqcqcmdmdndodpgq", white: "crbrbqcocnbmclck" },
            correct: ["bpboaoanap"],
            wrong: ["bpboapcp", "bpbocpap", "bpboaqcp", "cpbp", "bobn"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-9",
        chapterId: "beginner-level4",
        order: 364,
        title: { zh: "手筋 · 9/22", en: "Tesuji · 9/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdrerfqfpcncmdk", white: "epeqdqcpbpfoengohp" },
            correct: ["doeodp"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-10",
        chapterId: "beginner-level4",
        order: 365,
        title: { zh: "手筋 · 10/22", en: "Tesuji · 10/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpdoeobrbqbpbscsfofrgogmcq", white: "dsdrdqcoboapdnencmhqhrepfqiocpcr" },
            correct: ["eseqgqgrgp", "eseqgqgpgr", "gqgreseqgp"],
            wrong: ["gqgrgpfs", "ereq", "grgq"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-11",
        chapterId: "beginner-level4",
        order: 366,
        title: { zh: "手筋 · 11/22", en: "Tesuji · 11/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdpepfpgqhpbp", white: "brcrdqeqgrhriq" },
            correct: ["freresdsfs"],
            wrong: ["freresdsfqfs", "frerfsfq", "frerfqfs", "frergsfq", "fqfr", "erfr"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-12",
        chapterId: "beginner-level4",
        order: 367,
        title: { zh: "手筋 · 12/22", en: "Tesuji · 12/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqeqercpcodogpdl", white: "dpephqhphofnhmbpbqcqdrcsbr" },
            correct: ["foeoen"],
            wrong: ["eofpfofq", "fpeo"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-13",
        chapterId: "beginner-level4",
        order: 368,
        title: { zh: "手筋 · 13/22", en: "Tesuji · 13/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcodoepfpgphpiqiocl", white: "irjrhqgqdpdqerkq" },
            correct: ["frgreqdrgs"],
            wrong: ["frgreqdrfsfq", "frgreqdresfq", "frgrfqfs", "frgrfsfq", "frgrgsfq", "frgresfq", "fqfr", "eqfr"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-14",
        chapterId: "beginner-level4",
        order: 369,
        title: { zh: "手筋 · 14/22", en: "Tesuji · 14/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbqcqdpeqepfqen", white: "csdrdqcpcocmfsgrhqhp" },
            correct: ["eserfrdscr"],
            wrong: ["esercrfr", "eres", "dses", "fres", "crer"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-15",
        chapterId: "beginner-level4",
        order: 370,
        title: { zh: "手筋 · 15/22", en: "Tesuji · 15/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodnfnbobncldrerfrgrhqiq", white: "cqcpcreqeogphpgnhngldsel" },
            correct: ["epdpfpfqfogqdq", "epfpdpdqfq", "epfpdpfqdq"],
            wrong: ["epdpfpfqdqfo", "epdpfpfqgqfo", "dpdqepfq", "dpdqfqep", "dqdpfqep", "dqdpfpfo", "fpepfofqgqenfmem", "fpepfqfo", "fqep", "fofpdpdq", "fofpdqdp"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-16",
        chapterId: "beginner-level4",
        order: 371,
        title: { zh: "手筋 · 16/22", en: "Tesuji · 16/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqdrdpdocnfp", white: "cocpbpbqcmdmfm" },
            correct: ["bn"],
            wrong: ["bmbn"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-17",
        chapterId: "beginner-level4",
        order: 372,
        title: { zh: "手筋 · 17/22", en: "Tesuji · 17/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcpcnfogohofrgrgqhqdkcmdl", white: "ereqfqeofnengnelhlek" },
            correct: ["epdpfpdodq"],
            wrong: ["fpep", "dpep"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-18",
        chapterId: "beginner-level4",
        order: 373,
        title: { zh: "手筋 · 18/22", en: "Tesuji · 18/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodqeqfqdngpfoipiriqhm", white: "crcqcpcocmdlgqgres" },
            correct: ["fsfrdserdr", "dsdrfserfr"],
            wrong: ["fsfrerds", "fsfrdrds", "dsdrerfs", "dsdrfrfs", "frfs", "drds", "erfs"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-19",
        chapterId: "beginner-level4",
        order: 374,
        title: { zh: "手筋 · 19/22", en: "Tesuji · 19/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcodpeperfqdodl", white: "brcqarcpdqdrfrgqgpgngr" },
            correct: ["dscses"],
            wrong: ["eseq", "eqes", "fseq"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-20",
        chapterId: "beginner-level4",
        order: 375,
        title: { zh: "手筋 · 20/22", en: "Tesuji · 20/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bndndodpeqepgqgn", white: "cqdqbocncmdlfldk" },
            correct: ["bpcpco"],
            wrong: ["cobp", "cpbp"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-21",
        chapterId: "beginner-level4",
        order: 376,
        title: { zh: "手筋 · 21/22", en: "Tesuji · 21/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpepfpgphndmbm", white: "boapbqcqergqhqip" },
            correct: ["frfqdr", "drdqfrfqeq"],
            wrong: ["fqfr", "dqdr", "eqdr"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-1-22",
        chapterId: "beginner-level4",
        order: 377,
        title: { zh: "手筋 · 22/22", en: "Tesuji · 22/22" },
        instruction: { zh: "黑先。切断白棋棋子。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbocpdpepfpfqcm", white: "brcrcqdqfrgqgpgniq" },
            correct: ["ereqgr"],
        },
    },
];

const bl4Cut2Levels: Level[] = [
    {
        id: "beginner-level4-bl4-cut-2-1",
        chapterId: "beginner-level4",
        order: 378,
        title: { zh: "手筋 · 1/14", en: "Tesuji · 1/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crereqeofngnhlbr", white: "gohogqhqiqcqcobpcndl" },
            correct: ["epdpfpdodq", "epdpfpdqdo", "epfpdpfqfo", "epfpdpfofq"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-2",
        chapterId: "beginner-level4",
        order: 379,
        title: { zh: "手筋 · 2/14", en: "Tesuji · 2/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epfofndmdobobmcmeqerfrdk", white: "cpbpemfmbrdrdqfqfpgognhmdphriphq" },
            correct: ["dncnencoeo"],
            wrong: ["dncneoen", "dncncoen", "codn", "eneo"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-3",
        chapterId: "beginner-level4",
        order: 380,
        title: { zh: "手筋 · 3/14", en: "Tesuji · 3/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcrbsdresgrgqgnfp", white: "arbrbqbpcpdqeqfqdocm" },
            correct: ["fsfrergsdscsas"],
            wrong: ["fsfrergscsds", "fsfrdser", "fsfrcser", "frfs", "erfs", "dser"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-4",
        chapterId: "beginner-level4",
        order: 381,
        title: { zh: "手筋 · 4/14", en: "Tesuji · 4/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcqcpepfpgpfngnio", white: "crdreqfqgqhqendnbnclbo" },
            correct: ["dpdodqeoco", "dpdodqcoeo", "dpdqdo"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-5",
        chapterId: "beginner-level4",
        order: 382,
        title: { zh: "手筋 · 5/14", en: "Tesuji · 5/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrdrcqcndkcm", white: "dodpdqerdseqhq" },
            correct: ["bpcpco"],
            wrong: ["bococpbp", "cobobpancpapaqbq", "cobobpancpapbqaq", "cobobpanapcp", "cobobpanbqcp", "cobobpanaqcp", "cpbpboco"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-6",
        chapterId: "beginner-level4",
        order: 383,
        title: { zh: "手筋 · 6/14", en: "Tesuji · 6/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqcpbobncmergrgqgo", white: "bsbrbqbpcodoeq" },
            correct: ["drdqdpdscsdrfr", "drdqcsdsdpdrfr"],
            wrong: ["drdqdpdsfrfq", "drdqcsdsfrep", "dpdr", "dqdr", "frdrfqfs", "frdrfsfq", "csdr"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-7",
        chapterId: "beginner-level4",
        order: 384,
        title: { zh: "手筋 · 7/14", en: "Tesuji · 7/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpepfpgpgmgnhohk", white: "brdreqfqgqhqbndnfndmflipck" },
            correct: ["dpdodqeoco"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-8",
        chapterId: "beginner-level4",
        order: 385,
        title: { zh: "手筋 · 8/14", en: "Tesuji · 8/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crbrbqbocncl", white: "bscsdrdqdpbpgq" },
            correct: ["apcpcq"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-9",
        chapterId: "beginner-level4",
        order: 386,
        title: { zh: "手筋 · 9/14", en: "Tesuji · 9/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdreqfqgrhqcpbnclcm", white: "hrgqfpepdpdqjqdnjpinel" },
            correct: ["frgpergqcr"],
            wrong: ["erfr", "gpfr"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-10",
        chapterId: "beginner-level4",
        order: 387,
        title: { zh: "手筋 · 10/14", en: "Tesuji · 10/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpfpgpiphq", white: "crdrerfrgrdnenfnbn" },
            correct: ["epeqeofqdq", "epeqeodqfq", "epeoeqfodo", "epeoeqdofo"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-11",
        chapterId: "beginner-level4",
        order: 388,
        title: { zh: "手筋 · 11/14", en: "Tesuji · 11/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqcpdpcsereofndncl", white: "crdrdqepfqfogohqhm" },
            correct: ["es"],
            wrong: ["dseq", "eqds"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-12",
        chapterId: "beginner-level4",
        order: 389,
        title: { zh: "手筋 · 12/14", en: "Tesuji · 12/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqfqiq", white: "coeofo" },
            correct: ["eqerfrepgqdqfp"],
            wrong: ["eqerfrepfpgqdqdr", "eqerfrepfpgqdpdr", "dqdrcreqdpbr", "dqdrcreqerdp", "dqdrereq"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-13",
        chapterId: "beginner-level4",
        order: 390,
        title: { zh: "手筋 · 13/14", en: "Tesuji · 13/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqaqapaocndoepeqfqfrencl", white: "bscrcqcpbpcodqeres" },
            correct: ["bnbman"],
            wrong: ["bnbmboan"],
        },
    },
    {
        id: "beginner-level4-bl4-cut-2-14",
        chapterId: "beginner-level4",
        order: 391,
        title: { zh: "手筋 · 14/14", en: "Tesuji · 14/14" },
        instruction: { zh: "白先。切断黑棋棋子。", en: "White to play. Cut the black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqcqbpfqgrgqgo", white: "apbococpdpfreo" },
            correct: ["drerdqdscs"],
            wrong: ["drereqfsdqdscscr", "drereqfsdqdscrcs", "drereqfsdsdq", "drereqfscrdq", "drerdsdq", "dqdrereq", "ereqdqdr", "eqerdrfsdqdscscr", "eqerdrfsdqdscrcs", "eqerdrfsdsdq", "eqerdqdr"],
        },
    },
];

const bl4CapturingRace1Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capturing-race-1-1",
        chapterId: "beginner-level4",
        order: 392,
        title: { zh: "对杀 · 1/23", en: "Capturing Race · 1/23" },
        instruction: { zh: "白棋棋块有四口气，黑棋棋块有五口气。但白棋可以通过先在A点投入来赢得对杀。用白棋赢得对杀。", en: "The white group has four liberties and the black group five. But White can win the capturing race by first throwing in at A. Win the capturing race with White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbnbrclcncrdndseoeperesfpfqgr", white: "aqbqcqdmdodpdqdreneqfmfogohphqhr" },
            marks: { A: "fr" },
            correct: ["frfsgqbpgpfrhscogs", "frfsgqbphscogp", "frfsgqbphscogp", "frfsgpbpgqfrhscogs", "frfsgpbphscogqfrgs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-2",
        chapterId: "beginner-level4",
        order: 393,
        title: { zh: "对杀 · 2/23", en: "Capturing Race · 2/23" },
        instruction: { zh: "向棋盘边缘延伸在日语中称为'下がり'。这是一种制造额外气的手筋。白棋可以在A点下がり来制造额外气。用白棋赢得对杀。", en: "Stretching towards the edge of the board is called 'sagari' in Japanese. It is a tesuji to create extra liberties. White can play sagari at A to create extra liberties. Win the capturing race with White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbobpcocqcrdndrfn", white: "bqbrcpdpeperfrgp" },
            marks: { A: "bs" },
            correct: ["bsardq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-3",
        chapterId: "beginner-level4",
        order: 394,
        title: { zh: "对杀 · 3/23", en: "Capturing Race · 3/23" },
        instruction: { zh: "白棋有两口气，黑棋有三口气。白棋可以通过在B点落子来阻止黑棋在A点打吃。黑棋必须先提掉这个白棋棋子，才能在A点打吃。这给了白棋时间来填掉黑棋三子棋块的气。用白棋赢得对杀。", en: "White has two liberties and Black three. White can prevent Black from playing atari at A by playing at B. Black has to capture this white stone first, before playing atari at A. This gives White time to fill the liberties of the black group of three stones. Win the capturing race with White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbobpbscmcncpdqdrds", white: "aqbqcocqcrcsdodpfpfr" },
            marks: { A: "ap", B: "bn" },
            correct: ["bnbmeqaner", "bnbmeqanes", "bnbmeraneq", "bnbmeranes", "bnbmesaneq", "bnbmesaner"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-4",
        chapterId: "beginner-level4",
        order: 395,
        title: { zh: "对杀 · 4/23", en: "Capturing Race · 4/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqeqgrgqgpfpgn", white: "bqfqfrepdpcpboen" },
            correct: ["er"],
            wrong: ["crer", "fser"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-5",
        chapterId: "beginner-level4",
        order: 396,
        title: { zh: "对杀 · 5/23", en: "Capturing Race · 5/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbocncqcrdrerdm", white: "brbqcpdpdqfrfqeohrgo" },
            correct: ["bs"],
            wrong: ["eqbs", "csbsasds", "esbs", "aqbs", "arbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-6",
        chapterId: "beginner-level4",
        order: 397,
        title: { zh: "对杀 · 6/23", en: "Capturing Race · 6/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "braraqbpcpbmcmdndoeldm", white: "bscrcqbqbncncodpeoeperfm" },
            correct: ["aoapcs"],
            wrong: ["csan", "anao", "apao", "amao"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-7",
        chapterId: "beginner-level4",
        order: 398,
        title: { zh: "对杀 · 7/23", en: "Capturing Race · 7/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "braqbpcpdpeqergq", white: "apaobocodoepfodqdr" },
            correct: ["bqcqcr"],
            wrong: ["cqbq", "crbq", "dscr", "cscr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-8",
        chapterId: "beginner-level4",
        order: 399,
        title: { zh: "对杀 · 8/23", en: "Capturing Race · 8/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hofnfodpepeqerescrcqhpgqhrhmhq", white: "frfqfpgpbrbqcpbodmdodseo" },
            correct: ["drcsfs", "drcsbs"],
            wrong: ["csfs", "dqdr", "fsdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-9",
        chapterId: "beginner-level4",
        order: 400,
        title: { zh: "对杀 · 9/23", en: "Capturing Race · 9/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbpcpcrcsdqeqerfrdocm", white: "bsbrbqcqdpepfqgrgphr" },
            correct: ["dsdrfs"],
            wrong: ["dsdresfs", "fsar", "drds", "esfs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-10",
        chapterId: "beginner-level4",
        order: 401,
        title: { zh: "对杀 · 10/23", en: "Capturing Race · 10/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmamcobrcrcqbpapdodndmcm", white: "dqbqcpdpdrboalblcldlelemeneofp" },
            correct: ["anaqbn", "anaqcn"],
            wrong: ["aoaq", "bnan", "cnbn", "aqar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-11",
        chapterId: "beginner-level4",
        order: 402,
        title: { zh: "对杀 · 11/23", en: "Capturing Race · 11/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdoeocncmdlflhmhngp", white: "drdpcobodnenfn" },
            correct: ["fpepeqdqfodpbp", "fpepeqdqfodpcq"],
            wrong: ["cqfo", "epfo", "foepfpeq", "foepeqfp", "foepdqfp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-12",
        chapterId: "beginner-level4",
        order: 403,
        title: { zh: "对杀 · 12/23", en: "Capturing Race · 12/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqbncncodpdqdrdscl", white: "brcrcqcpbodoeoepfrfqem" },
            correct: ["ar"],
            wrong: ["aobsapcsaqar", "aobsapcsarasaqan", "aobsaqcsaras", "aobsaqcsapar", "aobsarcs", "esar", "erar", "eqar", "aqao", "apao", "csar", "bsar", "ascs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-13",
        chapterId: "beginner-level4",
        order: 404,
        title: { zh: "对杀 · 13/23", en: "Capturing Race · 13/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocobpeseqepbscrcqdrerdncl", white: "bqdqdpcpdoeofpfqfrarfnbriq" },
            correct: ["csdsfs"],
            wrong: ["dscs", "fscs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-14",
        chapterId: "beginner-level4",
        order: 405,
        title: { zh: "对杀 · 14/23", en: "Capturing Race · 14/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cscobocldpdqdrfreogodk", white: "crcqcpcndndoemgm" },
            correct: ["bpbnbm"],
            wrong: ["bpbnaobm", "bnbp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-15",
        chapterId: "beginner-level4",
        order: 406,
        title: { zh: "对杀 · 15/23", en: "Capturing Race · 15/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqbpcpbmcmdndodl", white: "aoanbncncodpepcqbrbscr" },
            correct: ["apamas"],
            wrong: ["asap", "aqap"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-16",
        chapterId: "beginner-level4",
        order: 407,
        title: { zh: "对杀 · 16/23", en: "Capturing Race · 16/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hrhqhpgohnfqfpepdpdrcrcqgs", white: "brbqcpdoboeofogpgqgrfr" },
            correct: ["dqeqer", "erdqesdsbs"],
            wrong: ["eqdq", "fser", "erdqdsesfscs", "erdqcses", "erdqeqes"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-17",
        chapterId: "beginner-level4",
        order: 408,
        title: { zh: "对杀 · 17/23", en: "Capturing Race · 17/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqcrdpdocncl", white: "bpcpdqdrepfq" },
            correct: ["araqap", "araqcsbsds", "ap"],
            wrong: ["araqbrbs", "aqarapbs", "aqarcsap", "bsbo", "csbsaqdsarer", "csbsdsar", "csbsardsaqes", "brbsaraq", "brbsaqar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-18",
        chapterId: "beginner-level4",
        order: 409,
        title: { zh: "对杀 · 18/23", en: "Capturing Race · 18/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcqbqdpepfqfrfsfn", white: "drdqcpbpdococm" },
            correct: ["dscsbs"],
            wrong: ["dscsaqar", "csbs", "aqds"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-19",
        chapterId: "beginner-level4",
        order: 410,
        title: { zh: "对杀 · 19/23", en: "Capturing Race · 19/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpdqdreqfpgpgqgr", white: "cscrcqbpcoboepeofofqfr" },
            correct: ["eserfs"],
            wrong: ["eres", "dsfs", "fsesdsgs", "dofs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-20",
        chapterId: "beginner-level4",
        order: 411,
        title: { zh: "对杀 · 20/23", en: "Capturing Race · 20/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbpcrdreqfqgp", white: "brcqbocndpdofn" },
            correct: ["ar"],
            wrong: ["aqbs", "bsar", "cpar", "apar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-21",
        chapterId: "beginner-level4",
        order: 412,
        title: { zh: "对杀 · 21/23", en: "Capturing Race · 21/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdrerfrdndodpbmgq", white: "arbrcrdqeqepeoendmel" },
            correct: ["cpbpbococn"],
            wrong: ["cpbpbocobncs", "cpbpbococmcs", "cpbpcobo", "csds", "dsbo"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-22",
        chapterId: "beginner-level4",
        order: 413,
        title: { zh: "对杀 · 22/23", en: "Capturing Race · 22/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drereqfqfpdpcpbpbqgo", white: "brcrcqdqepeocobnemcm" },
            correct: ["ar"],
            wrong: ["aqcs", "boar", "doar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-1-23",
        chapterId: "beginner-level4",
        order: 414,
        title: { zh: "对杀 · 23/23", en: "Capturing Race · 23/23" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqbpcocncqdrerfreq", white: "brcrdqcpdpepfqgrgqgoir" },
            correct: ["bsdsfsaqbo"],
            wrong: ["bsdsbocs", "csds", "dsbs", "fscs"],
        },
    },
];

const bl4CapturingRace2Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capturing-race-2-1",
        chapterId: "beginner-level4",
        order: 415,
        title: { zh: "对杀 · 1/20", en: "Capturing Race · 1/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drercqcpcodnen", white: "dodpdqcndmemfmclgogqhm" },
            correct: ["eo"],
            wrong: ["eqeo"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-2",
        chapterId: "beginner-level4",
        order: 416,
        title: { zh: "对杀 · 2/20", en: "Capturing Race · 2/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbqcpcoboaodqeqerfphp", white: "bncndndodpcqcrbrdrcsfnelbl" },
            correct: ["asanaq", "asanap"],
            wrong: ["asanbpaq", "asanesap", "esas", "aqas", "apas", "bsas"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-3",
        chapterId: "beginner-level4",
        order: 417,
        title: { zh: "对杀 · 3/20", en: "Capturing Race · 3/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqcqcrdpdoanbmcncmen", white: "brcsdrdqepcpbpbobnfqfnfo" },
            correct: ["ar", "bsasap", "bsasao", "bsasco"],
            wrong: ["apar", "aoar", "coar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-4",
        chapterId: "beginner-level4",
        order: 418,
        title: { zh: "对杀 · 4/20", en: "Capturing Race · 4/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlgpfpepbscrcqcpcodqgqgrfrgsdn", white: "csdrereqdphphqhrhshndoeogofo" },
            correct: ["es"],
            wrong: ["dses"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-5",
        chapterId: "beginner-level4",
        order: 419,
        title: { zh: "对杀 · 5/20", en: "Capturing Race · 5/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dsdrcrcqbpbococmdl", white: "csbsbrbqapcpdpdofqeqfn" },
            correct: ["areraq"],
            wrong: ["arerasaq", "aqar", "aoer"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-6",
        chapterId: "beginner-level4",
        order: 420,
        title: { zh: "对杀 · 6/20", en: "Capturing Race · 6/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gsgrgqgpfoeodococpgodq", white: "crcqbpbodpepfpfqfrfscncl" },
            correct: ["erdres"],
            wrong: ["erdreqes", "drds", "eqdr", "eser"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-7",
        chapterId: "beginner-level4",
        order: 421,
        title: { zh: "对杀 · 7/20", en: "Capturing Race · 7/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "frgqbncododncsdsdrdqcpgp", white: "crcqbpbocncmbmdpepemfofmckbs" },
            correct: ["bqbraq"],
            wrong: ["bqbrapaq", "bqbraraq", "bqbraoaq", "bqbranaq", "brbq", "aobq", "apbq", "aqbq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-8",
        chapterId: "beginner-level4",
        order: 422,
        title: { zh: "对杀 · 8/20", en: "Capturing Race · 8/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocodpdnepfpfqerdrcr", white: "brcqdqeqcpbpapfrgrhq" },
            correct: ["arcsbq", "arcsaq"],
            wrong: ["arcsbsas", "aqbqbsarcses", "bqaq", "bsar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-9",
        chapterId: "beginner-level4",
        order: 423,
        title: { zh: "对杀 · 9/20", en: "Capturing Race · 9/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hqgqfqbrbqcpdpepgreresfscn", white: "gphpdsdrdqeqhshriqipeofnfp" },
            correct: ["irjrcs", "irjrcr", "irjrcq"],
            wrong: ["crgs", "cqgs", "csgs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-10",
        chapterId: "beginner-level4",
        order: 424,
        title: { zh: "对杀 · 10/20", en: "Capturing Race · 10/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fpfoelbsbrbqbpdnencocneqhphoek", white: "doeobnbmcrerfqgqcqcpfnglilckirgndpbo" },
            correct: ["drdscsdqepdrfr"],
            wrong: ["dqdr", "epdr", "csdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-11",
        chapterId: "beginner-level4",
        order: 425,
        title: { zh: "对杀 · 11/20", en: "Capturing Race · 11/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmfqfrfscrbraraqbpcodoeofpapbn", white: "erbqfofngpgqgriocqdpepirdr" },
            correct: ["dseseqcscp"],
            wrong: ["dsesdqeq", "dsescpgs", "esds", "eqgs", "dqeq", "cpgs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-12",
        chapterId: "beginner-level4",
        order: 426,
        title: { zh: "对杀 · 12/20", en: "Capturing Race · 12/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gmdpdqaqarbrcrdnenfqbofpfo", white: "cqbpbqbncodogqcmdrergpdlfrho" },
            correct: ["aocpcn"],
            wrong: ["aocpapcn", "apao", "cpao", "cnao"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-13",
        chapterId: "beginner-level4",
        order: 427,
        title: { zh: "对杀 · 13/20", en: "Capturing Race · 13/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crdrdqeqfrgrhq", white: "brcsdsesercqcpfqfpgocn" },
            correct: ["bsasfsbsbq"],
            wrong: ["fsbs", "bqdp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-14",
        chapterId: "beginner-level4",
        order: 428,
        title: { zh: "对杀 · 14/20", en: "Capturing Race · 14/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrbpcodoeofpfqfrfscm", white: "drerdpepfogogpgqgrirenfm" },
            correct: ["dsesdq"],
            wrong: ["dsescsgs", "dseseqdq", "dqeqesds", "dqeqdsgs", "dqeqcpgs", "dqeqcqgs", "esds", "eqdq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-15",
        chapterId: "beginner-level4",
        order: 429,
        title: { zh: "对杀 · 15/20", en: "Capturing Race · 15/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codoepcsdrerfrgrdqcqboaoeodl", white: "cpdpcrbreqfqgqhrhpbqaphnirbp" },
            correct: ["dsbsar"],
            wrong: ["dsbsgsar", "bsdsesar", "bsdsaras", "ards"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-16",
        chapterId: "beginner-level4",
        order: 430,
        title: { zh: "对杀 · 16/20", en: "Capturing Race · 16/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbrbscrcqcpdoeoepfqemhq", white: "bqbpcocndpdqdrdscscl" },
            correct: ["bo"],
            wrong: ["eraq", "eqaq", "esaq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-17",
        chapterId: "beginner-level4",
        order: 431,
        title: { zh: "对杀 · 17/20", en: "Capturing Race · 17/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crdrcqdpdoco", white: "ereqdqcpbpepeoendmcm" },
            correct: ["bobqbr"],
            wrong: ["bobqapbr", "bqbo"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-18",
        chapterId: "beginner-level4",
        order: 432,
        title: { zh: "对杀 · 18/20", en: "Capturing Race · 18/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dsdrdqcqepfpfqgqhrirhphm", white: "crbqbpcpdpeqerfrgreodncl" },
            correct: ["brbsgs", "brbses", "brbsfs"],
            wrong: ["brbscsar", "brbsares", "escs", "gscs", "csbr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-19",
        chapterId: "beginner-level4",
        order: 433,
        title: { zh: "对杀 · 19/20", en: "Capturing Race · 19/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrdpdqcocnbmeo", white: "bqcqcpapbodrerfqgo" },
            correct: ["araqan"],
            wrong: ["araqcsds", "araqbncs", "anar", "bsar", "bnar", "csar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-2-20",
        chapterId: "beginner-level4",
        order: 434,
        title: { zh: "对杀 · 20/20", en: "Capturing Race · 20/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dreqepdodndmcmbmfofrcpbp", white: "blcldlelbncncoamglbqcqdqdp" },
            correct: ["aoanbrarcraqbs"],
            wrong: ["aoanbrarcraqasbs", "aoanbraraqap", "aoanbrarapaq", "aoancrbrbsarcsap", "aoancrbraqar", "aoanaqar", "apao", "crap", "brap", "aqar", "boan"],
        },
    },
];

const bl4CapturingRace3Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capturing-race-3-1",
        chapterId: "beginner-level4",
        order: 435,
        title: { zh: "对杀 · 1/20", en: "Capturing Race · 1/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqcperfrfqgqhrepeocn", white: "cqdqeqdrirhqgpfpipgn" },
            correct: ["es"],
            wrong: ["hsds", "grgs", "fsgs", "gsdscsfs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-2",
        chapterId: "beginner-level4",
        order: 436,
        title: { zh: "对杀 · 2/20", en: "Capturing Race · 2/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmeodoaraqbqcqcpaobnclblalemekgn", white: "dqcrbranambmcmcnerfqhqcodp" },
            correct: ["bpapbo"],
            wrong: ["bobp", "apbpbodn"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-3",
        chapterId: "beginner-level4",
        order: 437,
        title: { zh: "对杀 · 3/20", en: "Capturing Race · 3/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcqdqdrdsepeodocobnfncl", white: "csbqbpcpdpeqerfpgqfoip" },
            correct: ["bscrarasbs"],
            wrong: ["bscresas", "crbs", "escrarbsaqbo", "arbsescraqbo", "arbsaqbo"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-4",
        chapterId: "beginner-level4",
        order: 438,
        title: { zh: "对杀 · 4/20", en: "Capturing Race · 4/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crereqdqfqgrfs", white: "bsbqcqdpdrepfpgqhrhpirbo" },
            correct: ["ds"],
            wrong: ["csds", "brds", "hsds"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-5",
        chapterId: "beginner-level4",
        order: 439,
        title: { zh: "对杀 · 5/20", en: "Capturing Race · 5/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdrdqeqfqfrgphpiriqfo", white: "brcscqgqgrfpepdpbqcodm" },
            correct: ["esfsds", "esfsgs"],
            wrong: ["gses", "fses", "dses"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-6",
        chapterId: "beginner-level4",
        order: 440,
        title: { zh: "对杀 · 6/20", en: "Capturing Race · 6/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbpcrdrdqfqeo", white: "brcqcpcocmdl" },
            correct: ["ar"],
            wrong: ["boar", "bsar", "aqbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-7",
        chapterId: "beginner-level4",
        order: 441,
        title: { zh: "对杀 · 7/20", en: "Capturing Race · 7/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gpclblanarbqbpcpdmdndoepelfp", white: "hqbmcmbrcrdqdpboeqfqcogqcn" },
            correct: ["aoaqcqambs", "aoaqbsamas", "aoaqbsamcq"],
            wrong: ["aoaqapam", "aoaqamal", "aoaqbsamapbn", "amao", "apaoamal", "apaocqaq", "aqao", "cqao"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-8",
        chapterId: "beginner-level4",
        order: 442,
        title: { zh: "对杀 · 8/20", en: "Capturing Race · 8/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqcqcrdpepfqgr", white: "brcpbpapdqdrdocofn" },
            correct: ["bscsaqasds", "bscsaqasbr", "bscsaqasbs", "bscsdsasaq", "bscsdsasbr", "bscsdsasbs"],
            wrong: ["csbs", "aqbs", "dsbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-9",
        chapterId: "beginner-level4",
        order: 443,
        title: { zh: "对杀 · 9/20", en: "Capturing Race · 9/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "iqckblbmbrcqcpdrerfrgrdodncneodkbkhq", white: "iobobnclcmelemcrdqfkgndpfqgpcogo" },
            correct: ["bqcsbpcrfo", "bqcsbpcrep", "bqcsbpcren", "bqcsbpcrdm"],
            wrong: ["bpbq", "fobp", "epbp", "enbp", "dmbp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-10",
        chapterId: "beginner-level4",
        order: 444,
        title: { zh: "对杀 · 10/20", en: "Capturing Race · 10/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpfmfnbrbqbpbocncmdoeoeqgqgrdk", white: "dnenfogogpcocpcqhqhriphmcr" },
            correct: ["epdpdqeperfqfr", "epdpdqeperfqgs"],
            wrong: ["dpep", "dqep"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-11",
        chapterId: "beginner-level4",
        order: 445,
        title: { zh: "对杀 · 11/20", en: "Capturing Race · 11/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arcrdrerfsgrbqbpcpeo", white: "brbscqdqeqfqgqfrho" },
            correct: ["cseshr"],
            wrong: ["esds", "dses", "hrcs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-12",
        chapterId: "beginner-level4",
        order: 446,
        title: { zh: "对杀 · 12/20", en: "Capturing Race · 12/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drercqbqaqcpboanbmfqgp", white: "arbrcrclcmcnbndodpdqfo" },
            correct: ["apbpcoaoblalak", "apbpbl"],
            wrong: ["apbpcoaocsds", "apbpcsds", "coap", "bpap", "csds", "blapamcs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-13",
        chapterId: "beginner-level4",
        order: 447,
        title: { zh: "对杀 · 13/20", en: "Capturing Race · 13/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrbqcsdsdrdqepdocobofpfnbm", white: "dpcpbpapcqcrereqgrhq" },
            correct: ["bsases"],
            wrong: ["esbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-14",
        chapterId: "beginner-level4",
        order: 448,
        title: { zh: "对杀 · 14/20", en: "Capturing Race · 14/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcsbqbpcpdpepfqfrfscm", white: "brcqdqeqeresfpgphrhqeo" },
            correct: ["bsargq", "bsargr", "bsargs"],
            wrong: ["ardr", "gqdr", "grdr", "gsdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-15",
        chapterId: "beginner-level4",
        order: 449,
        title: { zh: "对杀 · 15/20", en: "Capturing Race · 15/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdrdqeqfrbpcpcododm", white: "brbqcqfqgrepdpgphreo" },
            correct: ["bs"],
            wrong: ["csbsasds", "fsbs", "esbs", "arbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-16",
        chapterId: "beginner-level4",
        order: 450,
        title: { zh: "对杀 · 16/20", en: "Capturing Race · 16/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "araqbqbpcodoepdqdrerfrfpfn", white: "brbscrcqcpdpeqfqgqgriq" },
            correct: ["bobnds", "bobnfsdsgs"],
            wrong: ["bobnesds", "dsas", "fsas", "esas"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-17",
        chapterId: "beginner-level4",
        order: 451,
        title: { zh: "对杀 · 17/20", en: "Capturing Race · 17/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apcocnbnandpdqcrbrdrfp", white: "araqbqcqcpbmcmdndoembk" },
            correct: ["bobsam"],
            wrong: ["bobsaobp", "bobsbpas", "ambp", "aobo", "bpbo", "bsbp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-18",
        chapterId: "beginner-level4",
        order: 452,
        title: { zh: "对杀 · 18/20", en: "Capturing Race · 18/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbocqeqdqfpfofrgrencm", white: "brbqcpdpepfqgqhrhpir" },
            correct: ["erdrdsescs"],
            wrong: ["erdrdsescrcs", "erdrcres", "erdresds", "crer", "drer", "gsco"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-19",
        chapterId: "beginner-level4",
        order: 453,
        title: { zh: "对杀 · 19/20", en: "Capturing Race · 19/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrbqbocodpepeqerdrdncl", white: "cscrcqcpdoeofogpfqfrfsgm" },
            correct: ["dsesfp", "esdsfp"],
            wrong: ["dsesdqbp", "esdsdqbp", "bpds", "dqds", "fpes"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-3-20",
        chapterId: "beginner-level4",
        order: 454,
        title: { zh: "对杀 · 20/20", en: "Capturing Race · 20/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdreqaraqfqfrgrbpbocohqhphocmimiriqcq", white: "bsbrbqcpdqdpepfpgpgqerglfnhr" },
            correct: ["eshsds", "eshscs"],
            wrong: ["cses", "dses", "hses", "gses", "fses"],
        },
    },
];

const bl4CapturingRace4Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capturing-race-4-1",
        chapterId: "beginner-level4",
        order: 455,
        title: { zh: "对杀 · 1/20", en: "Capturing Race · 1/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqcpdpeqfqgreo", white: "aqbpbocqdqcrcsercncl" },
            correct: ["ds"],
            wrong: ["aras", "drds", "frar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-2",
        chapterId: "beginner-level4",
        order: 456,
        title: { zh: "对杀 · 2/20", en: "Capturing Race · 2/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fpfqeqbrcqcpbpapdpfrfognhphr", white: "dqerdrcrdsbsbocofndoemeoepbm" },
            correct: ["ar"],
            wrong: ["fsar", "aqar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-3",
        chapterId: "beginner-level4",
        order: 457,
        title: { zh: "对杀 · 3/20", en: "Capturing Race · 3/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "apbpcqcrdrercodnbnen", white: "csbrbqfrfseqcpdpfpdofo" },
            correct: ["bsasaq"],
            wrong: ["bsasaraq", "bsasdsdq", "dsbs", "aqbsards", "arbsaqds"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-4",
        chapterId: "beginner-level4",
        order: 458,
        title: { zh: "对杀 · 4/20", en: "Capturing Race · 4/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqcqdpepeqfrfsfqhp", white: "araqcrdrerdqbpcpcodoclds" },
            correct: ["bsapes"],
            wrong: ["esbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-5",
        chapterId: "beginner-level4",
        order: 459,
        title: { zh: "对杀 · 5/20", en: "Capturing Race · 5/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlbogocqeresdqcrfqfpeodocofogm", white: "cpdpepeqfrgrgqgphobsbqaqbphn" },
            correct: ["brards"],
            wrong: ["brarcsds", "csbr", "dsbr", "arbr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-6",
        chapterId: "beginner-level4",
        order: 460,
        title: { zh: "对杀 · 6/20", en: "Capturing Race · 6/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcpdpeofogphqfqgn", white: "bpcodogqdqeqepfpbodm" },
            correct: ["drfrer"],
            wrong: ["drfrgrcr", "drfrcrhp", "frcr", "grcr", "crfrdrhp", "erdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-7",
        chapterId: "beginner-level4",
        order: 461,
        title: { zh: "对杀 · 7/20", en: "Capturing Race · 7/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drdqdpcoboaoapfrgp", white: "aqbpcpcqcrdoeofmdmbm" },
            correct: ["brcsdsbsar", "brcsbs", "brcsbq", "brcsar"],
            wrong: ["csbrbsas", "arbr", "bqbr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-8",
        chapterId: "beginner-level4",
        order: 462,
        title: { zh: "对杀 · 8/20", en: "Capturing Race · 8/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpcqdoeofogq", white: "brbqapbococmdpep" },
            correct: ["drdqcrereqfqfp"],
            wrong: ["drdqcrerfpeq", "dqeq", "fpdq", "eqdq", "fqdq", "crdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-9",
        chapterId: "beginner-level4",
        order: 463,
        title: { zh: "对杀 · 9/20", en: "Capturing Race · 9/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqbpcpdpeqfqfr", white: "bscrcqdqerdocoboepfpgphripenbm" },
            correct: ["dscses"],
            wrong: ["dscsdres", "esds", "csds", "drds", "ards"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-10",
        chapterId: "beginner-level4",
        order: 464,
        title: { zh: "对杀 · 10/20", en: "Capturing Race · 10/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epdqeqfqgqbobngrfofncpdp", white: "bqbpcqdrergpfphqhpeodocodmekinir" },
            correct: ["dnenemcncm"],
            wrong: ["dnencnem", "endn", "cndn"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-11",
        chapterId: "beginner-level4",
        order: 465,
        title: { zh: "对杀 · 11/20", en: "Capturing Race · 11/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdpdodncmclblem", white: "brcrdqcpcocnbmdrepfp" },
            correct: ["bp"],
            wrong: ["bnbp", "bobp", "aqar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-12",
        chapterId: "beginner-level4",
        order: 466,
        title: { zh: "对杀 · 12/20", en: "Capturing Race · 12/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbrcrcqdpdocnbmcmenbk", white: "bscsbqdrdqepcpcobobneqgp" },
            correct: ["apbpan", "apbpaq"],
            wrong: ["apbpaoan", "aqap", "anaq", "aoaq", "bpap"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-13",
        chapterId: "beginner-level4",
        order: 467,
        title: { zh: "对杀 · 13/20", en: "Capturing Race · 13/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqbrcpdpdqeqfrfqhr", white: "bscrcqdreresbpbococm" },
            correct: ["csdsfs"],
            wrong: ["fsap", "ascsfsar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-14",
        chapterId: "beginner-level4",
        order: 468,
        title: { zh: "对杀 · 14/20", en: "Capturing Race · 14/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrcrdrdscqdpeococncmblem", white: "arbqbpbobncpdqeqeresfphp" },
            correct: ["aqapanambm"],
            wrong: ["aqapbman", "bmaq", "anaq", "apaq", "aoaq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-15",
        chapterId: "beginner-level4",
        order: 469,
        title: { zh: "对杀 · 15/20", en: "Capturing Race · 15/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brbqbncncpdpdqepfpgperen", white: "aqbpboeqfqfrdrcrcqgqhq" },
            correct: ["bsesco", "bsesao", "bsesap"],
            wrong: ["bsesarcsapao", "csesbsar", "csesarbsapao", "dsesbscs", "dsesarbsapao", "arbsapao", "apbsarao", "aobs", "cobs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-16",
        chapterId: "beginner-level4",
        order: 470,
        title: { zh: "对杀 · 16/20", en: "Capturing Race · 16/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bscscrdqdpdocnbnanergq", white: "brcqaqapaobococpdndmblcleofm" },
            correct: ["bqbpas"],
            wrong: ["asam", "aras"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-17",
        chapterId: "beginner-level4",
        order: 471,
        title: { zh: "对杀 · 17/20", en: "Capturing Race · 17/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "braobococpbnbmdqdrepfreqgo", white: "crcqbqbpamblclcmcndodpen" },
            correct: ["aqbsar"],
            wrong: ["aqbsapar", "csbsasaq", "csbsards", "arap", "apaq", "bsap"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-18",
        chapterId: "beginner-level4",
        order: 472,
        title: { zh: "对杀 · 18/20", en: "Capturing Race · 18/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dndococpbpdsereqepgqfq", white: "bqcrdrdqdpeoendmcmbnfmfpgp" },
            correct: ["brbsaraqcqasbrares"],
            wrong: ["brbsaraqcqasbrarapao", "brbsaraqcqasapao", "brbsaraqapas", "brbscqar", "brbsaqar", "cqbr", "csbs", "aqar", "apbsarbraqao", "apbsarbrcqao", "apbsaqbrarao"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-19",
        chapterId: "beginner-level4",
        order: 473,
        title: { zh: "对杀 · 19/20", en: "Capturing Race · 19/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "braraqcqcpbpdodncmbmbkel", white: "cobobnandpdqdrcrcsbsgq" },
            correct: ["ap"],
            wrong: ["aoap", "amap", "cnap"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-4-20",
        chapterId: "beginner-level4",
        order: 474,
        title: { zh: "对杀 · 20/20", en: "Capturing Race · 20/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqapbpcpdqeqepeofrfnhn", white: "arbqcqdpdocnbndrerfqgrgpiqdl" },
            correct: ["crbrcs"],
            wrong: ["brcr", "bsbr", "cscr"],
        },
    },
];

const bl4CapturingRace5Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capturing-race-5-1",
        chapterId: "beginner-level4",
        order: 475,
        title: { zh: "对杀 · 1/20", en: "Capturing Race · 1/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cocpcqbqgrfrerdrdsfscmanbn", white: "aqbrcrcsbpboaogqdqeqhrhqfqhnar" },
            correct: ["hs"],
            wrong: ["apas", "asap"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-2",
        chapterId: "beginner-level4",
        order: 476,
        title: { zh: "对杀 · 2/20", en: "Capturing Race · 2/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbqbpbodrdqdpdodncnfqhp", white: "cocpcqcrbrbncmbldmengm" },
            correct: ["ar"],
            wrong: ["csar", "aqar", "aoar", "apar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-3",
        chapterId: "beginner-level4",
        order: 477,
        title: { zh: "对杀 · 3/20", en: "Capturing Race · 3/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlbmcmdpdobpbodncqdqckelgl", white: "cncrdrbndmemeneoepeqaqbqbrgq" },
            correct: ["aoapco", "aoapcp"],
            wrong: ["aoapanam", "anam", "cocp", "cpco", "apan"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-4",
        chapterId: "beginner-level4",
        order: 478,
        title: { zh: "对杀 · 4/20", en: "Capturing Race · 4/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqfpeoaraqbqcrdrdqdpcpgrengn", white: "codoboepeqeresdsbrbpapcl" },
            correct: ["bs"],
            wrong: ["csbs", "asbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-5",
        chapterId: "beginner-level4",
        order: 479,
        title: { zh: "对杀 · 5/20", en: "Capturing Race · 5/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ephshrgqfqbsbrcrcqdphpeofnfo", white: "doemdqeqerfrgrgsarbqcnenbpcp" },
            correct: ["dsdres"],
            wrong: ["dsdraqes", "aqds", "drds"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-6",
        chapterId: "beginner-level4",
        order: 480,
        title: { zh: "对杀 · 6/20", en: "Capturing Race · 6/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqcqcrdpepfpfqfrhrgn", white: "bsaqapbpcpcododqeqerescl" },
            correct: ["csfsbr"],
            wrong: ["csfsdsbr", "csfsdrds", "csfsasdr", "brds", "drfs", "dscs", "asds"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-7",
        chapterId: "beginner-level4",
        order: 481,
        title: { zh: "对杀 · 7/20", en: "Capturing Race · 7/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrdrdpdocobobneqfqhper", white: "dqcqbqbpbmcndncleoepemgo" },
            correct: ["apanao", "apanam"],
            wrong: ["aoapaqan", "aqao", "anao"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-8",
        chapterId: "beginner-level4",
        order: 482,
        title: { zh: "对杀 · 8/20", en: "Capturing Race · 8/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdsdqeqgrgqgpfphn", white: "brfqfrepdpcqbpfoem" },
            correct: ["esdrbs"],
            wrong: ["esdrerfs", "esdrcsbs", "esdrfsgs", "erdr", "fses", "drer"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-9",
        chapterId: "beginner-level4",
        order: 483,
        title: { zh: "对杀 · 9/20", en: "Capturing Race · 9/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "drerfqgqgrgshpipjqjrhn", white: "brcrdqepfpgphqhrhscodm" },
            correct: ["fsiseq"],
            wrong: ["fsisfres", "eqfs", "frfs", "dsis"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-10",
        chapterId: "beginner-level4",
        order: 484,
        title: { zh: "对杀 · 10/20", en: "Capturing Race · 10/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dogrfrbrcqcpdqeqboeogpgohqfmes", white: "fpfqerdrcrcocnbnandpdlep" },
            correct: ["bqbpapaqaobqbs", "bqbpaoaqapbqbs"],
            wrong: ["bpbq", "csbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-11",
        chapterId: "beginner-level4",
        order: 485,
        title: { zh: "对杀 · 11/20", en: "Capturing Race · 11/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepdrfofngpgqgrho", white: "bocodoeofpfqerdl" },
            correct: ["dqfreq"],
            wrong: ["cpdq", "eqdq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-12",
        chapterId: "beginner-level4",
        order: 486,
        title: { zh: "对杀 · 12/20", en: "Capturing Race · 12/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqcpcobnclcmdrereqfpenelfn", white: "arbrcrcndndodpdq" },
            correct: ["boaoaqbpapbobm", "boaoapbpaq"],
            wrong: ["boaoaqbpbmap", "boaoapbpbmaq", "boaobpap", "aqbo", "bpbo", "apbo"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-13",
        chapterId: "beginner-level4",
        order: 487,
        title: { zh: "对杀 · 13/20", en: "Capturing Race · 13/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqdqdrcrbsfpgpgqeshrhqfn", white: "arbrcqdpepbqcofqerfrgrdm" },
            correct: ["dscsas"],
            wrong: ["asfs", "csds", "fsgs", "gshs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-14",
        chapterId: "beginner-level4",
        order: 488,
        title: { zh: "对杀 · 14/20", en: "Capturing Race · 14/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcqbpcpdpepfpfrgrgqdmbn", white: "bscrbqdqeqfqgpgohqhrio" },
            correct: ["eserdr"],
            wrong: ["eres", "dres", "dses", "csdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-15",
        chapterId: "beginner-level4",
        order: 489,
        title: { zh: "对杀 · 15/20", en: "Capturing Race · 15/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "araqbqbpcododpcreqerem", white: "cpcqdqdrdsbrbsepfpgqgrgn" },
            correct: ["boescsbnfs", "boescsbnfr", "boescsbnfq", "boescsbnaoanfs", "boescsbnaoanfr", "boescsbnaoanfq", "csesbo"],
            wrong: ["fses", "esfs", "fres", "fqes", "csesfsas", "csesfras", "csesfqas"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-16",
        chapterId: "beginner-level4",
        order: 490,
        title: { zh: "对杀 · 16/20", en: "Capturing Race · 16/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdocoarbrcrdndmbnanfohndq", white: "aqdrerbqcqcpcmbmbkdlfqhqbocn" },
            correct: ["ap"],
            wrong: ["aoap", "bpao", "amap", "csap"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-17",
        chapterId: "beginner-level4",
        order: 491,
        title: { zh: "对杀 · 17/20", en: "Capturing Race · 17/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqbqdpbocndrerfrgqdmdlhp", white: "arbrcrdoepdqeqengo" },
            correct: ["bpcpcoapaqbpbn"],
            wrong: ["bpcpcoapbnaq", "bpcpapco", "bpcpaqco", "cpbp", "cobp", "aqbp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-18",
        chapterId: "beginner-level4",
        order: 492,
        title: { zh: "对杀 · 18/20", en: "Capturing Race · 18/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbpdreqfpfognhnioipiqhl", white: "dqeofnfmgogpgqdm" },
            correct: ["erdpep"],
            wrong: ["erdpfqep", "epfqfrer", "epfqerfr", "epfqgrdp", "fqep"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-19",
        chapterId: "beginner-level4",
        order: 493,
        title: { zh: "对杀 · 19/20", en: "Capturing Race · 19/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bscrdrerfresfqbpcpepeodnclbn", white: "brbqcqdqeqfpgpgqgrgsgn" },
            correct: ["csdsfs"],
            wrong: ["fscs", "dscs", "arcs", "aqcs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-5-20",
        chapterId: "beginner-level4",
        order: 494,
        title: { zh: "对杀 · 20/20", en: "Capturing Race · 20/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbqcqdrdsesdpdocobodmbm", white: "aqapbpcpdqeqerfsfrfohpfm" },
            correct: ["br"],
            wrong: ["crbr", "arbr", "csar"],
        },
    },
];

const bl4CapturingRace6Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capturing-race-6-1",
        chapterId: "beginner-level4",
        order: 495,
        title: { zh: "对杀 · 1/20", en: "Capturing Race · 1/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqeqcpbp", white: "bqcqdpdobn" },
            correct: ["brcraqbsar", "brcrdraqcs"],
            wrong: ["brcraqbsdrar", "brcrdraqapbs", "brcrdraqarbs", "crbrbsdraqcsaras", "crbrbsdrarcsaqas", "crbrbsdrcsds", "crbraqbs", "crbrarbs", "crbrdrap", "aqbrarbs", "aqbrcrbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-2",
        chapterId: "beginner-level4",
        order: 496,
        title: { zh: "对杀 · 2/20", en: "Capturing Race · 2/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epeoencpbpapbmcmdmeleqdq", white: "aqbqcqdrerfqfpbnbodpdodncnfrhoiq" },
            correct: ["an"],
            wrong: ["aoan", "coao", "amao", "crao"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-3",
        chapterId: "beginner-level4",
        order: 497,
        title: { zh: "对杀 · 3/20", en: "Capturing Race · 3/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqeqepeogofndncngl", white: "crdrerfqgqenemdlcldodpboek" },
            correct: ["bpcobn"],
            wrong: ["bpcocpbn", "cocpcqbpbqbn", "cocpcqbpbnbq", "cocpbpcq", "cocpbnbp", "cpcobpbn", "cpcobnbpcqbq", "cqbpbnbq", "cqbpbqbnbmcm", "bncp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-4",
        chapterId: "beginner-level4",
        order: 498,
        title: { zh: "对杀 · 4/20", en: "Capturing Race · 4/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbrcqdpeqfqfrfsesdobqcm", white: "bscrdrdqepfpgqgrgpirfm" },
            correct: ["dsgsas"],
            wrong: ["dsgscser", "csds", "asds"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-5",
        chapterId: "beginner-level4",
        order: 499,
        title: { zh: "对杀 · 5/20", en: "Capturing Race · 5/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drdqdpdoerenfnfpgn", white: "brbqcpcodnbneoepeqfqhoiqiodm" },
            correct: ["gqfogogpfr"],
            wrong: ["gqfogogphpgr", "gqfogpgo", "gqfofrgo", "fogq", "frgq", "gpgq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-6",
        chapterId: "beginner-level4",
        order: 500,
        title: { zh: "对杀 · 6/20", en: "Capturing Race · 6/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocpcqcrdnenep", white: "brbqbobncndodpdqgrhqcl" },
            correct: ["dreqfqeofofper"],
            wrong: ["dreqfqeofofpgper", "dreqfqeofpfo", "dreqerfq", "dreqeofq", "eqdr", "eodr", "bpdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-7",
        chapterId: "beginner-level4",
        order: 501,
        title: { zh: "对杀 · 7/20", en: "Capturing Race · 7/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "apbpcpdqdreqfpfqdocmbmhpck", white: "aqbqcqcrdpepcocneofodmgo" },
            correct: ["an"],
            wrong: ["bobn", "bnbo", "aoan"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-8",
        chapterId: "beginner-level4",
        order: 502,
        title: { zh: "对杀 · 8/20", en: "Capturing Race · 8/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpeqeofogohphqhrhnhs", white: "brcqdqbpfpgpgqgrbocmer" },
            correct: ["frfsgsfqepfrdr", "frfsepfqgsfrdr"],
            wrong: ["frfsfqep", "gsfr", "epfr", "fqep"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-9",
        chapterId: "beginner-level4",
        order: 503,
        title: { zh: "对杀 · 9/20", en: "Capturing Race · 9/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "araqbpcpdpepfpfqdmbnerdr", white: "brbqbscqdqeqfrgrgqgpgo" },
            correct: ["csesap"],
            wrong: ["cres", "escr", "dsfs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-10",
        chapterId: "beginner-level4",
        order: 504,
        title: { zh: "对杀 · 10/20", en: "Capturing Race · 10/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hqasarbqcqdqbpesereoepdsfrgr", white: "aqaobocodpeqfqfpfobrcrdrgn" },
            correct: ["csbsar"],
            wrong: ["bscs", "apcp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-11",
        chapterId: "beginner-level4",
        order: 505,
        title: { zh: "对杀 · 11/20", en: "Capturing Race · 11/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqarbrcrdqeqfpeofm", white: "bqcqcpapdrerfrephq" },
            correct: ["cobodp"],
            wrong: ["dpco", "dsbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-12",
        chapterId: "beginner-level4",
        order: 506,
        title: { zh: "对杀 · 12/20", en: "Capturing Race · 12/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqbpboardpepeoen", white: "cpcocndodldkfldrdqeqfqfpgn" },
            correct: ["cm"],
            wrong: ["dncm", "dmcm", "bncm"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-13",
        chapterId: "beginner-level4",
        order: 507,
        title: { zh: "对杀 · 13/20", en: "Capturing Race · 13/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cscrdqdpcoboaoeo", white: "brcqcpbpdrerfqhq" },
            correct: ["bqaqap"],
            wrong: ["apbq", "bsds", "aqbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-14",
        chapterId: "beginner-level4",
        order: 508,
        title: { zh: "对杀 · 14/20", en: "Capturing Race · 14/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrcpdqdpdodnfrfqfmgohr", white: "bqcqbpcocncmdrercsdl" },
            correct: ["arbsbo"],
            wrong: ["bses", "boar", "esar", "eqar", "dsarbses", "asar", "aqbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-15",
        chapterId: "beginner-level4",
        order: 509,
        title: { zh: "对杀 · 15/20", en: "Capturing Race · 15/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrcpdpdqeqfqgrgpfmhr", white: "arcqbqbpcodofrerdrcm" },
            correct: ["bsaqbo"],
            wrong: ["bsaqfsas", "bsaqesas", "bsaqdsas", "csds", "dsbs", "fscs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-16",
        chapterId: "beginner-level4",
        order: 510,
        title: { zh: "对杀 · 16/20", en: "Capturing Race · 16/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crfrfqepdpcpbpbqarcmdn", white: "bsbrdsereqdqcqfpgphrhpgmeo" },
            correct: ["fsescsdrcs", "fsescsdrcr", "fsescsdraqgrcr", "fsescsdraqgrcs"],
            wrong: ["fsescsdraqgrasgs", "csgr", "drcs", "esfs", "aqgr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-17",
        chapterId: "beginner-level4",
        order: 511,
        title: { zh: "对杀 · 17/20", en: "Capturing Race · 17/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eofpgpaqarbrcreqdqdrfofmhm", white: "bqcqapcpdpepgqhqfqfrdmcmelerdsck" },
            correct: ["cobodo"],
            wrong: ["cobobndo", "dococnbn", "bododncn"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-18",
        chapterId: "beginner-level4",
        order: 512,
        title: { zh: "对杀 · 18/20", en: "Capturing Race · 18/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqcpdoeofp", white: "epdpdrgrgqhphncocnbpaodmgo" },
            correct: ["erdqcr", "erdqeq"],
            wrong: ["dqeq", "eqcr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-19",
        chapterId: "beginner-level4",
        order: 513,
        title: { zh: "对杀 · 19/20", en: "Capturing Race · 19/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqeqerepeofogpbqbpgqbocogripdp", white: "brcrdrcqcpdodnfrfsesgognfpfqclgl" },
            correct: ["dscsgsdsar"],
            wrong: ["gsds", "aren"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-6-20",
        chapterId: "beginner-level4",
        order: 514,
        title: { zh: "对杀 · 20/20", en: "Capturing Race · 20/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dsereqdpcpcqcocndm", white: "bsasaraqbqcrdrdqepfpdoeogqfm" },
            correct: ["esfrcs"],
            wrong: ["esfrbpfs", "bpfr", "cses", "grfr"],
        },
    },
];

const bl4CapturingRace7Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capturing-race-7-1",
        chapterId: "beginner-level4",
        order: 515,
        title: { zh: "对杀 · 1/20", en: "Capturing Race · 1/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcqdqcpbperfrhq", white: "drcreqdpepcoboaoen" },
            correct: ["bqaqap"],
            wrong: ["apbq", "aqcs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-2",
        chapterId: "beginner-level4",
        order: 516,
        title: { zh: "对杀 · 2/20", en: "Capturing Race · 2/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdqdpcobobnbmdrfqhp", white: "cqcpbpblcmcndoeoemck" },
            correct: ["apbqbraram", "apbqbrarao", "apbqbraran"],
            wrong: ["apbqbraraqbs", "apbqbrarbsao", "apbqamaq", "apbqaoaq", "apbqanaq", "apbqaqbr", "brapbqbs", "aobq", "ambq", "anbq", "aqbr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-3",
        chapterId: "beginner-level4",
        order: 517,
        title: { zh: "对杀 · 3/20", en: "Capturing Race · 3/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crdrbpcodnenfmfleldkckfqhq", white: "cpeofngnemdmcmhn" },
            correct: ["bodpdo"],
            wrong: ["bodpcndo", "docn", "cndo", "dpcn"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-4",
        chapterId: "beginner-level4",
        order: 518,
        title: { zh: "对杀 · 4/20", en: "Capturing Race · 4/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcqbpcpdpepfqerfrgrcn", white: "bqcrbsdrdqeqhrhqgqfpgpeogn" },
            correct: ["esdscs"],
            wrong: ["gsds", "dses", "csaq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-5",
        chapterId: "beginner-level4",
        order: 519,
        title: { zh: "对杀 · 5/20", en: "Capturing Race · 5/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpcpcqcrerfsgrbobncngqgpgncl", white: "bsbrbqbpcodoeoepfqfremfl" },
            correct: ["dreqcs"],
            wrong: ["dreqfpds", "dqdr", "csdr", "eqdr", "dsdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-6",
        chapterId: "beginner-level4",
        order: 520,
        title: { zh: "对杀 · 6/20", en: "Capturing Race · 6/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "asbsbqaqcrdrdqepfpgqhqdoeo", white: "cqcpcocndpeqerdsclem" },
            correct: ["brares", "esfrbr"],
            wrong: ["brarbpfr", "esfrbpfs", "esfrcsbr", "bpfrbraresfs", "bpfrbrarapfq", "bpfresbr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-7",
        chapterId: "beginner-level4",
        order: 521,
        title: { zh: "对杀 · 7/20", en: "Capturing Race · 7/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbrcrdrcpcodncmfqfofmfl", white: "cqdqdpbpbobnbmdm" },
            correct: ["en"],
            wrong: ["cndo", "docn", "clen"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-8",
        chapterId: "beginner-level4",
        order: 522,
        title: { zh: "对杀 · 8/20", en: "Capturing Race · 8/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqcsdsdreqfqgrgo", white: "cqcrdqerbpcpbn" },
            correct: ["bsasesbsaq"],
            wrong: ["esbs", "aqfr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-9",
        chapterId: "beginner-level4",
        order: 523,
        title: { zh: "对杀 · 9/20", en: "Capturing Race · 9/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbqcpcodqeqfresdm", white: "cqcrdpepfpfqgqgrirgm" },
            correct: ["dsergs"],
            wrong: ["dserbsgs", "erdr", "drer", "csdr", "bsdr", "gsdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-10",
        chapterId: "beginner-level4",
        order: 524,
        title: { zh: "对杀 · 10/20", en: "Capturing Race · 10/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "csbsbrbqcpdpepfpfqgn", white: "crcqdqerdsbpcodoeobnem" },
            correct: ["eqfraq", "eqfrar"],
            wrong: ["eqfrfsgs", "freq", "aqeq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-11",
        chapterId: "beginner-level4",
        order: 525,
        title: { zh: "对杀 · 11/20", en: "Capturing Race · 11/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdpepcocnbnangq", white: "cpbpcmbmbkdmdndo" },
            correct: ["ao"],
            wrong: ["boap", "amap"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-12",
        chapterId: "beginner-level4",
        order: 526,
        title: { zh: "对杀 · 12/20", en: "Capturing Race · 12/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncnendoepdqcqcrbrer", white: "araqbqcpdpcoboaoeqfqdsgp" },
            correct: ["bsesfrdrfs"],
            wrong: ["bsesdrcs", "bsescsdr", "dresbscs", "csdrfrbs", "frcs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-13",
        chapterId: "beginner-level4",
        order: 527,
        title: { zh: "对杀 · 13/20", en: "Capturing Race · 13/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqbpcpdoeoepeqeresgoip", white: "aobocodpdqdrdscsbrdncmcken" },
            correct: ["aqapcq"],
            wrong: ["cqbs", "apbs", "asbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-14",
        chapterId: "beginner-level4",
        order: 528,
        title: { zh: "对杀 · 14/20", en: "Capturing Race · 14/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqdocoboendmcmblfnfl", white: "brdqdpepeoanbncndngq" },
            correct: ["bpcpcqapao", "bpcpap"],
            wrong: ["bpcpcqaparam", "aobp", "cpbp", "apbpaqao", "apbpaoaq", "apbpcqam", "apbpcpam"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-15",
        chapterId: "beginner-level4",
        order: 529,
        title: { zh: "对杀 · 15/20", en: "Capturing Race · 15/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmdnfsfrfqeqdpcpbpaqbrcr", white: "flfneoepgpgqgrgsdsdrcqdqbq" },
            correct: ["arascsapfp", "arascsaper", "arascsapes"],
            wrong: ["arascsapbsar", "arasercs", "arasfpcs", "arasescs", "csar", "fpcs", "ercs", "escs", "bsar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-16",
        chapterId: "beginner-level4",
        order: 530,
        title: { zh: "对杀 · 16/20", en: "Capturing Race · 16/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqarbpcocndpepeqeresdlbq", white: "brbscsdsdrdqcqcpeofogpgqfrgmdo" },
            correct: ["bo"],
            wrong: ["fqas", "fpas", "fsas"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-17",
        chapterId: "beginner-level4",
        order: 531,
        title: { zh: "对杀 · 17/20", en: "Capturing Race · 17/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqdrcpcobobndnenfrfqfoho", white: "crcqdpepdobmcmcnel" },
            correct: ["anbqaobpbr", "anbqbr", "aobqanbpbr"],
            wrong: ["anbqaobpapbr", "bpbq", "bqfp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-18",
        chapterId: "beginner-level4",
        order: 532,
        title: { zh: "对杀 · 18/20", en: "Capturing Race · 18/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqcrdrcodpepfqgqhqdm", white: "cpbpbodqeqeresfpgpgnhm" },
            correct: ["dncndo"],
            wrong: ["dncneodocmen", "doeo", "eodo", "aqfr", "dsfr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-19",
        chapterId: "beginner-level4",
        order: 533,
        title: { zh: "对杀 · 19/20", en: "Capturing Race · 19/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcpdpeqfqfrgrbncl", white: "dqhrgqhpfpepdogmir" },
            correct: ["dr"],
            wrong: ["erdr", "gsdr", "fsdr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-7-20",
        chapterId: "beginner-level4",
        order: 534,
        title: { zh: "对杀 · 20/20", en: "Capturing Race · 20/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbqcrdrdqeqfqgphphqhrfogm", white: "gqgrfrfpepdpcpcqbpbnbrar" },
            correct: ["es"],
            wrong: ["eres", "dsesergs", "dsesfscs", "cseserds", "csesasgs", "csesfsds", "aqgs"],
        },
    },
];

const bl4CapturingRace8Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capturing-race-8-1",
        chapterId: "beginner-level4",
        order: 535,
        title: { zh: "对杀 · 1/20", en: "Capturing Race · 1/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqdrepeogqhqgnio", white: "brbpcpdpeqergrcm" },
            correct: ["frfqesfsdscrfp"],
            wrong: ["frfqesfsfpds", "frfqfpesdsfs", "frfqfpeshrcr", "frfqfpesfsgs", "frfqfses", "fqfr", "esfr", "dsfr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-2",
        chapterId: "beginner-level4",
        order: 536,
        title: { zh: "对杀 · 2/20", en: "Capturing Race · 2/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrcqbmcmcnbkdodpem", white: "bqbpcpcobndrdqeqephq" },
            correct: ["araoaqapam"],
            wrong: ["araoaqapcsds", "araoamaqancs", "aoar", "anar", "aqar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-3",
        chapterId: "beginner-level4",
        order: 537,
        title: { zh: "对杀 · 3/20", en: "Capturing Race · 3/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqbncndoeofqer", white: "bqbocodndmclblfm" },
            correct: ["bpcpaoapanbrdpbpbs", "bpcpaoapanbrbs"],
            wrong: ["bpcpaoapanbrdpbpcscm", "bpcpaoapdpan", "bpcpaoapbran", "bpcpapao", "bpcpdpap", "cpbp", "aobp", "anbp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-4",
        chapterId: "beginner-level4",
        order: 538,
        title: { zh: "对杀 · 4/20", en: "Capturing Race · 4/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqdpeofogogpfqfrgrcpcn", white: "fpepeqdqdrdsesgqhphqhrioim" },
            correct: ["fs"],
            wrong: ["ergs", "gshs", "csgs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-5",
        chapterId: "beginner-level4",
        order: 539,
        title: { zh: "对杀 · 5/20", en: "Capturing Race · 5/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fsaqarbrcrbpcodoeofpfqfrcm", white: "irfogpgqgrerdrcqbqdpephnfn" },
            correct: ["dseseqcscp"],
            wrong: ["dseseqcsdqgs", "dsescsgs", "dsescpgs", "dsesdqeq", "dqeqcpgs", "dqeqdses", "dqeqesds", "esdscpeq", "eqdq", "cpgs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-6",
        chapterId: "beginner-level4",
        order: 540,
        title: { zh: "对杀 · 6/20", en: "Capturing Race · 6/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqcpdpepfqfrfnfl", white: "bpbocncmcqdqcrerfsgrgqgphnckir" },
            correct: ["eqesdr"],
            wrong: ["eqescsdr", "eqesdsdr", "cseq", "dses", "dreq", "eseq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-7",
        chapterId: "beginner-level4",
        order: 541,
        title: { zh: "对杀 · 7/20", en: "Capturing Race · 7/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncncocpdqdrbrdscsfqfpao", white: "bqbsaqcrcqbpbodndmclblfmdpdo" },
            correct: ["arasarbran", "arasan", "arasbraran"],
            wrong: ["asbm", "anar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-8",
        chapterId: "beginner-level4",
        order: 542,
        title: { zh: "对杀 · 8/20", en: "Capturing Race · 8/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqbpcodoepeqeresbncl", white: "bsbrcqcpdpdrdseofpfqgrengn" },
            correct: ["crcsdq"],
            wrong: ["crcsarfr", "dqcr", "cscr", "arfr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-9",
        chapterId: "beginner-level4",
        order: 543,
        title: { zh: "对杀 · 9/20", en: "Capturing Race · 9/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bscscrcqdpcobnbldodm", white: "dqdrdsfqbobpcpaqhp" },
            correct: ["arbqao"],
            wrong: ["arbqanbr", "aobr", "bqaraoap", "bqarapaoanap", "anbq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-10",
        chapterId: "beginner-level4",
        order: 544,
        title: { zh: "对杀 · 10/20", en: "Capturing Race · 10/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcsdqeqerfrcpbpcodoem", white: "bsbrbqcqgrgqfqfpepdpgnir" },
            correct: ["dsfsaq", "dsfsar"],
            wrong: ["aqds", "fsds"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-11",
        chapterId: "beginner-level4",
        order: 545,
        title: { zh: "对杀 · 11/20", en: "Capturing Race · 11/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqcpdpepfqfrfsbo", white: "cqdqeqcrfpfogqgrgsho" },
            correct: ["ds"],
            wrong: ["erdr", "esds", "cser", "drer"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-12",
        chapterId: "beginner-level4",
        order: 546,
        title: { zh: "对杀 · 12/20", en: "Capturing Race · 12/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbpcpdrdqeqfqfphq", white: "arbqcqcrcsdpepfoeobndn" },
            correct: ["apasaq", "apasbs", "apasbr"],
            wrong: ["dsasapbo", "dsasbrbo"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-13",
        chapterId: "beginner-level4",
        order: 547,
        title: { zh: "对杀 · 13/20", en: "Capturing Race · 13/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bsbrbqcpdpepfqgqhrgshpen", white: "bpbocogrfreqdqcqcrcsdsescm" },
            correct: ["erdrhs"],
            wrong: ["draq", "hsaqfsar", "hsaqerar", "hsaqdrar", "aqap"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-14",
        chapterId: "beginner-level4",
        order: 548,
        title: { zh: "对杀 · 14/20", en: "Capturing Race · 14/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcrdqdpfqfngp", white: "erdrcqbqdocodm" },
            correct: ["arcscpbpbo", "cpbparcsbo"],
            wrong: ["arcsfrbs", "arcseqbs", "arcsdsbsasaq", "frar", "eqar", "csar", "bsar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-15",
        chapterId: "beginner-level4",
        order: 549,
        title: { zh: "对杀 · 15/20", en: "Capturing Race · 15/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqcpdpepfrfqhphodnenhm", white: "bscrbqbpbodqeqerfpgphqhr" },
            correct: ["fsdrgq", "fsdrcsargq"],
            wrong: ["fsdresgq", "fsdrcsaresgq", "fsdrdsgq", "gqfs", "esdr", "drds"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-16",
        chapterId: "beginner-level4",
        order: 550,
        title: { zh: "对杀 · 16/20", en: "Capturing Race · 16/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "brcqcpcocnclfn", white: "bqbpcrdqdpgqdr" },
            correct: ["ar"],
            wrong: ["bsar", "boar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-17",
        chapterId: "beginner-level4",
        order: 551,
        title: { zh: "对杀 · 17/20", en: "Capturing Race · 17/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqarbrcrcqbmcmdndodpfn", white: "bqbpcpcobnamblcldqdrfqgp" },
            correct: ["cn"],
            wrong: ["apcn", "aoan"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-18",
        chapterId: "beginner-level4",
        order: 552,
        title: { zh: "对杀 · 18/20", en: "Capturing Race · 18/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crcqcpepeofqcn", white: "eqdqfpgphqgn" },
            correct: ["fr"],
            wrong: ["erfr", "drfr", "dpfr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-19",
        chapterId: "beginner-level4",
        order: 553,
        title: { zh: "对杀 · 19/20", en: "Capturing Race · 19/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqbpcpboblcldmdoeoemdk", white: "arbrcqcocncmbmamdpepfpcrhq" },
            correct: ["ao"],
            wrong: ["anbn", "bnan", "alao", "dnao"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-8-20",
        chapterId: "beginner-level4",
        order: 554,
        title: { zh: "对杀 · 20/20", en: "Capturing Race · 20/20" },
        instruction: { zh: "黑先。赢得对杀。", en: "Black to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "arbqcqcrdpeqepfqfr", white: "brcsdrerdqfsgrgqgpcpcocnfn" },
            correct: ["esdsbs"],
            wrong: ["bses", "dses"],
        },
    },
];

const bl4CapturingRace9Levels: Level[] = [
    {
        id: "beginner-level4-bl4-capturing-race-9-1",
        chapterId: "beginner-level4",
        order: 555,
        title: { zh: "对杀 · 1/20", en: "Capturing Race · 1/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcrdrerbpbocndnfncl", white: "brbqfrfqfpdqdpcpiq" },
            correct: ["bs"],
            wrong: ["csaq", "eqbs", "esbs", "aqbs", "arbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-2",
        chapterId: "beginner-level4",
        order: 556,
        title: { zh: "对杀 · 2/20", en: "Capturing Race · 2/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "csdrdqcpbpbobnepfres", white: "bqcqcrbmcncododpcl" },
            correct: ["arbsap", "arbsan"],
            wrong: ["aqarbrbs", "aqarbsap", "anaq", "bsaq", "apbr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-3",
        chapterId: "beginner-level4",
        order: 557,
        title: { zh: "对杀 · 3/20", en: "Capturing Race · 3/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrdrbodpdodneqfqerfp", white: "dqcqbqbpdmeneoepelcl" },
            correct: ["cocnbn", "bncnco"],
            wrong: ["cocncmbm", "cocncpap", "cncoaoan", "bncncmbm"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-4",
        chapterId: "beginner-level4",
        order: 558,
        title: { zh: "对杀 · 4/20", en: "Capturing Race · 4/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dreresdpepfogpgqgrirfnhn", white: "bobpbrcrdsdoeofpfqfrfscm" },
            correct: ["dq"],
            wrong: ["csgs", "eqdq", "cpgs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-5",
        chapterId: "beginner-level4",
        order: 559,
        title: { zh: "对杀 · 5/20", en: "Capturing Race · 5/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrcqdqbpapepfpfqgrgqfnir", white: "bqaobocpdpeqerdrfrcn" },
            correct: ["ar"],
            wrong: ["aqds", "csbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-6",
        chapterId: "beginner-level4",
        order: 560,
        title: { zh: "对杀 · 6/20", en: "Capturing Race · 6/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcsdsdrdqbocodoeoepdl", white: "crcqdpcpbpeqerfpgqgn" },
            correct: ["bsases"],
            wrong: ["bsasbqaq", "bsasapaq", "bsasaqbq", "esbs", "aqbq", "bqaq", "apaq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-7",
        chapterId: "beginner-level4",
        order: 561,
        title: { zh: "对杀 · 7/20", en: "Capturing Race · 7/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcpbodrerfqgqdoengofnfo", white: "crcocnbmdmdqdpepemfm" },
            correct: ["bpbqbraparaqan"],
            wrong: ["bpbqbraparaqbncs", "bpbqbrapbnar", "bpbqbrapanar", "bpbqaqbr", "bpbqapbr", "bpbqbnbr", "bqbp", "brbp"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-8",
        chapterId: "beginner-level4",
        order: 562,
        title: { zh: "对杀 · 8/20", en: "Capturing Race · 8/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndndsdrdqdpeofpbmbqbpbo", white: "cscrcqcpcodofngogpfqfrfsgqen" },
            correct: ["epeqfo"],
            wrong: ["epeqerbr", "epeqesbr", "foep", "eqbr", "erbr", "esbr", "brar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-9",
        chapterId: "beginner-level4",
        order: 563,
        title: { zh: "对杀 · 9/20", en: "Capturing Race · 9/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crbrbqcpcodofrfqfpepgrcm", white: "cqdpdqdrereofogpgqhrhqgn" },
            correct: ["escsgs", "escsfs"],
            wrong: ["dsfs", "gsfs", "fsesdsgs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-10",
        chapterId: "beginner-level4",
        order: 564,
        title: { zh: "对杀 · 10/20", en: "Capturing Race · 10/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "csdrdqeqfrcpbqbpdodn", white: "arbrcrcqfqgrgphrepdp" },
            correct: ["esdsbs", "esdsfs"],
            wrong: ["bses", "dses", "fses", "eres"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-11",
        chapterId: "beginner-level4",
        order: 565,
        title: { zh: "对杀 · 11/20", en: "Capturing Race · 11/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqcrcsdpeocoboeqerdles", white: "bsbrbqbpcpdrepfpfqfrhr" },
            correct: ["dqdsdqdrfs"],
            wrong: ["dqdsfsdq", "fsdq", "dsdq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-12",
        chapterId: "beginner-level4",
        order: 566,
        title: { zh: "对杀 · 12/20", en: "Capturing Race · 12/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbqbpboaocpdqeqerepfo", white: "bncncododpcqbrcrdrem" },
            correct: ["aq"],
            wrong: ["anaqbsds", "apaq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-13",
        chapterId: "beginner-level4",
        order: 567,
        title: { zh: "对杀 · 13/20", en: "Capturing Race · 13/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcqdrbpbocncl", white: "cpdpbqaqeqeresdsfo" },
            correct: ["crcsdq"],
            wrong: ["crcsarap", "dqcr", "csar", "arap", "bsar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-14",
        chapterId: "beginner-level4",
        order: 568,
        title: { zh: "对杀 · 14/20", en: "Capturing Race · 14/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsbrbqcpdpepfqgr", white: "bpbocncqcrer" },
            correct: ["dr"],
            wrong: ["csdrdqeqdsfs", "csdrdsdqesfr", "dqcseqfrdsfs", "aqdrdqcsdseq", "aqdrdscsdqeq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-15",
        chapterId: "beginner-level4",
        order: 569,
        title: { zh: "对杀 · 15/20", en: "Capturing Race · 15/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpcododqeqdrdsfrgqgsdm", white: "cscrcqdpepergrhrhqgpgn" },
            correct: ["esfsfq"],
            wrong: ["esfshsbq", "esfsbqaq", "esfsesfp", "fqes", "fses", "bqaq"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-16",
        chapterId: "beginner-level4",
        order: 570,
        title: { zh: "对杀 · 16/20", en: "Capturing Race · 16/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqcrdpdocnfn", white: "drdqeqepcpbpapgq" },
            correct: ["ar"],
            wrong: ["csbs", "brbs"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-17",
        chapterId: "beginner-level4",
        order: 571,
        title: { zh: "对杀 · 17/20", en: "Capturing Race · 17/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "asarbqbpcpcrcsdodncmbmel", white: "cqdqdpcoboapeoergq" },
            correct: ["brbsao"],
            wrong: ["aobr", "bsbr", "drbr", "dsbr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-18",
        chapterId: "beginner-level4",
        order: 572,
        title: { zh: "对杀 · 18/20", en: "Capturing Race · 18/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gngmdoeofoepeqfqdrgrgscncm", white: "bqbodpdqdnenfnfsesgqgpgofpipiqco" },
            correct: ["crfrhrerhsdscs", "crfrhrerhsdsfs", "crfrhrerhsdses"],
            wrong: ["crfrhrerdscs", "crfrdsdm", "crfrerds", "crfrhshr", "frer", "erfr", "dsfr"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-19",
        chapterId: "beginner-level4",
        order: 573,
        title: { zh: "对杀 · 19/20", en: "Capturing Race · 19/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brcrdrdqdpdocnbnangq", white: "bqcqcpcobodnendlblfo" },
            correct: ["ap"],
            wrong: ["amap", "bmap", "cmap", "aoap", "aqar"],
        },
    },
    {
        id: "beginner-level4-bl4-capturing-race-9-20",
        chapterId: "beginner-level4",
        order: 574,
        title: { zh: "对杀 · 20/20", en: "Capturing Race · 20/20" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdpcpbpaqbnereqgriqhohq", white: "bqbrcrdrdsdqepfpgpen" },
            correct: ["frfqgqfses"],
            wrong: ["frfqgqfshres", "frfqesgq", "arbs", "esfr", "fqfr"],
        },
    },
];

export const LEVELS: Level[] = [
    ...bl4Opening1Levels,
    ...bl4Opening2Levels,
    ...bl4Opening3Levels,
    ...bl4Opening4Levels,
    ...bl4Opening5Levels,
    ...bl4Opening6Levels,
    ...bl4Opening7Levels,
    ...bl4Opening8Levels,
    ...bl4Opening9Levels,
    ...bl4Joseki1Levels,
    ...bl4Joseki2Levels,
    ...bl4Skills1Levels,
    ...bl4Skills2Levels,
    ...bl4Skills3Levels,
    ...bl4Skills4Levels,
    ...bl4Capture1Levels,
    ...bl4Capture2Levels,
    ...bl4Capture3Levels,
    ...bl4Capture4Levels,
    ...bl4Connect1Levels,
    ...bl4Connect2Levels,
    ...bl4Connect3Levels,
    ...bl4Connect4Levels,
    ...bl4Cut1Levels,
    ...bl4Cut2Levels,
    ...bl4CapturingRace1Levels,
    ...bl4CapturingRace2Levels,
    ...bl4CapturingRace3Levels,
    ...bl4CapturingRace4Levels,
    ...bl4CapturingRace5Levels,
    ...bl4CapturingRace6Levels,
    ...bl4CapturingRace7Levels,
    ...bl4CapturingRace8Levels,
    ...bl4CapturingRace9Levels,
];
